// Lesson 2 - Oral Health Education
// Topic 1: Soft and Hard Deposits
// Topic 2: Toothbrushing
// Topic 3: Interdental & Supplemental Self-Care Aids
// Topic 4: Dentifrices
// Topic 4: Mouthrinse Comparison
// Topic 4: Sensodyne ProNamel Product Table
// Topic 5: Denture
// Topic 6: A String around Your Finger
// Topic 7: Toothbrushing
// Topic 8: Rinsing Recommendations

export const questions = {
  "1. Soft and Hard Deposits": [
    {
      id: 40001,
      question: "What is the primary purpose of oral hygiene assessment?",
      options: [
      "To determine only the amount of hard deposits",
      "To determine hard and soft deposits, oral hygiene status, self-care effectiveness, and motivation",
      "To evaluate only patient motivation levels",
      "To assess only the presence of tooth stains"
      ],
      correct: 1
    },
    {
      id: 40002,
      question: "Which assessment tool is specifically used to make oral biofilm clinically visible?",
      options: [
      "Periodontal explorer",
      "Compressed air",
      "Disclosing solution",
      "Mouth mirror"
      ],
      correct: 2
    },
    {
      id: 40003,
      question: "What are the three different types of disclosing agents mentioned in the document?",
      options: [
      "Powder, spray, and foam",
      "Liquid, gel, and tablet",
      "Paste, rinse, and swab",
      "Solution, powder, and cream"
      ],
      correct: 1
    },
    {
      id: 40004,
      question: "According to the document, soft and hard dental deposits are assessed according to location. Which locations are specified?",
      options: [
      "Anterior and posterior only",
      "Buccal and lingual only",
      "Supragingival and subgingival",
      "Coronal and apical only"
      ],
      correct: 2
    },
    {
      id: 40005,
      question: "When assessing the extent and distribution of deposits, which classification indicates the most severe condition?",
      options: [
      "Slight",
      "Localized",
      "Moderate",
      "Heavy"
      ],
      correct: 3
    },
    {
      id: 40006,
      question: "Dental plaque is defined as a dense, nonmineralized mass of bacterial colonies in what type of matrix?",
      options: [
      "Crystalline, rigid, water-based matrix",
      "Loose, detachable, air-exposed matrix",
      "Gel-like, intermicrobial, enclosed matrix",
      "Hard, mineralized, protective matrix"
      ],
      correct: 2
    },
    {
      id: 40007,
      question: "What property does dental plaque exhibit according to the document?",
      options: [
      "Easily removable and water-soluble properties",
      "Self-sustaining and protective properties",
      "Temporary and unstable properties",
      "Crystalline and rigid properties"
      ],
      correct: 1
    },
    {
      id: 40008,
      question: "What is the first stage of biofilm formation?",
      options: [
      "Rapid growth bacterial colonization",
      "Lag phase",
      "Initial adherence with pellicle deposition",
      "Steady state and detachment"
      ],
      correct: 2
    },
    {
      id: 40009,
      question: "During which stage of biofilm formation do planktonic bacteria become sessile and growth lags?",
      options: [
      "Initial adherence stage",
      "Lag phase",
      "Rapid growth stage",
      "Steady state stage"
      ],
      correct: 1
    },
    {
      id: 40010,
      question: "In the rapid growth bacterial colonization stage, what begins to form?",
      options: [
      "Pellicle layer only",
      "Water-insoluble slime matrix and microcolonies",
      "Calculus deposits",
      "Materia alba collections"
      ],
      correct: 1
    },
    {
      id: 40011,
      question: "What occurs during the steady state and detachment stage of biofilm formation?",
      options: [
      "Pellicle provides attachment sites",
      "Bacteria stop growing completely",
      "The intermicrobial matrix connects bacterial colonies and species live symbiotically",
      "All bacteria detach from the surface"
      ],
      correct: 2
    },
    {
      id: 40012,
      question: "What is the most effective way to clinically assess the presence of oral biofilm?",
      options: [
      "Visual observation only",
      "Using compressed air only",
      "Passing a dental explorer over the tooth surface",
      "Taking radiographs"
      ],
      correct: 2
    },
    {
      id: 40013,
      question: "What influences the growth, retention, and removal of oral biofilm according to the document?",
      options: [
      "Only patient age and gender",
      "Oral contributing factors such as malocclusion or mouth breathing",
      "Only the type of toothbrush used",
      "Only dietary habits"
      ],
      correct: 1
    },
    {
      id: 40014,
      question: "Dental calculus is defined as oral biofilm that has been mineralized by which substances?",
      options: [
      "Fluoride and chloride salts",
      "Sodium and potassium salts",
      "Calcium and phosphate salts from saliva",
      "Magnesium and iron salts"
      ],
      correct: 2
    },
    {
      id: 40015,
      question: "What is another common name for dental calculus?",
      options: [
      "Plaque",
      "Biofilm",
      "Materia alba",
      "Tartar"
      ],
      correct: 3
    },
    {
      id: 40016,
      question: "Where is supragingival calculus located?",
      options: [
      "Below the free gingival margin",
      "Above the free gingival margin",
      "Within the gingival sulcus only",
      "On the root surface only"
      ],
      correct: 1
    },
    {
      id: 40017,
      question: "What are the most common locations for supragingival calculus formation?",
      options: [
      "Sublingual and parotid salivary gland ducts",
      "Posterior teeth only",
      "Anterior teeth only",
      "Occlusal surfaces only"
      ],
      correct: 0
    },
    {
      id: 40018,
      question: "What is the most effective way to identify supragingival calculus?",
      options: [
      "Tactile examination only",
      "Radiographic examination only",
      "Visual observation in conjunction with compressed air",
      "Disclosing solution only"
      ],
      correct: 2
    },
    {
      id: 40019,
      question: "What color does supragingival calculus typically appear?",
      options: [
      "Always dark brown or black",
      "Always bright white",
      "Yellow-white but can be dark yellow to brown",
      "Red or pink"
      ],
      correct: 2
    },
    {
      id: 40020,
      question: "Where is subgingival calculus located?",
      options: [
      "Above the free gingival margin",
      "Below the free gingival margin, often on the root surface",
      "On the occlusal surface only",
      "In the interproximal space only"
      ],
      correct: 1
    },
    {
      id: 40021,
      question: "What is the most effective way to identify subgingival calculus?",
      options: [
      "Visual observation only",
      "Compressed air only",
      "Use of periodontal explorer",
      "Disclosing solution only"
      ],
      correct: 2
    },
    {
      id: 40022,
      question: "How does subgingival calculus appear on radiographs or through thin gingiva?",
      options: [
      "Bright white and opaque",
      "Transparent and clear",
      "Dark, opaque, and shadowlike",
      "Red and inflamed"
      ],
      correct: 2
    },
    {
      id: 40023,
      question: "What characteristics describe subgingival calculus deposits?",
      options: [
      "Soft and easily removed",
      "Hard and tenacious, occasionally visible through thin gingiva",
      "Always visible to the naked eye",
      "Loose and detachable"
      ],
      correct: 1
    },
    {
      id: 40024,
      question: "Approximately how many days are typically required for oral biofilm to become mineralized calculus?",
      options: [
      "1 to 5 days",
      "5 to 10 days",
      "10 to 20 days",
      "30 to 40 days"
      ],
      correct: 2
    },
    {
      id: 40025,
      question: "What do heavy calculus formers have higher salivary concentrations of compared to light formers?",
      options: [
      "Sodium and chloride",
      "Calcium and phosphate",
      "Fluoride and magnesium",
      "Potassium and iron"
      ],
      correct: 1
    },
    {
      id: 40026,
      question: "What do light calculus formers have higher salivary levels of compared to heavy formers?",
      options: [
      "Calcium",
      "Phosphate",
      "Pyrophosphate",
      "Fluoride"
      ],
      correct: 2
    },
    {
      id: 40027,
      question: "What is materia alba?",
      options: [
      "A hard, mineralized deposit on teeth",
      "A loosely attached collection of oral debris, epithelial cells, leukocytes, salivary proteins, bacteria, and lipids",
      "Only food remnants",
      "Only bacterial colonies"
      ],
      correct: 1
    },
    {
      id: 40028,
      question: "What color does materia alba typically present as on teeth?",
      options: [
      "Black or dark brown",
      "Bright red",
      "White, yellow, or gray",
      "Green or blue"
      ],
      correct: 2
    },
    {
      id: 40029,
      question: "What is food debris composed of?",
      options: [
      "Only bacteria",
      "Only dead epithelial cells",
      "Remnants of food retained after a meal",
      "Only salivary proteins"
      ],
      correct: 2
    },
    {
      id: 40030,
      question: "Tooth stains are defined as what?",
      options: [
      "Normal tooth color variations",
      "Discolored areas on teeth that contrast with the color of the rest of the tooth",
      "Only bacterial deposits",
      "Only calculus formations"
      ],
      correct: 1
    },
    {
      id: 40031,
      question: "What are intrinsic stains?",
      options: [
      "Stains that can be removed by scaling or polishing",
      "Stains that cannot be removed by scaling or polishing and result from alterations during tooth development",
      "Only surface stains",
      "Stains caused by food only"
      ],
      correct: 1
    },
    {
      id: 40032,
      question: "What are extrinsic stains?",
      options: [
      "Stains within the tooth structure that cannot be removed",
      "Stains that occur on the tooth surface and can usually be removed with coronal polishing or scaling",
      "Genetic stains only",
      "Stains from tooth development only"
      ],
      correct: 1
    },
    {
      id: 40033,
      question: "What are oral hygiene indices used to measure?",
      options: [
      "Only the color of teeth",
      "Only the amount of calculus",
      "The client's level of oral hygiene to establish baselines, survey populations, and evaluate interventions",
      "Only gingival inflammation"
      ],
      correct: 2
    },
    {
      id: 40034,
      question: "What does the O'Leary Plaque Score demonstrate?",
      options: [
      "Only calculus levels",
      "The procedure for taking and recording plaque control scores",
      "Only gingival bleeding",
      "Only tooth stain assessment"
      ],
      correct: 1
    },
    {
      id: 40035,
      question: "According to the Calculus Index (CI), what does a score of 0 indicate?",
      options: [
      "Heavy calculus present",
      "No calculus present",
      "Moderate calculus present",
      "Calculus covering entire tooth"
      ],
      correct: 1
    },
    {
      id: 40036,
      question: "According to the Calculus Index, what does a score of 1 indicate?",
      options: [
      "No calculus present",
      "Calculus covering the entire tooth surface",
      "Supragingival calculus covering not more than one-third of the exposed tooth surface",
      "Subgingival calculus only"
      ],
      correct: 2
    },
    {
      id: 40037,
      question: "According to the Calculus Index, what does a score of 2 indicate?",
      options: [
      "No calculus present",
      "Supragingival calculus covering more than one-third but not more than two-thirds of the exposed tooth surface",
      "Calculus covering entire tooth",
      "Subgingival calculus only"
      ],
      correct: 1
    },
    {
      id: 40038,
      question: "According to the Calculus Index, what does a score of 3 indicate?",
      options: [
      "No calculus present",
      "Minimal calculus present",
      "Moderate calculus present",
      "Supragingival calculus covering more than two-thirds of the exposed tooth surface"
      ],
      correct: 3
    },
    {
      id: 40039,
      question: "How should a client's ability to manage oral self-care be assessed?",
      options: [
      "Through written tests only",
      "Through open-ended questions, direct observation, and documenting oral hygiene status and dental history",
      "Through radiographs only",
      "Through blood tests only"
      ],
      correct: 1
    },
    {
      id: 40040,
      question: "Why is maintaining a record of a client's oral hygiene status important?",
      options: [
      "For insurance purposes only",
      "For legal documentation only",
      "To document products used, instruction given, and compare current and previous plaque scores",
      "For research purposes only"
      ],
      correct: 2
    },
    {
      id: 40041,
      question: "What should be documented regarding oral hygiene products in the client's record?",
      options: [
      "Only the brand names",
      "Only the cost of products",
      "The oral hygiene products used and previous instruction given",
      "Only the color of products"
      ],
      correct: 2
    },
    {
      id: 40042,
      question: "In biofilm formation, what does the pellicle provide?",
      options: [
      "Nutrients for bacteria",
      "An attachment site for bacteria",
      "Protection from antibiotics",
      "Calcification minerals"
      ],
      correct: 1
    },
    {
      id: 40043,
      question: "What type of bacteria transition occurs during the lag phase of biofilm formation?",
      options: [
      "Sessile to planktonic",
      "Planktonic to sessile",
      "Aerobic to anaerobic only",
      "Gram-positive to gram-negative only"
      ],
      correct: 1
    },
    {
      id: 40044,
      question: "What connects bacterial colonies during the steady state of biofilm formation?",
      options: [
      "Pellicle layer",
      "Salivary proteins",
      "Intermicrobial matrix",
      "Enamel surface"
      ],
      correct: 2
    },
    {
      id: 40045,
      question: "When assessing deposits by amount, what are the two categories mentioned?",
      options: [
      "Mild and severe",
      "Generalized and localized",
      "Anterior and posterior",
      "Visible and invisible"
      ],
      correct: 1
    },
    {
      id: 40046,
      question: "What environmental surface does dental plaque attach to according to the definition?",
      options: [
      "Dry surface",
      "Rough surface",
      "Moist environmental surface",
      "Smooth surface only"
      ],
      correct: 2
    },
    {
      id: 40047,
      question: "Which assessment tool uses compressed air in conjunction with visual observation?",
      options: [
      "Plaque assessment",
      "Gingival assessment",
      "Supragingival calculus identification",
      "Root surface evaluation"
      ],
      correct: 2
    },
    {
      id: 40048,
      question: "What is the primary difference between supragingival and subgingival calculus in terms of identification method?",
      options: [
      "Both use only visual observation",
      "Supragingival uses visual observation with air; subgingival uses periodontal explorer",
      "Both use only explorer",
      "Both use only radiographs"
      ],
      correct: 1
    },
    {
      id: 40049,
      question: "What type of deposit is described as having self-sustaining and protective properties?",
      options: [
      "Materia alba",
      "Food debris",
      "Dental plaque",
      "Tooth stains"
      ],
      correct: 2
    },
    {
      id: 40050,
      question: "What can materia alba be removed with?",
      options: [
      "Scaling only",
      "Professional cleaning only",
      "Rinsing or light brushing",
      "Surgical intervention"
      ],
      correct: 2
    },
    {
      id: 40051,
      question: "What is the relationship between calculus formation time and oral biofilm?",
      options: [
      "Biofilm forms from calculus",
      "Calculus forms from mineralized biofilm",
      "They are unrelated",
      "They form simultaneously"
      ],
      correct: 1
    },
    {
      id: 40052,
      question: "Which stage of biofilm formation involves the formation of the water-insoluble slime matrix?",
      options: [
      "Initial adherence",
      "Lag phase",
      "Rapid growth bacterial colonization",
      "Steady state"
      ],
      correct: 2
    },
    {
      id: 40053,
      question: "What lives symbiotically during the steady state stage of biofilm formation?",
      options: [
      "Only one species of bacteria",
      "Bacteria and viruses",
      "Different bacterial species",
      "Fungi and bacteria"
      ],
      correct: 2
    },
    {
      id: 40054,
      question: "What makes subgingival calculus occasionally visible without instruments?",
      options: [
      "Its bright white color",
      "Through thin gingiva",
      "It is always visible",
      "Under ultraviolet light"
      ],
      correct: 1
    },
    {
      id: 40055,
      question: "What factor influences whether someone is a heavy or light calculus former?",
      options: [
      "Age only",
      "Gender only",
      "Salivary composition (calcium, phosphate, pyrophosphate levels)",
      "Diet only"
      ],
      correct: 2
    },
    {
      id: 40056,
      question: "According to the document, what should assessment of oral biofilm begin with?",
      options: [
      "Measuring pocket depths",
      "Taking radiographs",
      "Noting its location",
      "Calculating an index score"
      ],
      correct: 2
    },
    {
      id: 40057,
      question: "What type of cells are included in materia alba composition?",
      options: [
      "Only bacterial cells",
      "Desquamated epithelial cells and leukocytes",
      "Only red blood cells",
      "Only salivary gland cells"
      ],
      correct: 1
    },
    {
      id: 40058,
      question: "Which component is NOT mentioned as part of materia alba?",
      options: [
      "Bacteria",
      "Desquamated epithelial cells",
      "Calcified minerals",
      "Salivary proteins"
      ],
      correct: 2
    },
    {
      id: 40059,
      question: "What is the key difference between intrinsic and extrinsic stains regarding removal?",
      options: [
      "Both can be removed equally",
      "Intrinsic cannot be removed by scaling/polishing; extrinsic can be removed",
      "Extrinsic cannot be removed; intrinsic can be removed",
      "Neither can be removed"
      ],
      correct: 1
    },
    {
      id: 40060,
      question: "When do intrinsic stains result according to the document?",
      options: [
      "From surface deposits only",
      "From alterations during the development of the tooth",
      "From poor oral hygiene only",
      "From dietary factors only"
      ],
      correct: 1
    },
    {
      id: 40061,
      question: "What is the purpose of establishing a baseline for an individual using oral hygiene indices?",
      options: [
      "For comparison with future assessments",
      "For insurance billing only",
      "For research purposes only",
      "For decorative charts"
      ],
      correct: 0
    },
    {
      id: 40062,
      question: "What can oral hygiene indices be used to evaluate?",
      options: [
      "Only patient compliance",
      "Only professional cleaning effectiveness",
      "An intervention, drug, or device",
      "Only dietary changes"
      ],
      correct: 2
    },
    {
      id: 40063,
      question: "Dental plaque is a mineralized mass of bacterial colonies.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40064,
      question: "Disclosing agents are used to make oral biofilm clinically visible.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40065,
      question: "Supragingival calculus is located below the free gingival margin.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40066,
      question: "It typically takes approximately 10 to 20 days for oral biofilm to become mineralized calculus.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40067,
      question: "Heavy calculus formers have higher salivary concentrations of calcium and phosphate compared to light formers.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40068,
      question: "Intrinsic stains can be removed by scaling or polishing.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40069,
      question: "Extrinsic stains occur on the tooth surface and can usually be removed with coronal polishing or scaling.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40070,
      question: "The most effective way to identify subgingival calculus is through visual observation with compressed air.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    }
  ],
  "2. Toothbrushing": [
    {
      id: 40071,
      question: "What is the most commonly used device for removing oral biofilm?",
      options: [
      "Interdental brushes",
      "Manual toothbrush",
      "Dental floss",
      "Mouth rinse"
      ],
      correct: 1
    },
    {
      id: 40072,
      question: "Manual toothbrushes are designed to remove oral biofilm from which tooth surfaces?",
      options: [
      "Facial, lingual, and occlusal surfaces",
      "Only facial and lingual surfaces",
      "Only interproximal surfaces",
      "Only occlusal surfaces"
      ],
      correct: 0
    },
    {
      id: 40073,
      question: "Which characteristic is NOT listed as essential for an effective toothbrush?",
      options: [
      "Appropriate strength, rigidity, and weight",
      "Functional design that is flexible and comfortable",
      "Electric-powered vibration mechanism",
      "Size, shape, weight, and texture that meet individual needs"
      ],
      correct: 2
    },
    {
      id: 40074,
      question: "What is the typical length of most toothbrush filaments?",
      options: [
      "5 to 7 mm long",
      "8 to 10 mm long",
      "10 to 12 mm long",
      "13 to 15 mm long"
      ],
      correct: 2
    },
    {
      id: 40075,
      question: "How does filament design affect toothbrushing?",
      options: [
      "It affects toothbrushing efficacy",
      "It only affects the cost of production",
      "It determines the color of the brush",
      "It has no measurable impact"
      ],
      correct: 0
    },
    {
      id: 40076,
      question: "Power toothbrushes are typically activated by what source?",
      options: [
      "Manual hand motion only",
      "Water pressure systems",
      "Electricity or battery",
      "Solar energy panels"
      ],
      correct: 2
    },
    {
      id: 40077,
      question: "For which group are power toothbrushes especially beneficial?",
      options: [
      "Professional athletes only",
      "Children under age 5 exclusively",
      "Those with special needs",
      "Only elderly patients"
      ],
      correct: 2
    },
    {
      id: 40078,
      question: "Which mode of action involves oscillation-rotations with microvibrations?",
      options: [
      "Circular mode",
      "Sonic mode",
      "Oscillating-rotations with microvibrations mode",
      "Side-to-side mode"
      ],
      correct: 2
    },
    {
      id: 40079,
      question: "What type of power toothbrush has bristles that vibrate at ultrasonic frequencies greater than 20 kHz?",
      options: [
      "Circular power toothbrush",
      "Oscillating-rotating power toothbrush",
      "Sonic power toothbrush",
      "Ultrasonic power toothbrush"
      ],
      correct: 3
    },
    {
      id: 40080,
      question: "Which power toothbrush mode involves the entire brush head rotating in one direction?",
      options: [
      "Side-to-side mode",
      "Ultrasonic mode",
      "Circular mode",
      "Oscillating-rotations mode"
      ],
      correct: 2
    },
    {
      id: 40081,
      question: "Power toothbrushes are particularly indicated for individuals with which condition?",
      options: [
      "Perfect oral health only",
      "Fixed orthodontic appliances",
      "No dental conditions",
      "Temporary crowns only"
      ],
      correct: 1
    },
    {
      id: 40082,
      question: "Which is an indication for power toothbrush use?",
      options: [
      "Healthy gingiva only",
      "No oral biofilm present",
      "Uncontrolled oral biofilm and periodontal diseases",
      "Recently extracted teeth"
      ],
      correct: 2
    },
    {
      id: 40083,
      question: "What type of instructions do manual and power toothbrushes require?",
      options: [
      "Generic universal instructions for all",
      "Client-specific instructions",
      "No instructions necessary",
      "Only written instructions"
      ],
      correct: 1
    },
    {
      id: 40084,
      question: "What is the minimum recommended duration for toothbrushing?",
      options: [
      "30 seconds",
      "1 minute",
      "2 minutes",
      "5 minutes"
      ],
      correct: 2
    },
    {
      id: 40085,
      question: "How often is brushing commonly recommended?",
      options: [
      "Once daily",
      "Twice daily",
      "Three times daily",
      "Four times daily"
      ],
      correct: 1
    },
    {
      id: 40086,
      question: "What is a common problem clients face regarding toothbrushing force?",
      options: [
      "They apply too little pressure",
      "They struggle to accurately gauge the pressure",
      "They brush too slowly",
      "They use the wrong toothpaste"
      ],
      correct: 1
    },
    {
      id: 40087,
      question: "What type of grasp do clinicians recommend to help reduce brushing force?",
      options: [
      "Palm grasp",
      "Power grasp",
      "Fingertip grasp",
      "Fist grasp"
      ],
      correct: 2
    },
    {
      id: 40088,
      question: "What feature do some power toothbrushes have to prevent excessive force application?",
      options: [
      "Louder motors",
      "Indicators or automatic shutoff functions",
      "Larger brush heads",
      "Longer handles"
      ],
      correct: 1
    },
    {
      id: 40089,
      question: "In the Bass toothbrushing method, at what angle are filaments directed to the long axis of the tooth?",
      options: [
      "90 degrees",
      "30 degrees",
      "45 degrees",
      "60 degrees"
      ],
      correct: 2
    },
    {
      id: 40090,
      question: "What is another name for the Bass toothbrushing method?",
      options: [
      "Crown technique",
      "Bass sulcular technique",
      "Apical roll method",
      "Gingival massage technique"
      ],
      correct: 1
    },
    {
      id: 40091,
      question: "In which direction are filaments directed in the Bass method?",
      options: [
      "Toward the crown",
      "Horizontally across teeth",
      "Directed apically",
      "In circular motions"
      ],
      correct: 2
    },
    {
      id: 40092,
      question: "How are the filaments positioned in the Stillman method compared to the Bass method?",
      options: [
      "They are directed occlusally",
      "They are angled the same, directed apically",
      "They are perpendicular to teeth",
      "They are positioned horizontally"
      ],
      correct: 1
    },
    {
      id: 40093,
      question: "In the Stillman method, where are filaments placed?",
      options: [
      "Only on tooth surfaces",
      "Only on the gingiva",
      "Partly on cervical portion of teeth and partly on adjacent gingiva",
      "Only on occlusal surfaces"
      ],
      correct: 2
    },
    {
      id: 40094,
      question: "What is the key characteristic of the Charter method?",
      options: [
      "Filaments directed apically",
      "Filaments directed toward the crown",
      "Filaments in circular motion",
      "Filaments in horizontal strokes"
      ],
      correct: 1
    },
    {
      id: 40095,
      question: "At what angle are filaments positioned in the Charter method?",
      options: [
      "90 degrees to tooth axis",
      "30 degrees to tooth axis",
      "45 degrees to tooth axis",
      "60 degrees to tooth axis"
      ],
      correct: 2
    },
    {
      id: 40096,
      question: "What motion characterizes the Roll Stroke method?",
      options: [
      "Horizontal back-and-forth motion",
      "Filaments directed apically and rolled occlusally in vertical motion",
      "Circular motion only",
      "Side-to-side motion"
      ],
      correct: 1
    },
    {
      id: 40097,
      question: "What modification is made in the Modified Bass, Stillman, and Charter methods?",
      options: [
      "Use of electric brush only",
      "Addition of mouthwash",
      "Add a roll stroke after cleaning cervical area",
      "Elimination of vibratory strokes"
      ],
      correct: 2
    },
    {
      id: 40098,
      question: "What motion characterizes the Fones method?",
      options: [
      "Vertical strokes",
      "Horizontal strokes",
      "Filaments activated in circular motion",
      "Rolling motion only"
      ],
      correct: 2
    },
    {
      id: 40099,
      question: "For whom is the Fones method recommended?",
      options: [
      "Adults with periodontal disease",
      "Young children with primary teeth",
      "Elderly patients exclusively",
      "Patients with implants only"
      ],
      correct: 1
    },
    {
      id: 40100,
      question: "What characterizes the Horizontal Scrub technique?",
      options: [
      "Circular brushing motions",
      "Vertical rolling strokes",
      "Bristles move back and forth in short horizontal strokes",
      "Angled vibratory movements"
      ],
      correct: 2
    },
    {
      id: 40101,
      question: "For which surfaces is the Horizontal Scrub technique recommended?",
      options: [
      "All tooth surfaces",
      "Occlusal surfaces only",
      "Facial surfaces only",
      "Lingual surfaces only"
      ],
      correct: 1
    },
    {
      id: 40102,
      question: "What is the primary indication for the Bass (sulcular) method?",
      options: [
      "Orthodontic appliances",
      "Periodontal health and disease maintenance",
      "Primary teeth only",
      "Temporary restorations"
      ],
      correct: 1
    },
    {
      id: 40103,
      question: "The Stillman method is indicated for which condition?",
      options: [
      "Orthodontic treatment",
      "Progressive gingival recession and gingival stimulation",
      "Fixed prosthetic appliances",
      "Dental implants only"
      ],
      correct: 1
    },
    {
      id: 40104,
      question: "For what purpose is the Charter method particularly useful?",
      options: [
      "Heavy calculus removal",
      "Orthodontics and temporary cleaning of surgical sites",
      "Primary dentition only",
      "Tongue cleaning"
      ],
      correct: 1
    },
    {
      id: 40105,
      question: "When is the Roll Stroke method used?",
      options: [
      "As a standalone method only",
      "For occlusal surfaces exclusively",
      "In conjunction with Bass, Stillman, and Charter methods",
      "Only for children"
      ],
      correct: 2
    },
    {
      id: 40106,
      question: "What should be included when educating patients about toothbrushing?",
      options: [
      "Only verbal instructions",
      "Discussion of toothbrush selection based on patient needs and findings",
      "One universal technique for all",
      "No explanation necessary"
      ],
      correct: 1
    },
    {
      id: 40107,
      question: "According to patient education tips, what should be incorporated along with toothbrushing?",
      options: [
      "Only fluoride toothpaste",
      "Interdental cleansing and antimicrobial products if needed",
      "Mouthwash exclusively",
      "No additional products"
      ],
      correct: 1
    },
    {
      id: 40108,
      question: "What should be explained to patients regarding tongue brushing?",
      options: [
      "It is unnecessary",
      "The benefits of tongue brushing",
      "It should be avoided",
      "Only power brushes should be used"
      ],
      correct: 1
    },
    {
      id: 40109,
      question: "What ethical principle requires dental hygienists to increase public awareness of oral health practices?",
      options: [
      "Autonomy",
      "Justice",
      "Beneficence",
      "Non-maleficence"
      ],
      correct: 2
    },
    {
      id: 40110,
      question: "What does beneficent dental hygiene care require?",
      options: [
      "Minimal patient interaction",
      "Allocation of time for instruction, repetition, and assessment",
      "Only one-time instruction",
      "No follow-up needed"
      ],
      correct: 1
    },
    {
      id: 40111,
      question: "The ethical principle of autonomy requires dental hygienists to do what?",
      options: [
      "Make all decisions for patients",
      "Listen to and respect patient's right to make decisions",
      "Ignore patient preferences",
      "Only follow standard protocols"
      ],
      correct: 1
    },
    {
      id: 40112,
      question: "What should care plans include regarding oral biofilm?",
      options: [
      "Only professional cleaning",
      "Evaluation of presence and distribution of biofilm and patient self-care",
      "No assessment needed",
      "Only toothbrush recommendations"
      ],
      correct: 1
    },
    {
      id: 40113,
      question: "What must be documented in the patient's legal record?",
      options: [
      "Only the appointment date",
      "Only the cleaning performed",
      "Counseling on oral hygiene and patient's level of progress",
      "Only the payment received"
      ],
      correct: 2
    },
    {
      id: 40114,
      question: "What form can toothbrush trauma appear as on soft tissues?",
      options: [
      "Only bleeding gums",
      "Tooth decay",
      "Gingival abrasions with redness, scuffing, or punctate lesions",
      "Tooth sensitivity only"
      ],
      correct: 2
    },
    {
      id: 40115,
      question: "What percentage of middle-aged Americans experience gingival recession to some degree?",
      options: [
      "20% to 40%",
      "50% to 60%",
      "80% to 100%",
      "10% to 20%"
      ],
      correct: 2
    },
    {
      id: 40116,
      question: "What risks are associated with gingival recession?",
      options: [
      "Only cosmetic concerns",
      "Increased risk of dentinal hypersensitivity and root caries",
      "No significant risks",
      "Only bleeding risks"
      ],
      correct: 1
    },
    {
      id: 40117,
      question: "The cause of gingival recession is described as what?",
      options: [
      "Only toothbrushing factors",
      "Purely genetic",
      "Multifactorial",
      "Unknown"
      ],
      correct: 2
    },
    {
      id: 40118,
      question: "Which is considered a pathologic factor contributing to recession?",
      options: [
      "Tooth color",
      "Tooth size",
      "Clinical attachment loss from periodontal disease",
      "Tooth shape"
      ],
      correct: 2
    },
    {
      id: 40119,
      question: "Where is tooth abrasion typically located?",
      options: [
      "On the incisal edges",
      "Around the cementoenamel junction (CEJ)",
      "On occlusal surfaces only",
      "On the lingual surfaces"
      ],
      correct: 1
    },
    {
      id: 40120,
      question: "What causes dental abfractions?",
      options: [
      "Poor oral hygiene only",
      "Excessive sugar intake",
      "Excessive occlusal loading resulting in tooth flexure",
      "Improper flossing"
      ],
      correct: 2
    },
    {
      id: 40121,
      question: "What are noncarious cervical lesions (NCCL) caused by?",
      options: [
      "Bacterial infection",
      "Demineralization from chemical erosion",
      "Physical trauma only",
      "Genetic factors only"
      ],
      correct: 1
    },
    {
      id: 40122,
      question: "What benefits does tongue cleansing provide?",
      options: [
      "Only fresher breath",
      "Reduces bacteria, controls malodor, and improves taste perception",
      "Whitens teeth only",
      "Strengthens enamel"
      ],
      correct: 1
    },
    {
      id: 40123,
      question: "What tools can be used for tongue cleaning?",
      options: [
      "Only specialized scrapers",
      "Only power toothbrushes",
      "Manual toothbrush, tongue scraper, or power toothbrush with special head",
      "Only interdental brushes"
      ],
      correct: 2
    },
    {
      id: 40124,
      question: "What can result from vigorous tongue scrubbing or scraping?",
      options: [
      "Improved taste only",
      "Better oral health",
      "Trauma to the tongue",
      "Stronger tongue muscles"
      ],
      correct: 2
    },
    {
      id: 40125,
      question: "How should a toothbrush be cared for after use?",
      options: [
      "Stored in a closed container immediately",
      "Rinsed and air dried",
      "Placed in a drawer",
      "Soaked in mouthwash"
      ],
      correct: 1
    },
    {
      id: 40126,
      question: "Can toothbrushes be a mode of indirect transmission for pathogenic organisms?",
      options: [
      "No, they are always sterile",
      "Only if shared with others",
      "Yes, they can be",
      "Only power toothbrushes"
      ],
      correct: 2
    },
    {
      id: 40127,
      question: "Have studies confirmed that toothbrush contamination results in disease transmission?",
      options: [
      "Yes, definitely",
      "Only in immunocompromised patients",
      "No studies have confirmed this",
      "Only with certain diseases"
      ],
      correct: 2
    },
    {
      id: 40128,
      question: "When should instruction, practice, and reinforcement of toothbrushing be provided?",
      options: [
      "Only at the first appointment",
      "Only when problems arise",
      "At all appointments subsequent to the planning phase",
      "Every five years"
      ],
      correct: 2
    },
    {
      id: 40129,
      question: "What must hygienists be aware of when working with clients?",
      options: [
      "Only their technical skills",
      "Their personal biases and accept client abilities and values",
      "Only their schedule",
      "Only insurance coverage"
      ],
      correct: 1
    },
    {
      id: 40130,
      question: "In shared decision-making, what does the dental hygienist provide to the patient?",
      options: [
      "Only treatment options",
      "Technical knowledge",
      "Only cost information",
      "Only appointment times"
      ],
      correct: 1
    },
    {
      id: 40131,
      question: "What does the patient provide to the dental hygienist in shared decision-making?",
      options: [
      "Only payment",
      "Only medical history",
      "Patient preferences, beliefs, values, and current practices",
      "Only insurance information"
      ],
      correct: 2
    },
    {
      id: 40132,
      question: "Who may be included in the deliberation and decision-making process?",
      options: [
      "Only the patient",
      "Only the dental hygienist",
      "Other healthcare providers, caregivers, and family members",
      "Only the dentist"
      ],
      correct: 2
    },
    {
      id: 40133,
      question: "What is the direction of knowledge transfer in shared decision-making?",
      options: [
      "One-way from hygienist to patient",
      "One-way from patient to hygienist",
      "Two-way between hygienist and patient",
      "No knowledge transfer occurs"
      ],
      correct: 2
    },
    {
      id: 40134,
      question: "What should be communicated to patients in a manner appropriate to?",
      options: [
      "Only clinical standards",
      "Age, language, culture, readiness, and learning style",
      "Only educational level",
      "Only time available"
      ],
      correct: 1
    },
    {
      id: 40135,
      question: "What should toothbrushing effectiveness be correlated with?",
      options: [
      "Only time spent brushing",
      "Only type of toothbrush used",
      "Presence of oral biofilm, calcified deposits, and gingival disease",
      "Only toothpaste brand"
      ],
      correct: 2
    },
    {
      id: 40136,
      question: "What should be discussed with patients who exhibit gingival recession?",
      options: [
      "Only cosmetic treatments",
      "Only surgical options",
      "Gingival recession and noncarious cervical lesions with possible causes",
      "Only whitening options"
      ],
      correct: 2
    },
    {
      id: 40137,
      question: "Power toothbrushes are safe and effective.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40138,
      question: "Filament design affects toothbrushing efficacy.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40139,
      question: "Most toothbrush filaments are 15 to 18 mm long.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40140,
      question: "Power toothbrushes are suitable for almost any client.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40141,
      question: "The Oral-B oscillating rotating power toothbrush has the ADA Seal of Acceptance.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40142,
      question: "Sonic power toothbrushes cause fluid motion through sound waves.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40143,
      question: "Toothbrushing duration should be a minimum of 30 seconds.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40144,
      question: "Twice daily brushing is commonly recommended.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40145,
      question: "The Fones method is recommended for young children with primary teeth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40146,
      question: "The Horizontal Scrub technique is recommended for all tooth surfaces.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40147,
      question: "Gingival recession affects less than 50% of middle-aged Americans.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40148,
      question: "Dental abfractions are caused by excessive occlusal loading.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40149,
      question: "Tongue cleansing helps control oral malodor.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40150,
      question: "Studies have confirmed that toothbrush contamination results in disease transmission.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40151,
      question: "The toothbrush should be rinsed and air dried after each use.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40152,
      question: "In the Bass method, filaments are directed toward the crown of the tooth.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40153,
      question: "The Charter method directs filaments toward the crown of the tooth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    }
  ],
  "3. Interdental & Supplemental Self-Care Aids": [
    {
      id: 40154,
      question: "What percentage of tooth surfaces does toothbrushing typically miss?",
      options: [
      "Up to 25% of tooth surfaces",
      "Up to 40% of tooth surfaces",
      "Up to 50% of tooth surfaces",
      "Up to 60% of tooth surfaces"
      ],
      correct: 1
    },
    {
      id: 40155,
      question: "What is the col in periodontal anatomy?",
      options: [
      "The keratinized tissue at the gingival margin",
      "The space between adjacent tooth roots",
      "The nonkeratinized epithelial depression connecting buccal and lingual papillae",
      "The attached gingiva surrounding the tooth"
      ],
      correct: 2
    },
    {
      id: 40156,
      question: "Which embrasure classification is characterized by gingival tissue that fills the interdental space completely?",
      options: [
      "Class III embrasure space",
      "Class II embrasure space",
      "Normal or Class I embrasure space",
      "Class IV embrasure space"
      ],
      correct: 2
    },
    {
      id: 40157,
      question: "What type of interdental aid is most appropriate for Class I embrasures?",
      options: [
      "Interdental brushes with thick bristles",
      "Rubber tip stimulators exclusively",
      "Dental floss or dental tape",
      "Wooden wedges and toothpick holders"
      ],
      correct: 2
    },
    {
      id: 40158,
      question: "Which clinical condition should be assessed when selecting interdental devices?",
      options: [
      "Patient's dietary preferences and meal frequency",
      "Contour and consistency of gingival tissues",
      "Patient's insurance coverage and benefits",
      "The brand preferences of the dental office"
      ],
      correct: 1
    },
    {
      id: 40159,
      question: "What factor related to tooth anatomy affects interdental device selection?",
      options: [
      "The color and translucency of enamel",
      "The patient's age and gender",
      "The size of interproximal embrasures",
      "The thickness of the tooth's cementum layer"
      ],
      correct: 2
    },
    {
      id: 40160,
      question: "Which patient factor is important when recommending interdental aids?",
      options: [
      "Level of dexterity and ability to use a device",
      "The patient's occupation and work schedule",
      "The distance from their home to the dental office",
      "Their preference for morning or evening appointments"
      ],
      correct: 0
    },
    {
      id: 40161,
      question: "What determines the choice between waxed and unwaxed dental floss?",
      options: [
      "The patient's budget and insurance coverage",
      "The dentist's personal preference only",
      "The tightness of contact areas and roughness of surfaces",
      "The time of day the patient flosses"
      ],
      correct: 2
    },
    {
      id: 40162,
      question: "Which flossing method involves wrapping floss around the middle fingers?",
      options: [
      "The loop method for easy handling",
      "The threader method for bridges",
      "The spool method with finger wrapping",
      "The holder method with plastic devices"
      ],
      correct: 2
    },
    {
      id: 40163,
      question: "What is the primary advantage of tufted or braided floss?",
      options: [
      "It is less expensive than regular floss",
      "It is effective for cleaning around orthodontic appliances and fixed bridges",
      "It requires less manual dexterity to use",
      "It can be used without any patient instruction"
      ],
      correct: 1
    },
    {
      id: 40164,
      question: "When are floss threaders particularly useful?",
      options: [
      "For patients with only natural teeth and no restorations",
      "For children learning to floss for the first time",
      "For cleaning under fixed bridges and orthodontic wires",
      "For patients with perfect tooth alignment"
      ],
      correct: 2
    },
    {
      id: 40165,
      question: "What is the recommended technique for using a floss holder?",
      options: [
      "Insert horizontally and pull straight out without vertical movement",
      "Use only on anterior teeth to avoid breaking",
      "Guide floss between teeth, curve around each tooth, and move up and down",
      "Apply maximum pressure to ensure thorough cleaning"
      ],
      correct: 2
    },
    {
      id: 40166,
      question: "What is a key benefit of dental water jets (oral irrigators)?",
      options: [
      "They completely replace the need for toothbrushing",
      "They are effective for flushing debris and reducing gingivitis",
      "They eliminate the need for professional dental cleanings",
      "They whiten teeth better than any other method"
      ],
      correct: 1
    },
    {
      id: 40167,
      question: "What is the proper angle for directing a water jet tip?",
      options: [
      "Perpendicular to the gingival margin at 90 degrees",
      "Parallel to the tooth surface at 0 degrees",
      "At a 45-degree angle toward the gingival margin",
      "At a 180-degree angle away from the gums"
      ],
      correct: 2
    },
    {
      id: 40168,
      question: "When are interdental brushes most appropriate?",
      options: [
      "For all patients regardless of their oral anatomy",
      "For Class II and Class III embrasures with open spaces",
      "Only for patients with orthodontic braces",
      "Exclusively for primary dentition in children"
      ],
      correct: 1
    },
    {
      id: 40169,
      question: "What is important when selecting the size of an interdental brush?",
      options: [
      "Always choose the largest size available for better cleaning",
      "Use the same size for all interdental spaces",
      "Select a size that fits without forcing into the space",
      "Only use the smallest size to avoid tissue damage"
      ],
      correct: 2
    },
    {
      id: 40170,
      question: "How should an interdental brush be inserted between teeth?",
      options: [
      "With force to ensure it reaches the contact point",
      "Gently without forcing, at a slight angle if needed",
      "Only from the lingual side of the teeth",
      "Horizontally with rapid back-and-forth movements"
      ],
      correct: 1
    },
    {
      id: 40171,
      question: "What is the primary use of end-tufted or single-tufted brushes?",
      options: [
      "For cleaning large open interdental spaces only",
      "For hard-to-reach areas like distal surfaces of last molars",
      "As a complete replacement for regular toothbrushes",
      "For polishing tooth surfaces after meals"
      ],
      correct: 1
    },
    {
      id: 40172,
      question: "What is the main concern with using household toothpicks?",
      options: [
      "They are too expensive for most patients",
      "They may cause trauma or blunting of the papilla",
      "They are completely ineffective at removing any debris",
      "They require extensive training to use properly"
      ],
      correct: 1
    },
    {
      id: 40173,
      question: "What makes triangular wooden wedges safer than regular toothpicks?",
      options: [
      "They are shorter in length and easier to hold",
      "They are designed for safe and effective biofilm removal",
      "They cost less than other interdental devices",
      "They can be used without any instruction"
      ],
      correct: 1
    },
    {
      id: 40174,
      question: "What is the correct technique for using a triangular toothpick?",
      options: [
      "Insert perpendicular to the gingival margin with maximum pressure",
      "Place at the gingival margin and angle toward the occlusal surface",
      "Use only on posterior teeth to avoid anterior damage",
      "Apply in a circular motion around each tooth"
      ],
      correct: 1
    },
    {
      id: 40175,
      question: "What is the primary function of rubber tip stimulators?",
      options: [
      "To replace toothbrushing in patients with sensitive teeth",
      "To massage gingival tissues and remove plaque at the gingival margin",
      "To whiten teeth through mechanical polishing",
      "To apply fluoride directly to tooth surfaces"
      ],
      correct: 1
    },
    {
      id: 40176,
      question: "How should a rubber tip stimulator be positioned?",
      options: [
      "Perpendicular to the tooth surface at 90 degrees",
      "At a 45-degree angle to the gingival margin",
      "Parallel to the occlusal plane horizontally",
      "Vertical to the long axis of the tooth"
      ],
      correct: 1
    },
    {
      id: 40177,
      question: "What motion should be used with a rubber tip stimulator?",
      options: [
      "Rapid side-to-side movements across all teeth",
      "Circular or vibratory motion tracing the gingival margin",
      "Vertical strokes from apex to crown",
      "Pressing firmly without any movement"
      ],
      correct: 1
    },
    {
      id: 40178,
      question: "What is a sulcabrush designed for?",
      options: [
      "Cleaning the occlusal surfaces of molars only",
      "Removing stains from anterior teeth",
      "Accessing difficult areas like furcations and isolated teeth",
      "Replacing regular interdental brushes in all cases"
      ],
      correct: 2
    },
    {
      id: 40179,
      question: "What is the primary benefit of using tongue cleaners?",
      options: [
      "They strengthen the tongue muscles for better speech",
      "They reduce bacteria and help control oral malodor",
      "They change the taste perception of foods",
      "They prevent all types of oral diseases"
      ],
      correct: 1
    },
    {
      id: 40180,
      question: "What technique should be used with a tongue cleaner?",
      options: [
      "Scrape from the tip of the tongue backward toward the throat",
      "Apply pressure only to the sides of the tongue",
      "Gently scrape from back to front, avoiding the gag reflex",
      "Use circular motions covering the entire tongue surface randomly"
      ],
      correct: 2
    },
    {
      id: 40181,
      question: "What is a concern regarding oral piercings and interdental care?",
      options: [
      "Piercings have no impact on oral health or care recommendations",
      "They may contribute to recession, chipping, or trauma",
      "They improve gingival health by stimulating blood flow",
      "They prevent the accumulation of plaque biofilm"
      ],
      correct: 1
    },
    {
      id: 40182,
      question: "What should be avoided around oral piercings during interdental cleaning?",
      options: [
      "All forms of interdental cleaning devices",
      "Dental floss and tape exclusively",
      "Metal interdental brushes that could cause trauma",
      "Water irrigators at any pressure setting"
      ],
      correct: 2
    },
    {
      id: 40183,
      question: "What is essential for effective patient education on interdental devices?",
      options: [
      "Providing only verbal instructions without demonstration",
      "Using hands-on demonstration tailored to the patient's anatomy",
      "Giving the patient a pamphlet to read at home",
      "Assuming the patient will learn through trial and error"
      ],
      correct: 1
    },
    {
      id: 40184,
      question: "Why should patients repeat techniques back to the clinician?",
      options: [
      "To ensure they can teach others the same technique",
      "To confirm understanding and proper execution of the skill",
      "To demonstrate they are better than other patients",
      "To reduce the appointment time for future visits"
      ],
      correct: 1
    },
    {
      id: 40185,
      question: "What type of educational reinforcement should be provided?",
      options: [
      "Only verbal instructions during the appointment",
      "Written or digital resources for home reference",
      "A single demonstration with no follow-up materials",
      "Instructions that contradict demonstrated techniques"
      ],
      correct: 1
    },
    {
      id: 40186,
      question: "What is the benefit of regular interdental cleaning?",
      options: [
      "It eliminates the need for any professional dental care",
      "It reduces inflammation and bleeding while supporting periodontal stability",
      "It prevents all systemic diseases unrelated to oral health",
      "It guarantees that no dental problems will ever occur"
      ],
      correct: 1
    },
    {
      id: 40187,
      question: "What percentage of total questions should true/false questions represent?",
      options: [
      "Around 10% of the total question count",
      "Around 25% of the total question count",
      "Around 50% of the total question count",
      "Around 75% of the total question count"
      ],
      correct: 0
    },
    {
      id: 40188,
      question: "Which factor affects the recommendation of floss type?",
      options: [
      "The patient's hair color and eye color",
      "The day of the week the patient flosses",
      "The roughness of interproximal surfaces and restorations",
      "The brand of toothpaste the patient uses"
      ],
      correct: 2
    },
    {
      id: 40189,
      question: "What is critical about interdental biofilm removal?",
      options: [
      "It is optional for patients with healthy gums",
      "It is critical for preventing oral diseases",
      "It only matters for patients over age 65",
      "It should only be done by dental professionals"
      ],
      correct: 1
    },
    {
      id: 40190,
      question: "What should guide the selection of self-care devices?",
      options: [
      "Effectiveness, client needs, preferences, and specific factors like piercings",
      "Only the cost of the device and insurance coverage",
      "The marketing materials from device manufacturers",
      "The alphabetical order of device names"
      ],
      correct: 0
    },
    {
      id: 40191,
      question: "How should clients be educated about using interdental devices?",
      options: [
      "Clients should figure out techniques independently without help",
      "Clients should be educated as co-therapists with safe, effective techniques",
      "Clients only need to watch online videos with no professional guidance",
      "Clients should use devices based solely on package instructions"
      ],
      correct: 1
    },
    {
      id: 40192,
      question: "What happens when gingival tissue does not fill the embrasure space?",
      options: [
      "No interdental cleaning is necessary in these areas",
      "Only toothbrushing is sufficient for cleaning",
      "Interdental brushes or other aids may be more appropriate than floss",
      "The embrasure space will naturally close over time"
      ],
      correct: 2
    },
    {
      id: 40193,
      question: "What is the location of the col relative to the contact area?",
      options: [
      "Occlusal to the contact area between adjacent teeth",
      "Apical to the contact area connecting papillae",
      "At the same level as the contact area",
      "On the facial surface only of each tooth"
      ],
      correct: 1
    },
    {
      id: 40194,
      question: "Toothbrushing alone can effectively clean all tooth surfaces including interdental areas.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40195,
      question: "Interdental areas harbor pathogenic bacteria that contribute to periodontal disease.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40196,
      question: "Patients with increased risk for periodontal disease may need specialized devices beyond toothbrushing.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40197,
      question: "The col is a keratinized epithelial structure in the interdental area.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40198,
      question: "Class I embrasures are characterized by gingival tissue completely filling the interdental space.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40199,
      question: "Probing depths are a clinical factor to consider when selecting interdental aids.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40200,
      question: "Patient preference is irrelevant when selecting interdental cleaning devices.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40201,
      question: "Waxed floss is always superior to unwaxed floss for all patients.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40202,
      question: "The spool method involves wrapping floss around the middle fingers of each hand.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40203,
      question: "Floss holders can help patients with limited dexterity use dental floss effectively.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40204,
      question: "Dental water jets can completely replace manual flossing and toothbrushing.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40205,
      question: "Interdental brushes are most appropriate for Class II and Class III embrasures.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40206,
      question: "The same size interdental brush should be used for all interdental spaces in the mouth.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40207,
      question: "End-tufted brushes are useful for cleaning hard-to-reach areas like distal surfaces of last molars.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40208,
      question: "Household toothpicks provide significant oral health benefits beyond removing impacted food.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40209,
      question: "Triangular wooden wedges are safer than regular toothpicks for interdental cleaning.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40210,
      question: "Rubber tip stimulators should be positioned perpendicular to the tooth surface at 90 degrees.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40211,
      question: "A circular or vibratory motion is recommended when using rubber tip stimulators.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40212,
      question: "Tongue cleaners help reduce bacteria and control oral malodor.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40213,
      question: "Oral piercings have no impact on self-care recommendations or oral health.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40214,
      question: "Metal interdental brushes should be avoided around oral piercings to prevent trauma.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40215,
      question: "Hands-on demonstration is essential for effective patient education on interdental devices.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40216,
      question: "Patients should repeat techniques back to the clinician to confirm proper understanding.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40217,
      question: "Regular interdental cleaning reduces inflammation and bleeding while supporting periodontal stability.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40218,
      question: "Gingival attachment levels are irrelevant when selecting interdental cleaning devices.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40219,
      question: "The condition and types of restorative work present should be considered when recommending interdental aids.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40220,
      question: "Patient motivation is a factor in selecting appropriate interdental cleaning devices.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40221,
      question: "Tufted floss is particularly effective for cleaning around orthodontic appliances and bridges.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40222,
      question: "Water jet tips should be directed at a 45-degree angle toward the gingival margin.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40223,
      question: "Interdental brushes should be forced into tight spaces to ensure thorough cleaning.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40224,
      question: "Written or digital reinforcement resources support effective patient education.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40225,
      question: "The size of interproximal embrasures has no bearing on device selection.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40226,
      question: "Interdental cleaning should be tailored to the patient's oral conditions and risk factors.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40227,
      question: "Tooth position and alignment affect the choice of interdental cleaning devices.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40228,
      question: "Cost, safety, and effectiveness are all important considerations when recommending devices.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40229,
      question: "Sulcabrushes are designed for accessing difficult areas like furcations and isolated teeth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40230,
      question: "Floss threaders are useful for cleaning under fixed bridges and orthodontic wires.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40231,
      question: "Regular interdental cleaning supports long-term periodontal stability.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40232,
      question: "The loop method is an alternative flossing technique to the spool method.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40233,
      question: "Tongue cleaners should be scraped from the back to the front of the tongue.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40234,
      question: "All interdental devices work equally well for every patient regardless of individual anatomy.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40235,
      question: "Patient dexterity level should be assessed when recommending interdental aids.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    }
  ],
  "4. Dentifrices": [
    {
      id: 40236,
      question: "What is a dentifrice?",
      options: [
      "A device used only for tongue cleaning",
      "A substance used with a toothbrush to clean teeth, tongue, and gingiva",
      "A specialized tool for removing calculus",
      "A prescription medication for gum disease"
      ],
      correct: 1
    },
    {
      id: 40237,
      question: "What are the three main effects of dentifrices?",
      options: [
      "Cosmetic, hygienic, and therapeutic effects",
      "Whitening, fluoride, and antibacterial effects",
      "Cleaning, polishing, and remineralizing effects",
      "Freshening, flavoring, and coloring effects"
      ],
      correct: 0
    },
    {
      id: 40238,
      question: "Which type of dentifrice is recommended for use with power toothbrushes?",
      options: [
      "High-foaming dentifrices with maximum detergent",
      "Fluoride dentifrices with maximum concentration",
      "Nonfoaming to low-foaming dentifrices",
      "Abrasive dentifrices with coarse particles"
      ],
      correct: 2
    },
    {
      id: 40239,
      question: "What type of dentifrice is designed for persons with special needs who may swallow it?",
      options: [
      "Fluoride dentifrices with high concentration",
      "Ingestible dentifrices safe for swallowing",
      "Antibacterial dentifrices with triclosan",
      "Whitening dentifrices with peroxide"
      ],
      correct: 1
    },
    {
      id: 40240,
      question: "Which ingredient is commonly excluded from dentifrices for allergic persons?",
      options: [
      "Fluoride and calcium phosphate",
      "Humectants and water content",
      "Sodium lauryl sulfate, preservatives, and dyes",
      "Abrasives and binders only"
      ],
      correct: 2
    },
    {
      id: 40241,
      question: "What is the purpose of fluoride in dentifrices?",
      options: [
      "To whiten teeth and remove stains",
      "To prevent caries and remineralize teeth",
      "To control plaque and gingivitis",
      "To freshen breath and improve taste"
      ],
      correct: 1
    },
    {
      id: 40242,
      question: "What does amorphous calcium phosphate do in dentifrices?",
      options: [
      "Controls dentinal hypersensitivity effectively",
      "Prevents bacterial growth and plaque formation",
      "Remineralizes teeth and adds luster",
      "Provides foaming action for debris removal"
      ],
      correct: 2
    },
    {
      id: 40243,
      question: "What should a dental hygienist check before recommending a dentifrice?",
      options: [
      "Only the patient's age and gender",
      "Patient's medical history to eliminate risk of allergies or adverse reactions",
      "Only the patient's insurance coverage",
      "The brand preferences of the dental office"
      ],
      correct: 1
    },
    {
      id: 40244,
      question: "What should be documented in the patient's record regarding dentifrice recommendations?",
      options: [
      "Only the brand name and price",
      "Product choices, concentration, therapeutic effect, and frequency of use",
      "Only the patient's verbal agreement",
      "The dentist's personal preference only"
      ],
      correct: 1
    },
    {
      id: 40245,
      question: "What does the patient's signature confirm regarding dentifrice recommendations?",
      options: [
      "Agreement to purchase the most expensive product",
      "Understanding and acceptance of the recommendations",
      "Willingness to try multiple products simultaneously",
      "Commitment to visit the dental office monthly"
      ],
      correct: 1
    },
    {
      id: 40246,
      question: "What must organic or bio dentifrices NOT contain?",
      options: [
      "Fluoride or calcium compounds",
      "Abrasive particles or detergents",
      "Animal ingredients",
      "Water or humectants"
      ],
      correct: 2
    },
    {
      id: 40247,
      question: "What is the requirement for vegan or vegetarian dentifrices?",
      options: [
      "Must contain only synthetic chemicals",
      "Must be plant origin",
      "Must be fluoride-free exclusively",
      "Must have animal-derived glycerin"
      ],
      correct: 1
    },
    {
      id: 40248,
      question: "What characterizes biodegradable dentifrices?",
      options: [
      "Must be packaged in plastic tubes",
      "Must not include polluting ingredients",
      "Must contain preservatives for shelf life",
      "Must have maximum foaming agents"
      ],
      correct: 1
    },
    {
      id: 40249,
      question: "What factors does the general public consider when choosing a dentifrice?",
      options: [
      "Evidence-based clinical recommendations only",
      "Long-term effects and risk factors",
      "Cost, flavor, breath freshness, clean white teeth",
      "Therapeutic agents and compatibility"
      ],
      correct: 2
    },
    {
      id: 40250,
      question: "What do dental professionals prioritize when recommending dentifrices?",
      options: [
      "Marketing claims and brand popularity",
      "Evidence-based clinical recommendation and choice of therapeutic agents",
      "Cost and patient convenience only",
      "Packaging appearance and flavor options"
      ],
      correct: 1
    },
    {
      id: 40251,
      question: "What do manufacturers consider regarding client health when formulating dentifrices?",
      options: [
      "Only the client's age demographics",
      "State of clients' health like diabetes, hypertension, xerostomia",
      "Only the client's geographic location",
      "The client's occupation and lifestyle"
      ],
      correct: 1
    },
    {
      id: 40252,
      question: "Why is the orifice of the toothpaste tube a concern?",
      options: [
      "It affects the amount dispensed per use",
      "It can be a source of cross-contamination",
      "It determines the shelf life of the product",
      "It influences the flavor intensity"
      ],
      correct: 1
    },
    {
      id: 40253,
      question: "What infectious diseases can be transmitted through toothpaste tube contamination?",
      options: [
      "Only common cold and flu viruses",
      "Hepatitis B, gastroenteritis, common cold, and flu",
      "Only bacterial infections, no viruses",
      "Dental caries and periodontal disease"
      ],
      correct: 1
    },
    {
      id: 40254,
      question: "What is the recommended practice to prevent toothpaste tube cross-contamination?",
      options: [
      "Share tubes but clean the orifice daily",
      "Each family member should have their own tube",
      "Use only pump dispensers for the family",
      "Store tubes in the refrigerator between uses"
      ],
      correct: 1
    },
    {
      id: 40255,
      question: "How much of a dentifrice is water?",
      options: [
      "5% to 10% of dentifrice composition",
      "20% to 30% of dentifrice composition",
      "40% to 50% of dentifrice composition",
      "60% to 70% of dentifrice composition"
      ],
      correct: 1
    },
    {
      id: 40256,
      question: "What makes tablet dentifrices different from paste dentifrices?",
      options: [
      "Tablets contain more fluoride than pastes",
      "Tablets do not contain water; they activate after chewing",
      "Tablets are only for children's use",
      "Tablets have stronger abrasive properties"
      ],
      correct: 1
    },
    {
      id: 40257,
      question: "What is the purpose of preservatives in dentifrices?",
      options: [
      "To enhance flavor and sweetness",
      "To inhibit mold and bacterial growth and prolong shelf life",
      "To increase foaming and cleaning action",
      "To provide color and visual appeal"
      ],
      correct: 1
    },
    {
      id: 40258,
      question: "What is the function of binders in dentifrices?",
      options: [
      "To enhance the flavor profile",
      "Thickeners that prevent separation of ingredients",
      "To increase fluoride bioavailability",
      "To create foaming action"
      ],
      correct: 1
    },
    {
      id: 40259,
      question: "What is the role of detergents in dentifrices?",
      options: [
      "To preserve the product from bacterial growth",
      "Foaming agents to loosen debris and stains",
      "To bind ingredients together",
      "To provide sweetness and flavor"
      ],
      correct: 1
    },
    {
      id: 40260,
      question: "What do copolymers do when added to dentifrices?",
      options: [
      "Increase abrasiveness for better cleaning",
      "Increase substantivity, such as duration in mouth",
      "Reduce cost of the formulation",
      "Change the color of the dentifrice"
      ],
      correct: 1
    },
    {
      id: 40261,
      question: "What is a medicinal ingredient in a dentifrice?",
      options: [
      "Added to provide flavor or color only",
      "Intended to produce a therapeutic effect on hard and/or soft tissues",
      "Used solely to prevent bacterial growth",
      "Provides better consistency for the dentifrice"
      ],
      correct: 1
    },
    {
      id: 40262,
      question: "What is a nonmedicinal ingredient in a dentifrice?",
      options: [
      "Provides therapeutic effects on tissues",
      "Added to provide flavor, color, prevent bacterial growth, or provide consistency",
      "Always contains fluoride for caries prevention",
      "Used exclusively for remineralization purposes"
      ],
      correct: 1
    },
    {
      id: 40263,
      question: "What are the five common dentifrice abrasives?",
      options: [
      "Fluoride, chlorhexidine, triclosan, peroxide, enzymes",
      "Phosphates, carbonates, silicas, aluminum compounds, other substances",
      "Water, preservatives, binders, detergents, flavoring",
      "Sodium, potassium, calcium, magnesium, zinc"
      ],
      correct: 1
    },
    {
      id: 40264,
      question: "What do phosphates do as abrasives in dentifrices?",
      options: [
      "Control bacterial growth in the mouth",
      "Help the dentifrice whiten teeth and make them feel clean",
      "Increase fluoride bioavailability significantly",
      "Bind ingredients together for consistency"
      ],
      correct: 1
    },
    {
      id: 40265,
      question: "What is the function of carbonates as abrasives?",
      options: [
      "To prevent tooth decay through remineralization",
      "Help to clean and deodorize the mouth and make it smell fresh",
      "To increase the pH of the dentifrice",
      "To enhance the color of teeth"
      ],
      correct: 1
    },
    {
      id: 40266,
      question: "Why are silicas frequently used as abrasives in dentifrices?",
      options: [
      "They are the least expensive abrasive option",
      "Silicas are chemically compatible with NaF and MFP, nonreactive",
      "They provide the strongest cleaning action",
      "They add flavor and freshness"
      ],
      correct: 1
    },
    {
      id: 40267,
      question: "What is the concern with alumina and aluminum compounds as abrasives?",
      options: [
      "They are too expensive for commercial use",
      "Insoluble with very high abrasive potential, particles irregular and harder than tooth",
      "They react negatively with fluoride compounds",
      "They cause staining of tooth surfaces"
      ],
      correct: 1
    },
    {
      id: 40268,
      question: "What other substances can be used as abrasives in dentifrices?",
      options: [
      "Sugars and artificial sweeteners",
      "Clay and synthetics, such as vinyl or resins",
      "Vitamins and minerals only",
      "Essential oils and herbal extracts"
      ],
      correct: 1
    },
    {
      id: 40269,
      question: "On the Mohs hardness scale, what is the hardness range of cementum and dentin?",
      options: [
      "1 to 1.5 on the Mohs scale",
      "2 to 2.5 on the Mohs scale",
      "4 to 5 on the Mohs scale",
      "6 to 7 on the Mohs scale"
      ],
      correct: 1
    },
    {
      id: 40270,
      question: "On the Mohs hardness scale, what is the hardness of enamel?",
      options: [
      "2 to 3 on the Mohs scale",
      "4 to 5 on the Mohs scale",
      "6 to 7 on the Mohs scale",
      "8 to 9 on the Mohs scale"
      ],
      correct: 1
    },
    {
      id: 40271,
      question: "What percentage of dentifrices fall below 2% on the abrasiveness scale?",
      options: [
      "50% of all dentifrices",
      "72% of all dentifrices",
      "85% of all dentifrices",
      "95% of all dentifrices"
      ],
      correct: 1
    },
    {
      id: 40272,
      question: "What does the Relative Dentin Abrasivity (RDA) Scale measure?",
      options: [
      "The fluoride content of dentifrices",
      "The abrasiveness of most dentifrices",
      "The pH level of dentifrices",
      "The cost-effectiveness of dentifrices"
      ],
      correct: 1
    },
    {
      id: 40273,
      question: "What RDA value range is considered low abrasive?",
      options: [
      "0-70 on the RDA scale",
      "71-100 on the RDA scale",
      "101-150 on the RDA scale",
      "151-200 on the RDA scale"
      ],
      correct: 0
    },
    {
      id: 40274,
      question: "What RDA value range is considered medium abrasive?",
      options: [
      "0-70 on the RDA scale",
      "71-100 on the RDA scale",
      "101-150 on the RDA scale",
      "151-250 on the RDA scale"
      ],
      correct: 1
    },
    {
      id: 40275,
      question: "What RDA value range is considered highly abrasive?",
      options: [
      "50-100 on the RDA scale",
      "71-100 on the RDA scale",
      "101-150 on the RDA scale",
      "151-200 on the RDA scale"
      ],
      correct: 2
    },
    {
      id: 40276,
      question: "What RDA value range is regarded as harmful limit?",
      options: [
      "100-150 on the RDA scale",
      "120-180 on the RDA scale",
      "151-250 on the RDA scale",
      "200-300 on the RDA scale"
      ],
      correct: 2
    },
    {
      id: 40277,
      question: "What is bioavailability in the context of dentifrices?",
      options: [
      "The amount of product needed per brushing",
      "When medicinal agent is stable during storage and biologically active in mouth",
      "The shelf life of the dentifrice",
      "The cost per use of the dentifrice"
      ],
      correct: 1
    },
    {
      id: 40278,
      question: "What ingredient increases the bioavailability of fluoride ions?",
      options: [
      "Sodium lauryl sulfate in high concentrations",
      "Cocamidopropyl betaine in the formulation",
      "Calcium carbonate as an abrasive",
      "Preservatives and coloring agents"
      ],
      correct: 1
    },
    {
      id: 40279,
      question: "What factors affect fluoride bioavailability in dentifrices?",
      options: [
      "Only the brand name and marketing",
      "Type of fluoride, type of abrasive, pH level, presence of SLS",
      "Only the expiration date",
      "The color and flavor of the dentifrice"
      ],
      correct: 1
    },
    {
      id: 40280,
      question: "What is the bioavailability percentage of Colgate Cavity Protection with 1450 ppm MFP/NaF?",
      options: [
      "45.2% bioavailability of fluoride",
      "57.8% bioavailability of fluoride",
      "70.6% bioavailability of fluoride",
      "86.5% bioavailability of fluoride"
      ],
      correct: 1
    },
    {
      id: 40281,
      question: "Which product shows the highest fluoride bioavailability percentage?",
      options: [
      "Colgate Total with 1450 ppm NaF",
      "Elmex Sensitive with 1400 ppm AmF",
      "Crest Cavity Protection with 1100 ppm NaF",
      "Solidox with 1000 ppm SnF2"
      ],
      correct: 2
    },
    {
      id: 40282,
      question: "What adverse effect can fluoride cause when ingested during tooth development?",
      options: [
      "Increased tooth sensitivity to cold",
      "Fluorosis affecting enamel appearance",
      "Accelerated tooth decay",
      "Gingival inflammation and bleeding"
      ],
      correct: 1
    },
    {
      id: 40283,
      question: "What soft-tissue reaction can sodium lauryl sulfate cause?",
      options: [
      "Tooth enamel erosion",
      "Mucosal desquamation or ulceration",
      "Increased salivary flow",
      "Tooth whitening effects"
      ],
      correct: 1
    },
    {
      id: 40284,
      question: "What reactions can tartar control and herbal dentifrices cause?",
      options: [
      "Increased tooth strength and hardness",
      "Erythema, scaling, fissuring of perioral area, cheilitis, gingivitis",
      "Accelerated remineralization of enamel",
      "Reduced plaque accumulation"
      ],
      correct: 1
    },
    {
      id: 40285,
      question: "What is cheilitis?",
      options: [
      "Inflammation of the gingival tissues",
      "Inflamed lips with eczema-like symptoms",
      "Loss of tooth structure from acids",
      "Excessive salivary production"
      ],
      correct: 1
    },
    {
      id: 40286,
      question: "What is stomatitis?",
      options: [
      "Tooth sensitivity to temperature changes",
      "Inflamed mouth affecting gums, tongue, causing burning, swelling, peeling",
      "Discoloration of tooth enamel",
      "Excessive tooth wear from grinding"
      ],
      correct: 1
    },
    {
      id: 40287,
      question: "What are the main components that determine dentifrice abrasiveness?",
      options: [
      "Color and flavor only",
      "Insoluble materials and soluble materials",
      "Water content and preservatives",
      "Packaging type and dispenser design"
      ],
      correct: 1
    },
    {
      id: 40288,
      question: "What is the advantage of higher levels of abrasives (>2%)?",
      options: [
      "Reduce cost of the product",
      "Remove more biofilm and acquire pellicle faster",
      "Increase fluoride penetration",
      "Provide better taste"
      ],
      correct: 1
    },
    {
      id: 40289,
      question: "What is the disadvantage of higher levels of abrasives (>2%)?",
      options: [
      "Reduce the shelf life of the product",
      "Can increase abrasion and cause hypersensitivity",
      "Decrease cleaning effectiveness",
      "Make the dentifrice less appealing"
      ],
      correct: 1
    },
    {
      id: 40290,
      question: "What percentage of dentifrices do not risk damaging dentin or exposing cementum?",
      options: [
      "50% fall below 2% abrasiveness",
      "72% fall below 2% abrasiveness",
      "85% fall below 2% abrasiveness",
      "95% fall below 2% abrasiveness"
      ],
      correct: 1
    },
    {
      id: 40291,
      question: "What is the majority pH characteristic of most dentifrices?",
      options: [
      "Most dentifrices have an acidic pH",
      "The majority of dentifrices have a neutral pH",
      "Most dentifrices have a highly alkaline pH",
      "Dentifrice pH varies randomly with no pattern"
      ],
      correct: 1
    },
    {
      id: 40292,
      question: "What is an advantage of low pH in dentifrices?",
      options: [
      "Prevents bacterial growth in the tube",
      "Formation of fluorapatite crystals",
      "Increases foaming action",
      "Improves flavor stability"
      ],
      correct: 1
    },
    {
      id: 40293,
      question: "What pH level is considered problematic for exposed root surfaces?",
      options: [
      "pH above 7.5 causes demineralization",
      "pH of less than 6.5 causes erosion",
      "pH between 6.5 and 7.5 is harmful",
      "pH below 5.0 is optimal"
      ],
      correct: 1
    },
    {
      id: 40294,
      question: "What is the average pH threshold for cementum and dentin demineralization?",
      options: [
      "Average pH of 7.5 on surfaces",
      "Average pH of 6.5 on cementum and dentin",
      "Average pH of 5.5 on surfaces",
      "Average pH of 4.5 on surfaces"
      ],
      correct: 1
    },
    {
      id: 40295,
      question: "What is the pH threshold for enamel (hydroxyapatite) demineralization?",
      options: [
      "pH of 7.0 on enamel",
      "pH of 5.5 on enamel",
      "pH of 4.5 on enamel",
      "pH of 3.5 on enamel"
      ],
      correct: 1
    },
    {
      id: 40296,
      question: "What is the pH threshold for fluorapatite enamel demineralization?",
      options: [
      "pH of 5.5 on fluorapatite",
      "pH of 4.5 on fluorapatite enamel",
      "pH of 3.5 on fluorapatite",
      "pH of 6.5 on fluorapatite"
      ],
      correct: 1
    },
    {
      id: 40297,
      question: "What is erosion in the context of tooth structure loss?",
      options: [
      "Tooth wear from tooth-to-tooth contact",
      "Dissolution of organic and inorganic tooth structure from chemical agents",
      "Loss from high occlusal load stress",
      "Wear from foreign substances harder than tooth"
      ],
      correct: 1
    },
    {
      id: 40298,
      question: "What is abrasion in dental terms?",
      options: [
      "Chemical dissolution of tooth structure",
      "Pathologic tooth wear from foreign substance harder than tooth structure",
      "Loss from occlusal stress and load",
      "Normal wear from chewing function"
      ],
      correct: 1
    },
    {
      id: 40299,
      question: "What is abfraction?",
      options: [
      "Tooth wear from acidic beverages",
      "Cervical tooth structure loss from high occlusal load causing cracking",
      "Tooth wear from toothbrush abrasion",
      "Chemical erosion from gastric acid"
      ],
      correct: 1
    },
    {
      id: 40300,
      question: "What is attrition?",
      options: [
      "Chemical erosion from acidic foods",
      "Loss of tooth structure from tooth-to-tooth contact friction",
      "Wear from improper brushing technique",
      "Loss from periodontal disease"
      ],
      correct: 1
    },
    {
      id: 40301,
      question: "What is a risk of using peroxide-containing toothpaste daily?",
      options: [
      "Increased fluoride uptake in enamel",
      "Increases risk of tooth surface erosion over time",
      "Accelerated calculus formation",
      "Improved gingival health"
      ],
      correct: 1
    },
    {
      id: 40302,
      question: "What diverse factors contribute to loss of tooth structure?",
      options: [
      "Only genetic predisposition",
      "Type of dentifrice, brushing frequency, filament hardness, pressure, direction",
      "Only dietary habits",
      "Only age-related factors"
      ],
      correct: 1
    },
    {
      id: 40303,
      question: "Why are dentifrices not easily compared?",
      options: [
      "All use identical testing protocols",
      "Various methods used to evaluate abrasiveness, different protocols",
      "All have the same ingredients",
      "Cost is the only variable"
      ],
      correct: 1
    },
    {
      id: 40304,
      question: "What should be assessed before making a dentifrice recommendation?",
      options: [
      "Only the patient's age",
      "Client's health, dental, and pharmacologic histories",
      "Only the patient's income level",
      "Only the patient's geographic location"
      ],
      correct: 1
    },
    {
      id: 40305,
      question: "What should be considered along with client histories when recommending dentifrices?",
      options: [
      "Office inventory levels only",
      "Client's assessed needs and expectations as well as product evidence",
      "Only manufacturer recommendations",
      "Only advertising claims"
      ],
      correct: 1
    },
    {
      id: 40306,
      question: "What type of products should be recommended to clients?",
      options: [
      "Only the least expensive options",
      "Products approved by ADA or CDA with FDA-approved ingredients",
      "Only products advertised on television",
      "Only products the dentist personally uses"
      ],
      correct: 1
    },
    {
      id: 40307,
      question: "What is a legal and ethical responsibility regarding dentifrice recommendations?",
      options: [
      "Verbal recommendations are sufficient",
      "Document recommendations in the client's record",
      "Only document if the patient asks",
      "Documentation is optional"
      ],
      correct: 1
    },
    {
      id: 40308,
      question: "Which therapeutic agent category includes fluoride and antimicrobial components?",
      options: [
      "Desensitizing agents for hypersensitivity",
      "Anticaries agents targeting caries pathogens",
      "Antigingivitis agents like triclosan",
      "Anticalculus agents with pyrophosphate"
      ],
      correct: 1
    },
    {
      id: 40309,
      question: "What are examples of antigingivitis agents in dentifrices?",
      options: [
      "Fluoride and calcium compounds",
      "Triclosan and chlorhexidine gluconate (CHG)",
      "Hydrogen peroxide and baking soda",
      "Potassium nitrate and stannous fluoride"
      ],
      correct: 1
    },
    {
      id: 40310,
      question: "What is the anticalculus agent commonly used in dentifrices?",
      options: [
      "Sodium fluoride for prevention",
      "Pyrophosphate to prevent calculus formation",
      "Triclosan for bacterial control",
      "Hydrogen peroxide for stain removal"
      ],
      correct: 1
    },
    {
      id: 40311,
      question: "What are examples of antistain agents in dentifrices?",
      options: [
      "Fluoride, chlorhexidine, and triclosan",
      "Hydrogen peroxide, sodium bicarbonate, and abrasives",
      "Potassium compounds and calcium",
      "Enzymes and lubricants"
      ],
      correct: 1
    },
    {
      id: 40312,
      question: "What type of dentifrice is recommended for patients with low carious risk?",
      options: [
      "High-concentration fluoride only",
      "Fluoride 1000 ppm or fluoride-free options with CPP and ACP",
      "Antibacterial dentifrices exclusively",
      "Whitening dentifrices with peroxide"
      ],
      correct: 1
    },
    {
      id: 40313,
      question: "What fluoride concentration is recommended for moderate carious risk?",
      options: [
      "500 ppm fluoride concentration",
      "Fluoride (SnF2, NaF, MFP, AmF) around 1000-1500 ppm",
      "2500 ppm fluoride concentration",
      "Fluoride-free formulations only"
      ],
      correct: 1
    },
    {
      id: 40314,
      question: "What is recommended for patients with high carious risk?",
      options: [
      "No fluoride, only abrasives",
      "1500 ppm fluoride concentration minimum",
      "500 ppm fluoride maximum",
      "Fluoride-free with calcium only"
      ],
      correct: 1
    },
    {
      id: 40315,
      question: "What is recommended for extreme carious risk or vulnerable patients?",
      options: [
      "Standard 1000 ppm fluoride",
      "High remineralizing ingredients: 5000 ppm + Ca2+ and CPP-ACP + Fluoride",
      "Fluoride-free products only",
      "Whitening products with peroxide"
      ],
      correct: 1
    },
    {
      id: 40316,
      question: "What instruction is given for patients using high-concentration fluoride dentifrices?",
      options: [
      "Rinse immediately after brushing",
      "Spit, do not rinse, wait 30 minutes before eating or drinking",
      "Swallow the dentifrice after brushing",
      "Use twice the normal amount"
      ],
      correct: 1
    },
    {
      id: 40317,
      question: "What is the recommended fluoride concentration range for children's dentifrices like Pronamel?",
      options: [
      "500-750 ppm fluoride",
      "0.254% Sodium fluoride (approximately 1000-1150 ppm)",
      "2000-2500 ppm fluoride",
      "Fluoride-free formulation"
      ],
      correct: 1
    },
    {
      id: 40318,
      question: "What age group is Pronamel for Children designed for?",
      options: [
      "Ages 2-5 years old",
      "Ages 6+ years old",
      "Ages 12+ years old",
      "All ages including infants"
      ],
      correct: 1
    },
    {
      id: 40319,
      question: "What is the primary feature of Sensodyne Rapid Relief?",
      options: [
      "Maximum whitening capability",
      "Dentin hypersensitivity relief in 60 seconds with speed technology",
      "Anticaries protection only",
      "Plaque removal exclusively"
      ],
      correct: 1
    },
    {
      id: 40320,
      question: "What percentage and type of fluoride does Sensodyne Rapid Relief contain?",
      options: [
      "0.254% sodium fluoride",
      "0.454% stannous fluoride",
      "1.0% sodium fluoride",
      "0.76% sodium monofluorophosphate"
      ],
      correct: 1
    },
    {
      id: 40321,
      question: "What is the minimum age for using Sensodyne Rapid Relief?",
      options: [
      "6 years and older",
      "12 years and older",
      "18 years and older",
      "3 years and older"
      ],
      correct: 1
    },
    {
      id: 40322,
      question: "What unique ingredient technology does Sensodyne Repair & Protect contain?",
      options: [
      "Hydrogen peroxide whitening system",
      "5% Calcium sodium phosphosilicate (NovaMin®)",
      "Triclosan antibacterial agent",
      "Maximum abrasive particles"
      ],
      correct: 1
    },
    {
      id: 40323,
      question: "A dentifrice is used only for cleaning teeth and has no therapeutic purposes.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40324,
      question: "Dentifrices have cosmetic, hygienic, and therapeutic effects.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40325,
      question: "Nonfoaming to low-foaming dentifrices are recommended for use with power toothbrushes.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40326,
      question: "Ingestible dentifrices are specifically designed for persons with special needs.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40327,
      question: "All dentifrices contain sodium lauryl sulfate as a required ingredient.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40328,
      question: "Fluoride in dentifrices helps prevent caries and remineralize teeth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40329,
      question: "Amorphous calcium phosphate is used to control dentinal hypersensitivity.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40330,
      question: "Before recommending a dentifrice, dental hygienists should check the patient's medical history.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40331,
      question: "Dentifrice recommendations do not need to be documented in patient records.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40332,
      question: "The patient's signature confirms understanding and acceptance of dentifrice recommendations.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40333,
      question: "Organic or bio dentifrices must not contain animal ingredients.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40334,
      question: "Vegan dentifrices can contain animal-derived ingredients.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40335,
      question: "Biodegradable dentifrices must not include polluting ingredients.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40336,
      question: "The orifice of the toothpaste tube can be a source of cross-contamination.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40337,
      question: "Sharing toothpaste tubes between family members is recommended for cost savings.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40338,
      question: "Toothpaste tube contamination can transmit hepatitis B and gastroenteritis.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40339,
      question: "Each family member should have their own tube of toothpaste.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40340,
      question: "Water makes up 20% to 30% of dentifrice composition.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40341,
      question: "Tablet dentifrices contain the same amount of water as paste dentifrices.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40342,
      question: "Preservatives in dentifrices inhibit mold and bacterial growth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40343,
      question: "Binders are thickeners that prevent separation of ingredients.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40344,
      question: "Detergents in dentifrices act as foaming agents to loosen debris.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40345,
      question: "Copolymers increase substantivity, extending duration in the mouth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40346,
      question: "Medicinal ingredients are intended to produce therapeutic effects on oral tissues.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40347,
      question: "Nonmedicinal ingredients provide flavor, color, or consistency to dentifrices.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40348,
      question: "The five common dentifrice abrasives include phosphates, carbonates, silicas, aluminum compounds, and other substances.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40349,
      question: "Phosphates help whiten teeth and make them feel clean.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40350,
      question: "Carbonates help clean and deodorize the mouth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40351,
      question: "Silicas are chemically compatible with NaF and MFP fluoride compounds.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40352,
      question: "Alumina and aluminum compounds have low abrasive potential.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40353,
      question: "Cementum and dentin have a hardness of 2 to 2.5 on the Mohs scale.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40354,
      question: "Enamel has a hardness of 4 to 5 on the Mohs scale.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40355,
      question: "72% of dentifrices fall below 2% on the abrasiveness scale.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40356,
      question: "The Relative Dentin Abrasivity (RDA) Scale measures dentifrice abrasiveness.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40357,
      question: "An RDA value of 0-70 is considered low abrasive.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40358,
      question: "An RDA value of 71-100 is considered medium abrasive.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40359,
      question: "An RDA value of 101-150 is considered highly abrasive.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40360,
      question: "An RDA value of 151-250 is regarded as harmful limit.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40361,
      question: "Bioavailability occurs when the medicinal agent is stable during storage and biologically active in the mouth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40362,
      question: "Cocamidopropyl betaine decreases the bioavailability of fluoride ions.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40363,
      question: "The type of abrasive used affects fluoride bioavailability.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40364,
      question: "The pH level of a dentifrice affects fluoride bioavailability.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40365,
      question: "Sodium lauryl sulfate (SLS) presence affects fluoride bioavailability.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40366,
      question: "Fluoride ingested during tooth development can cause fluorosis.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40367,
      question: "Sodium lauryl sulfate can cause mucosal desquamation or ulceration.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40368,
      question: "Essential oils in dentifrices can cause cheilitis or circumoral dermatitis.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40369,
      question: "The majority of dentifrices have a neutral pH.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40370,
      question: "Low pH dentifrices promote the formation of fluorapatite crystals.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40371,
      question: "A pH of less than 6.5 can cause erosion of dentin and cementum.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40372,
      question: "Low pH dentifrices can tarnish titanium implants.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40373,
      question: "The average pH of 6.5 is the demineralization threshold for cementum and dentin.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40374,
      question: "Enamel (hydroxyapatite) demineralizes at pH of 5.5.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40375,
      question: "Fluorapatite enamel demineralizes at pH of 4.5.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40376,
      question: "Erosion is the dissolution of tooth structure from chemical agents.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40377,
      question: "Abrasion is pathologic tooth wear from substances harder than the tooth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40378,
      question: "Abfraction is caused by high occlusal load causing cervical cracking.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40379,
      question: "Attrition is loss of tooth structure from tooth-to-tooth contact.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40380,
      question: "Using peroxide-containing toothpaste daily increases the risk of tooth erosion.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40381,
      question: "Type of dentifrice used affects loss of tooth structure.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40382,
      question: "Brushing frequency contributes to tooth structure loss.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40383,
      question: "Toothbrush filament hardness affects tooth abrasion.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40384,
      question: "Pressure during brushing can cause tooth structure loss.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40385,
      question: "The direction of brush strokes influences tooth abrasion.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40386,
      question: "Manual and powered toothbrushes have the same abrasive effect.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40387,
      question: "Insufficient salivary flow can contribute to tooth structure loss.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40388,
      question: "Dentifrices are easily compared because all use the same evaluation methods.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40389,
      question: "Manufacturers use different protocols making direct dentifrice comparisons difficult.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40390,
      question: "Comparing dentifrices is important for confident recommendations.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40391,
      question: "Client's health, dental, and pharmacologic histories should be assessed before recommending dentifrices.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40392,
      question: "Client's assessed needs and expectations should be considered when recommending dentifrices.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40393,
      question: "Only ADA or CDA approved products with FDA-approved ingredients should be recommended.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40394,
      question: "Documentation of dentifrice recommendations in the client's record is required.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40395,
      question: "Anticaries agents include fluoride and antimicrobial components targeting caries pathogens.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40396,
      question: "Triclosan and chlorhexidine gluconate are antigingivitis agents.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40397,
      question: "Pyrophosphate is used as an anticalculus agent.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40398,
      question: "Hydrogen peroxide, sodium bicarbonate, and abrasives are antistain agents.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40399,
      question: "For low carious risk, fluoride 1000 ppm or fluoride-free options are recommended.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40400,
      question: "For moderate carious risk, 1000-1500 ppm fluoride is recommended.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40401,
      question: "For high carious risk, at least 1500 ppm fluoride is recommended.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40402,
      question: "For extreme carious risk, 5000 ppm with calcium and CPP-ACP plus fluoride is recommended.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40403,
      question: "Patients using high-concentration fluoride should spit and not rinse after brushing.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40404,
      question: "Patients should wait 30 minutes before eating or drinking after using high-concentration fluoride.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    }
  ],
  "4. Mouthrinse Comparison": [
    {
      id: 40405,
      question: "What is the primary purpose of therapeutic mouthrinses according to the presentation?",
      options: [
      "To whiten teeth and freshen breath temporarily",
      "To improve gingival health and help prevent dental caries",
      "To replace the need for regular brushing and flossing",
      "To serve as a cosmetic product for social situations"
      ],
      correct: 1
    },
    {
      id: 40406,
      question: "What are the two types of antimicrobial activity that therapeutic agents in mouthrinses can provide?",
      options: [
      "Antiseptic activity and antifungal activity",
      "Antibacterial activity and antiviral activity",
      "Bacteriostatic activity and bactericidal activity",
      "Prophylactic activity and therapeutic activity"
      ],
      correct: 2
    },
    {
      id: 40407,
      question: "What percentage of a typical mouthrinse formulation is water by volume?",
      options: [
      "Approximately 50% by volume",
      "Approximately 60% by volume",
      "Approximately 70% by volume",
      "Approximately 80% by volume"
      ],
      correct: 2
    },
    {
      id: 40408,
      question: "Which property of chlorhexidine is primarily responsible for its effectiveness as an antimicrobial agent?",
      options: [
      "Its ability to produce oxygen that kills bacteria",
      "Its low pH that inhibits bacterial growth",
      "Its high substantivity allowing prolonged release from dental surfaces",
      "Its enzymatic breakdown of bacterial cell walls"
      ],
      correct: 2
    },
    {
      id: 40409,
      question: "How does chlorhexidine achieve its antimicrobial effect according to the mechanism of action described?",
      options: [
      "It disrupts bacterial DNA replication and protein synthesis",
      "It ruptures bacterial cell membranes leading to cell death",
      "It prevents bacteria from adhering through enzymatic action",
      "It creates an alkaline environment hostile to bacteria"
      ],
      correct: 1
    },
    {
      id: 40410,
      question: "What is a significant drawback of chlorhexidine's cationic nature?",
      options: [
      "It increases the cost of manufacturing the product",
      "It causes allergic reactions in most users",
      "It may interact adversely with toothpastes and cause tooth staining",
      "It reduces the shelf life of the mouthrinse formulation"
      ],
      correct: 2
    },
    {
      id: 40411,
      question: "What is the typical concentration range of cetylpyridinium chloride (CPC) when used as an active ingredient in mouthrinses?",
      options: [
      "Approximately 0.07% by volume",
      "Approximately 0.12% by volume",
      "Approximately 0.20% by volume",
      "Approximately 0.50% by volume"
      ],
      correct: 0
    },
    {
      id: 40412,
      question: "According to the FDA, at what concentration level is CPC not considered an effective antiplaque/antigingivitis agent?",
      options: [
      "Below 0.025% by volume",
      "Below 0.045% by volume",
      "Below 0.065% by volume",
      "Below 0.085% by volume"
      ],
      correct: 1
    },
    {
      id: 40413,
      question: "How does the substantivity of CPC compare to chlorhexidine?",
      options: [
      "CPC has higher substantivity than chlorhexidine",
      "CPC has equal substantivity to chlorhexidine",
      "CPC has lower substantivity and desorbs more quickly than chlorhexidine",
      "CPC has no substantivity unlike chlorhexidine"
      ],
      correct: 2
    },
    {
      id: 40414,
      question: "How many different essential oils comprise the fixed combination used in essential oil mouthrinses?",
      options: [
      "Two different essential oils",
      "Three different essential oils",
      "Four different essential oils",
      "Five different essential oils"
      ],
      correct: 2
    },
    {
      id: 40415,
      question: "Which of the following is NOT one of the four essential oils mentioned in the presentation?",
      options: [
      "Thymol derived from herbs",
      "Menthol providing cooling sensation",
      "Peppermint oil for flavor",
      "Eucalyptol from eucalyptus"
      ],
      correct: 2
    },
    {
      id: 40416,
      question: "What is the primary mechanism by which essential oils achieve antimicrobial activity?",
      options: [
      "They create a physical barrier on tooth surfaces",
      "They nonselectively and rapidly disrupt bacterial cell walls",
      "They stimulate immune response in gingival tissues",
      "They increase saliva production to wash away bacteria"
      ],
      correct: 1
    },
    {
      id: 40417,
      question: "Beyond bactericidal activity, what additional capability have essential oil formulations demonstrated?",
      options: [
      "They can reverse existing periodontal disease",
      "They can remineralize tooth enamel",
      "They can penetrate plaque biofilm",
      "They can stimulate gum tissue regeneration"
      ],
      correct: 2
    },
    {
      id: 40418,
      question: "What is a key advantage of essential oils being nonionic compared to cationic antimicrobials?",
      options: [
      "They have stronger antimicrobial properties",
      "They work faster than cationic agents",
      "They do not adversely interact with dentifrices or produce significant staining",
      "They are less expensive to manufacture"
      ],
      correct: 2
    },
    {
      id: 40419,
      question: "What is the typical concentration range of flavoring agents in mouthrinse formulations?",
      options: [
      "0.1 - 0.4% by volume",
      "1.0 - 4.0% by volume",
      "5.0 - 10.0% by volume",
      "10.0 - 15.0% by volume"
      ],
      correct: 0
    },
    {
      id: 40420,
      question: "What is the primary role of alcohol in mouthrinse formulations?",
      options: [
      "To provide antimicrobial activity as the active ingredient",
      "To serve as a solvent and vehicle for active ingredients",
      "To add flavor and improve product acceptance",
      "To preserve the color of the mouthrinse"
      ],
      correct: 1
    },
    {
      id: 40421,
      question: "What is the typical concentration range of humectants in mouthrinse formulations?",
      options: [
      "1 - 5% by volume",
      "5 - 20% by volume",
      "20 - 40% by volume",
      "40 - 60% by volume"
      ],
      correct: 1
    },
    {
      id: 40422,
      question: "What is the primary purpose of humectants in mouthrinse formulations?",
      options: [
      "To kill bacteria and prevent plaque formation",
      "To add \"body\" to the liquid and provide cleanliness feeling",
      "To preserve the product from microbial contamination",
      "To enhance the flavor profile of the product"
      ],
      correct: 1
    },
    {
      id: 40423,
      question: "What role do surfactants play in mouthrinse formulations?",
      options: [
      "They provide the primary antimicrobial activity",
      "They add sweetness and improve taste",
      "They solubilize flavor oils and stabilize the formula",
      "They increase the viscosity of the liquid"
      ],
      correct: 2
    },
    {
      id: 40424,
      question: "Why is the correct selection of surfactant important in mouthrinse formulations?",
      options: [
      "It determines the color of the final product",
      "It may adversely interact with antimicrobial ingredients",
      "It affects the shelf life more than any other ingredient",
      "It determines whether the product needs refrigeration"
      ],
      correct: 1
    },
    {
      id: 40425,
      question: "According to the clinical efficacy data presented, which antimicrobial agent generally showed the highest percentage reduction in plaque?",
      options: [
      "Cetylpyridinium chloride at all concentrations",
      "Essential oils in all formulations tested",
      "Chlorhexidine, particularly at higher concentrations",
      "All agents showed equivalent efficacy"
      ],
      correct: 2
    },
    {
      id: 40426,
      question: "In the gingivitis reduction studies presented, what was the highest percentage reduction observed?",
      options: [
      "Approximately 40% reduction",
      "Approximately 60% reduction",
      "Approximately 80% reduction",
      "Approximately 100% reduction"
      ],
      correct: 2
    },
    {
      id: 40427,
      question: "What pathway does the FDA use to evaluate over-the-counter mouthrinse ingredients?",
      options: [
      "Clinical trial approval process",
      "Monograph system with ingredient categories",
      "Post-market surveillance only",
      "Accelerated approval pathway"
      ],
      correct: 1
    },
    {
      id: 40428,
      question: "Which antimicrobial agents have been recommended by an FDA advisory committee to be classified as safe and effective?",
      options: [
      "Chlorhexidine and triclosan",
      "Essential oils and cetylpyridinium chloride",
      "Hydrogen peroxide and zinc chloride",
      "Sodium fluoride and stannous fluoride"
      ],
      correct: 1
    },
    {
      id: 40429,
      question: "Through which FDA process has chlorhexidine been approved for use in mouthrinses?",
      options: [
      "Over-the-counter monograph process",
      "New Drug Application (NDA) process",
      "Generally Recognized as Safe (GRAS) determination",
      "Emergency Use Authorization process"
      ],
      correct: 1
    },
    {
      id: 40430,
      question: "According to ADA Seal of Acceptance guidelines, what is the minimum required gingivitis reduction in clinical trials?",
      options: [
      "An average of 15% reduction in one trial",
      "An average of 20% reduction in two six-month trials",
      "An average of 25% reduction in three trials",
      "An average of 30% reduction in one year-long trial"
      ],
      correct: 1
    },
    {
      id: 40431,
      question: "What must manufacturers demonstrate regarding plaque reduction to meet ADA Seal criteria?",
      options: [
      "Any measurable reduction in plaque levels",
      "Complete elimination of all plaque",
      "Statistically significant quantitative reductions in plaque or plaque pathogenicity",
      "Plaque reduction equal to professional cleaning"
      ],
      correct: 2
    },
    {
      id: 40432,
      question: "Which of the following is a safety criterion for the ADA Seal of Acceptance?",
      options: [
      "The product must be alcohol-free",
      "Pathogenic microorganisms must not develop during the study",
      "The product must contain natural ingredients only",
      "The product must be approved for children under age 6"
      ],
      correct: 1
    },
    {
      id: 40433,
      question: "Which antimicrobial mouthrinse formulations have earned the ADA Seal of Acceptance?",
      options: [
      "Only prescription chlorhexidine products",
      "Only cetylpyridinium chloride products",
      "Products containing fixed combination of essential oils and chlorhexidine",
      "All antimicrobial mouthrinses on the market"
      ],
      correct: 2
    },
    {
      id: 40434,
      question: "Why do chlorhexidine mouthrinses no longer carry the ADA Seal of Acceptance?",
      options: [
      "They failed to meet safety standards",
      "The seal program was discontinued for prescription products",
      "They were found to be ineffective",
      "Manufacturers chose not to renew their applications"
      ],
      correct: 1
    },
    {
      id: 40435,
      question: "What specific advantage does chlorhexidine's mechanism of action provide?",
      options: [
      "It only targets harmful bacteria",
      "It binds to salivary mucins reducing pellicle and bacterial colony formation",
      "It stimulates natural immune defenses",
      "It changes the pH of the oral cavity"
      ],
      correct: 1
    },
    {
      id: 40436,
      question: "What additional antimicrobial activities do essential oils exhibit beyond cell wall disruption?",
      options: [
      "They only disrupt cell walls",
      "They include protein denaturation and enzyme activity alteration",
      "They primarily work through pH modification",
      "They function exclusively through oxygen generation"
      ],
      correct: 1
    },
    {
      id: 40437,
      question: "How do essential oils affect pioneer plaque bacteria according to research cited?",
      options: [
      "They have no effect on pioneer bacteria",
      "They completely eliminate all pioneer bacteria",
      "They affect the growth rate of pioneer plaque bacteria",
      "They only affect mature plaque bacteria"
      ],
      correct: 2
    },
    {
      id: 40438,
      question: "What effect do essential oils have on bacterial co-aggregation?",
      options: [
      "They promote beneficial bacterial aggregation",
      "They have no effect on aggregation",
      "They interfere with co-aggregation of oral bacteria",
      "They only affect aggregation in mature biofilms"
      ],
      correct: 2
    },
    {
      id: 40439,
      question: "In what way do essential oils demonstrate anti-inflammatory properties?",
      options: [
      "By stimulating white blood cell production",
      "By reducing tissue swelling only",
      "Through exhibition of anti-inflammatory properties and neutrophil function alteration",
      "By increasing blood flow to affected areas"
      ],
      correct: 2
    },
    {
      id: 40440,
      question: "What percentage of mouthrinse formulations typically consists of surfactants?",
      options: [
      "0 - 1% by volume",
      "5 - 10% by volume",
      "10 - 20% by volume",
      "20 - 30% by volume"
      ],
      correct: 0
    },
    {
      id: 40441,
      question: "What happens to chlorhexidine when it encounters anionic compounds in dentifrices?",
      options: [
      "It becomes more effective",
      "It may become inactivated",
      "It changes color but remains effective",
      "It has no interaction"
      ],
      correct: 1
    },
    {
      id: 40442,
      question: "According to the presentation, what causes tooth staining with cationic antimicrobials?",
      options: [
      "Direct pigmentation of tooth enamel",
      "Precipitation of negatively charged dietary chromogens",
      "Chemical reaction with fluoride",
      "Accumulation of the antimicrobial agent itself"
      ],
      correct: 1
    },
    {
      id: 40443,
      question: "What is described as a \"timed release of the antimicrobial\" in the presentation?",
      options: [
      "The manufacturing process of adding ingredients",
      "The desorption of chlorhexidine from dental surfaces over time",
      "The gradual dissolution of the mouthrinse bottle material",
      "The scheduled dosing regimen recommended for patients"
      ],
      correct: 1
    },
    {
      id: 40444,
      question: "To what surfaces does chlorhexidine adsorb according to the presentation?",
      options: [
      "Only to tooth enamel surfaces",
      "Only to bacterial cell surfaces",
      "To glycoproteins and phosphoproteins on teeth and mucous membranes",
      "Only to dental restorations"
      ],
      correct: 2
    },
    {
      id: 40445,
      question: "What is the main difference in desorption rate between CPC and chlorhexidine?",
      options: [
      "They have identical desorption rates",
      "CPC releases much faster resulting in lower clinical effectiveness",
      "CPC releases slower providing longer protection",
      "Desorption rate is not relevant to effectiveness"
      ],
      correct: 1
    },
    {
      id: 40446,
      question: "According to the quick reference guide, what is the substantivity level of essential oils?",
      options: [
      "High substantivity comparable to chlorhexidine",
      "Moderate substantivity between CPC and chlorhexidine",
      "Negligible substantivity",
      "Variable substantivity depending on formulation"
      ],
      correct: 2
    },
    {
      id: 40447,
      question: "What common property do both chlorhexidine and CPC share that affects their use?",
      options: [
      "They are both nonionic compounds",
      "They are both cationic leading to interactions and staining potential",
      "They both have negligible substantivity",
      "They both require prescription authorization"
      ],
      correct: 1
    },
    {
      id: 40448,
      question: "How many six-month clinical trials meet ADA guidelines for essential oil mouthrinses according to the presentation?",
      options: [
      "Two clinical trials",
      "Four clinical trials",
      "More than six clinical trials",
      "Ten clinical trials"
      ],
      correct: 2
    },
    {
      id: 40449,
      question: "Which statement best describes the manufacturer's variety of mouthrinse products available?",
      options: [
      "Only one type of antimicrobial mouthrinse exists",
      "Manufacturers produce and market a variety of mouthrinses",
      "All mouthrinses contain identical formulations",
      "Only prescription mouthrinses show variety"
      ],
      correct: 1
    },
    {
      id: 40450,
      question: "What challenge do patients face when selecting mouthrinses according to the presentation?",
      options: [
      "All products work equally well",
      "Difficulty in selecting the appropriate mouthrinse due to variety",
      "Limited availability of products",
      "Excessive cost of all products"
      ],
      correct: 1
    },
    {
      id: 40451,
      question: "Why must dental practitioners have fundamental understanding of mouthrinse formulations?",
      options: [
      "To manufacture their own products",
      "To properly advise their patients",
      "To meet licensing requirements",
      "To reduce insurance costs"
      ],
      correct: 1
    },
    {
      id: 40452,
      question: "What type of product development process applies to essential oils and CPC according to FDA classification?",
      options: [
      "Prescription drug approval",
      "Medical device approval",
      "Over-the-counter ingredient evaluation",
      "Supplement registration"
      ],
      correct: 2
    },
    {
      id: 40453,
      question: "What clinical duration was used for most of the efficacy studies cited in the presentation?",
      options: [
      "Three-month clinical trials",
      "Six-month clinical trials",
      "Nine-month clinical trials",
      "Twelve-month clinical trials"
      ],
      correct: 1
    },
    {
      id: 40454,
      question: "In terms of plaque reduction, what was the approximate range of effectiveness shown by chlorhexidine in the studies?",
      options: [
      "5-25% reduction",
      "15-65% reduction",
      "70-85% reduction",
      "90-100% reduction"
      ],
      correct: 1
    },
    {
      id: 40455,
      question: "What was the approximate range of gingivitis reduction shown by essential oils in the studies presented?",
      options: [
      "5-15% reduction",
      "10-35% reduction",
      "40-60% reduction",
      "65-80% reduction"
      ],
      correct: 1
    },
    {
      id: 40456,
      question: "According to the presentation disclaimer, what should be noted about essential oils in current formulas?",
      options: [
      "All essential oils are synthetic",
      "Not all essential oils in current formulas are natural ingredients",
      "All essential oils are natural ingredients",
      "Essential oils are only used for fragrance"
      ],
      correct: 1
    },
    {
      id: 40457,
      question: "What electron microscopy evidence was presented regarding mouthrinse effectiveness?",
      options: [
      "Increased biofilm formation after rinsing",
      "No visible change in bacterial presence",
      "Reduced bacterial presence after rinsing compared to before",
      "Complete elimination of all oral bacteria"
      ],
      correct: 2
    },
    {
      id: 40458,
      question: "What organization created the educational tools package presented in this document?",
      options: [
      "American Dental Association",
      "Food and Drug Administration",
      "Johnson & Johnson Healthcare Products Division of McNEIL-PPC, Inc.",
      "National Institutes of Health"
      ],
      correct: 2
    },
    {
      id: 40459,
      question: "Therapeutic mouthrinses are designed only to freshen breath and have no impact on gingival health or caries prevention.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40460,
      question: "Water typically comprises approximately 70% of a mouthrinse formulation by volume.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40461,
      question: "Both active and inactive ingredients are present in therapeutic mouthrinses.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40462,
      question: "The purpose of inactive ingredients includes helping deliver therapeutic agents and assisting with patient acceptance.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40463,
      question: "Chlorhexidine, cetylpyridinium chloride, and essential oils all have identical chemical structures and mechanisms of action.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40464,
      question: "Chlorhexidine demonstrates high substantivity which contributes to its prolonged antimicrobial effect.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40465,
      question: "Cationic antimicrobials like chlorhexidine and CPC may interact adversely with anionic compounds in some dentifrices.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40466,
      question: "Cetylpyridinium chloride at concentrations below 0.045% is considered by the FDA to be an effective antiplaque/antigingivitis agent.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40467,
      question: "The substantivity of CPC is comparable to or higher than chlorhexidine.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40468,
      question: "Essential oils consist of a fixed combination of exactly four different oils with antimicrobial properties.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40469,
      question: "Menthol, methyl salicylate, thymol, and eucalyptol are the four components of the essential oil combination.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40470,
      question: "Essential oils achieve antimicrobial activity by selectively targeting only harmful bacteria.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40471,
      question: "Essential oil formulations have demonstrated the ability to penetrate plaque biofilm.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40472,
      question: "Essential oils are nonionic, meaning they do not have significant interactions with toothpastes or produce significant staining.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40473,
      question: "Flavoring agents in mouthrinses serve only to improve taste and have no antimicrobial properties.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40474,
      question: "Alcohol in mouthrinse formulations acts primarily as a solvent and vehicle for delivering active ingredients.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40475,
      question: "Humectants typically comprise 5-20% of mouthrinse formulation by volume.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40476,
      question: "Surfactants play no role in stabilizing mouthrinse formulations.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40477,
      question: "According to the clinical data presented, chlorhexidine generally demonstrated the highest percentage reductions in plaque among the antimicrobials studied.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40478,
      question: "All antimicrobial mouthrinse ingredients are evaluated through the same FDA approval pathway.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40479,
      question: "An FDA advisory committee has recommended that essential oils and CPC be classified as safe and effective.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40480,
      question: "Chlorhexidine has been approved through the FDA's New Drug Application process.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40481,
      question: "To meet ADA Seal of Acceptance guidelines, a mouthrinse must demonstrate an average gingivitis reduction of 20% in two six-month trials.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40482,
      question: "Products containing the fixed combination of essential oils have earned the ADA Seal of Acceptance.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40483,
      question: "Chlorhexidine mouthrinse formulations currently carry the ADA Seal of Acceptance.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40484,
      question: "The ADA Seal program was recently discontinued for prescription and professional products.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40485,
      question: "All antimicrobial mouthrinses are formulated with identical ingredients and demonstrate the same clinical efficacy.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40486,
      question: "Chlorhexidine binds to salivary mucins, which helps reduce pellicle formation and bacterial colony development.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40487,
      question: "Essential oils have been shown to affect the growth rate of pioneer plaque bacteria.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40488,
      question: "The ionic charge of an antimicrobial agent has no impact on its interaction with other oral care products.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40489,
      question: "Tooth staining from cationic antimicrobials is caused by precipitation of negatively charged dietary chromogens.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40490,
      question: "The desorption of chlorhexidine from dental surfaces over time has been described as a \"timed release of the antimicrobial.\"",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40491,
      question: "CPC desorbs from oral surfaces at approximately the same rate as chlorhexidine.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40492,
      question: "Essential oils demonstrate negligible substantivity compared to chlorhexidine.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40493,
      question: "Both chlorhexidine and CPC are cationic compounds which can lead to interactions with toothpastes and potential staining.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40494,
      question: "More than six clinical trials supporting essential oil mouthrinses meet ADA guidelines according to the presentation.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40495,
      question: "Patients find it easy to select the appropriate mouthrinse due to clear labeling and limited product variety.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40496,
      question: "Dental practitioners need fundamental understanding of mouthrinse formulations to properly advise their patients.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40497,
      question: "All antimicrobial mouthrinses require prescription authorization for purchase.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40498,
      question: "Most efficacy studies cited in the presentation were six-month clinical trials.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40499,
      question: "The presentation states that all essential oils in current mouthrinse formulas are natural ingredients.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40500,
      question: "Electron microscopy evidence showed reduced bacterial presence after rinsing with antimicrobial mouthrinses.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    }
  ],
  "4. Sensodyne ProNamel Product Table": [
    {
      id: 40501,
      question: "What is the minimum age recommendation for ProNamel for Children?",
      options: [
      "6 years and older",
      "8 years and older",
      "10 years and older",
      "12 years and older"
      ],
      correct: 0
    },
    {
      id: 40502,
      question: "Which product is described as having \"our most advanced enamel care formulation\"?",
      options: [
      "ProNamel for Children",
      "Sensodyne Fresh Mint",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Rapid Relief"
      ],
      correct: 2
    },
    {
      id: 40503,
      question: "What is the active ingredient concentration of sodium fluoride in ProNamel for Children?",
      options: [
      "0.2299% sodium fluoride",
      "0.454% sodium fluoride",
      "0.254% sodium fluoride",
      "5% sodium fluoride"
      ],
      correct: 2
    },
    {
      id: 40504,
      question: "Which product contains NovaMin® technology as its primary active ingredient?",
      options: [
      "Sensodyne Fresh Mint",
      "Sensodyne Repair & Protect",
      "Sensodyne Sensitivity & Gum",
      "ProNamel Intensive Enamel Repair"
      ],
      correct: 1
    },
    {
      id: 40505,
      question: "How quickly does Sensodyne Rapid Relief provide dentin hypersensitivity relief when used as directed?",
      options: [
      "Within 30 seconds",
      "Within 45 seconds",
      "Within 60 seconds",
      "Within 90 seconds"
      ],
      correct: 2
    },
    {
      id: 40506,
      question: "What is the concentration of potassium nitrate in Sensodyne Fresh Mint?",
      options: [
      "2.5% potassium nitrate",
      "5% potassium nitrate",
      "7.5% potassium nitrate",
      "10% potassium nitrate"
      ],
      correct: 1
    },
    {
      id: 40507,
      question: "Which product is specifically formulated to provide dual relief of dentin hypersensitivity and gingivitis?",
      options: [
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief",
      "Sensodyne Repair & Protect",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 3
    },
    {
      id: 40508,
      question: "What is the minimum age recommendation for Sensodyne Rapid Relief?",
      options: [
      "6 years and older",
      "8 years and older",
      "10 years and older",
      "12 years and older"
      ],
      correct: 3
    },
    {
      id: 40509,
      question: "Which patient profile best describes someone who would benefit from ProNamel Intensive Enamel Repair?",
      options: [
      "Children with strong healthy teeth",
      "Someone who frequently consumes acidic foods and beverages",
      "Someone with localized recently diagnosed sensitivity",
      "Someone with red swollen bleeding gums"
      ],
      correct: 1
    },
    {
      id: 40510,
      question: "What concentration of stannous fluoride is found in Sensodyne Rapid Relief?",
      options: [
      "0.254% stannous fluoride",
      "0.2299% stannous fluoride",
      "0.454% stannous fluoride",
      "5% stannous fluoride"
      ],
      correct: 2
    },
    {
      id: 40511,
      question: "Which product is specifically mentioned as helping relieve dentin hypersensitivity associated with professional whitening?",
      options: [
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Fresh Mint",
      "Sensodyne Repair & Protect",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 1
    },
    {
      id: 40512,
      question: "What is the concentration of calcium sodium phosphosilicate (NovaMin®) in Sensodyne Repair & Protect?",
      options: [
      "2.5% calcium sodium phosphosilicate",
      "5% calcium sodium phosphosilicate",
      "7.5% calcium sodium phosphosilicate",
      "10% calcium sodium phosphosilicate"
      ],
      correct: 1
    },
    {
      id: 40513,
      question: "Which product category does ProNamel for Children fall under?",
      options: [
      "Dentin hypersensitivity",
      "Gum problems",
      "Healthy teeth",
      "Professional whitening"
      ],
      correct: 2
    },
    {
      id: 40514,
      question: "What type of patient would most benefit from Sensodyne Rapid Relief?",
      options: [
      "Children with strong healthy teeth",
      "Someone with localized or recently diagnosed sensitivity wanting immediate relief",
      "Someone with generalized sensitivity and gingival recession",
      "Someone who frequently consumes acidic beverages"
      ],
      correct: 1
    },
    {
      id: 40515,
      question: "Which product helps control plaque buildup to improve gum health?",
      options: [
      "ProNamel for Children",
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 3
    },
    {
      id: 40516,
      question: "What is the sodium fluoride concentration in Sensodyne Repair & Protect?",
      options: [
      "0.254% sodium fluoride",
      "0.454% sodium fluoride",
      "0.2299% sodium fluoride",
      "5% sodium fluoride"
      ],
      correct: 2
    },
    {
      id: 40517,
      question: "Which product is described as \"engineered for speed\"?",
      options: [
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Repair & Protect"
      ],
      correct: 1
    },
    {
      id: 40518,
      question: "What patient characteristic is associated with someone who would benefit from Sensodyne Repair & Protect?",
      options: [
      "Frequently consumes acidic foods",
      "Has localized recently diagnosed sensitivity",
      "Has generalized sensitivity with gingival recession and exposed dentin",
      "Wants all benefits of regular toothpaste"
      ],
      correct: 2
    },
    {
      id: 40519,
      question: "Which two products share the same active ingredient combination of sodium fluoride and potassium nitrate?",
      options: [
      "ProNamel products only",
      "Sensodyne Fresh Mint and Sensodyne Rapid Relief",
      "Sensodyne Repair & Protect and Sensodyne Sensitivity & Gum",
      "ProNamel for Children and ProNamel Intensive Enamel Repair"
      ],
      correct: 1
    },
    {
      id: 40520,
      question: "What type of relief does Sensodyne Fresh Mint provide according to the product table?",
      options: [
      "Immediate 60-second relief",
      "24/7 dentin hypersensitivity relief with twice daily brushing",
      "Relief of gingivitis symptoms",
      "Relief from acid wear"
      ],
      correct: 1
    },
    {
      id: 40521,
      question: "Which product would be most appropriate for a patient with coexisting dentin hypersensitivity and gingivitis?",
      options: [
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief",
      "Sensodyne Repair & Protect",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 3
    },
    {
      id: 40522,
      question: "What is the active ingredient concentration in ProNamel Intensive Enamel Repair besides sodium fluoride?",
      options: [
      "2.5% potassium nitrate",
      "5% potassium nitrate",
      "0.454% stannous fluoride",
      "5% calcium sodium phosphosilicate"
      ],
      correct: 1
    },
    {
      id: 40523,
      question: "Which product is specifically designed to help protect children's teeth against acid wear and cavities?",
      options: [
      "ProNamel for Children",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Fresh Mint",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 0
    },
    {
      id: 40524,
      question: "What characteristic distinguishes Sensodyne Sensitivity & Gum from other Sensodyne products?",
      options: [
      "It contains NovaMin® technology",
      "It provides 60-second relief",
      "It provides dual relief for sensitivity and gum problems",
      "It is suitable for children"
      ],
      correct: 2
    },
    {
      id: 40525,
      question: "Which product actively repairs acid-weakened enamel?",
      options: [
      "ProNamel for Children",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief"
      ],
      correct: 1
    },
    {
      id: 40526,
      question: "What patient symptom would indicate the need for Sensodyne Sensitivity & Gum?",
      options: [
      "Localized sensitivity only",
      "Acid wear on teeth",
      "Red, swollen, bleeding gums with plaque buildup in addition to sensitivity",
      "Recent diagnosis of sensitivity wanting immediate relief"
      ],
      correct: 2
    },
    {
      id: 40527,
      question: "Which product contains 0.454% stannous fluoride as its sole active ingredient?",
      options: [
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief",
      "Sensodyne Repair & Protect",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 1
    },
    {
      id: 40528,
      question: "What feature is unique to Sensodyne Repair & Protect compared to other sensitivity products?",
      options: [
      "Contains potassium nitrate",
      "Uses patented NovaMin® technology",
      "Provides 24/7 relief",
      "Contains stannous fluoride"
      ],
      correct: 1
    },
    {
      id: 40529,
      question: "Which product would be recommended for someone considering whitening treatment?",
      options: [
      "ProNamel for Children",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Fresh Mint",
      "Sensodyne Repair & Protect"
      ],
      correct: 2
    },
    {
      id: 40530,
      question: "What is the concentration of stannous fluoride in Sensodyne Sensitivity & Gum?",
      options: [
      "0.254% stannous fluoride",
      "0.2299% stannous fluoride",
      "0.454% stannous fluoride",
      "5% stannous fluoride"
      ],
      correct: 2
    },
    {
      id: 40531,
      question: "Which product is designed to strengthen tooth enamel in children?",
      options: [
      "Sensodyne Fresh Mint",
      "ProNamel for Children",
      "Sensodyne Rapid Relief",
      "ProNamel Intensive Enamel Repair"
      ],
      correct: 1
    },
    {
      id: 40532,
      question: "What type of protection does Sensodyne Fresh Mint build around the nerves?",
      options: [
      "Immediate fast-acting protection",
      "Soothing protection providing 24/7 relief",
      "Dual protection for sensitivity and gums",
      "Protection against acid wear"
      ],
      correct: 1
    },
    {
      id: 40533,
      question: "Which product category addresses gum problems?",
      options: [
      "ProNamel for Children only",
      "All Sensodyne products",
      "Only Sensodyne Sensitivity & Gum",
      "ProNamel Intensive Enamel Repair"
      ],
      correct: 2
    },
    {
      id: 40534,
      question: "What patient profile describes someone who wants healthy, stronger, better-protected teeth/enamel?",
      options: [
      "Candidate for ProNamel for Children",
      "Candidate for ProNamel Intensive Enamel Repair",
      "Candidate for Sensodyne Rapid Relief",
      "Candidate for Sensodyne Sensitivity & Gum"
      ],
      correct: 1
    },
    {
      id: 40535,
      question: "Which product provides long-lasting protection when used as directed?",
      options: [
      "ProNamel for Children",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Rapid Relief",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 2
    },
    {
      id: 40536,
      question: "What additional benefit does Sensodyne Sensitivity & Gum provide beyond sensitivity relief?",
      options: [
      "Whitening benefits",
      "Enamel repair",
      "Plaque control to improve gum health",
      "Acid wear protection"
      ],
      correct: 2
    },
    {
      id: 40537,
      question: "Which product contains both sodium fluoride at 0.2299% and another active ingredient?",
      options: [
      "ProNamel for Children",
      "Sensodyne Fresh Mint",
      "Sensodyne Repair & Protect",
      "ProNamel Intensive Enamel Repair"
      ],
      correct: 2
    },
    {
      id: 40538,
      question: "What is the primary purpose of ProNamel Intensive Enamel Repair?",
      options: [
      "To provide immediate sensitivity relief",
      "To actively repair acid-weakened enamel",
      "To control plaque buildup",
      "To help with professional whitening"
      ],
      correct: 1
    },
    {
      id: 40539,
      question: "Which product would be most appropriate for generalized sensitivity with exposed dentin?",
      options: [
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief",
      "Sensodyne Repair & Protect",
      "ProNamel Intensive Enamel Repair"
      ],
      correct: 2
    },
    {
      id: 40540,
      question: "What is the active ingredient combination in Sensodyne Sensitivity & Gum?",
      options: [
      "Sodium fluoride and potassium nitrate",
      "Stannous fluoride only",
      "Calcium sodium phosphosilicate and sodium fluoride",
      "Sodium fluoride and calcium phosphate"
      ],
      correct: 1
    },
    {
      id: 40541,
      question: "Which product helps protect enamel against future acid wear?",
      options: [
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 2
    },
    {
      id: 40542,
      question: "What type of technology does Sensodyne Repair & Protect use to repair exposed dentin?",
      options: [
      "Potassium nitrate technology",
      "Stannous fluoride technology",
      "Unique patented NovaMin® technology",
      "Advanced fluoride technology"
      ],
      correct: 2
    },
    {
      id: 40543,
      question: "Which product is specifically indicated for someone who wants all benefits of regular toothpaste?",
      options: [
      "ProNamel for Children",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Fresh Mint",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 2
    },
    {
      id: 40544,
      question: "What is the minimum age for using Sensodyne Repair & Protect?",
      options: [
      "6 years and older",
      "8 years and older",
      "10 years and older",
      "12 years and older"
      ],
      correct: 3
    },
    {
      id: 40545,
      question: "Which product category does Sensodyne Fresh Mint fall under?",
      options: [
      "Healthy teeth",
      "Dentin hypersensitivity",
      "Gum problems",
      "Children's products"
      ],
      correct: 1
    },
    {
      id: 40546,
      question: "What distinguishes the patient profile for ProNamel for Children?",
      options: [
      "Has gingival recession",
      "Children with strong and healthy teeth",
      "Suffers from sensitivity",
      "Has red swollen gums"
      ],
      correct: 1
    },
    {
      id: 40547,
      question: "Which product helps relieve tooth sensitivity while also protecting against acid wear?",
      options: [
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Repair & Protect"
      ],
      correct: 2
    },
    {
      id: 40548,
      question: "What makes Sensodyne Rapid Relief different from other sensitivity toothpastes?",
      options: [
      "It contains NovaMin® technology",
      "It provides relief in 60 seconds",
      "It helps with gum problems",
      "It protects against acid wear"
      ],
      correct: 1
    },
    {
      id: 40549,
      question: "Which product contains potassium nitrate at 5% concentration combined with 0.254% sodium fluoride?",
      options: [
      "ProNamel for Children",
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Fresh Mint",
      "Sensodyne Repair & Protect"
      ],
      correct: 2
    },
    {
      id: 40550,
      question: "What patient condition is specifically addressed by Sensodyne Repair & Protect?",
      options: [
      "Localized sensitivity",
      "Acid wear from beverages",
      "Gingival recession with exposed dentin",
      "Red and bleeding gums"
      ],
      correct: 2
    },
    {
      id: 40551,
      question: "Which product would be appropriate for a patient with plaque buildup in addition to sensitivity?",
      options: [
      "ProNamel Intensive Enamel Repair",
      "Sensodyne Fresh Mint",
      "Sensodyne Rapid Relief",
      "Sensodyne Sensitivity & Gum"
      ],
      correct: 3
    },
    {
      id: 40552,
      question: "ProNamel for Children contains 0.254% sodium fluoride as its active ingredient.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40553,
      question: "All Sensodyne products are suitable for children ages 6 and older.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40554,
      question: "Sensodyne Rapid Relief provides dentin hypersensitivity relief in 60 seconds when used as directed.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40555,
      question: "ProNamel Intensive Enamel Repair contains potassium nitrate as one of its active ingredients.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40556,
      question: "Sensodyne Sensitivity & Gum addresses only dentin hypersensitivity and not gum problems.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40557,
      question: "The minimum age recommendation for Sensodyne Rapid Relief is 12 years and older.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40558,
      question: "Sensodyne Repair & Protect uses NovaMin® technology to help repair exposed dentin.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40559,
      question: "ProNamel for Children is categorized under the \"Dentin Hypersensitivity\" product category.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40560,
      question: "Sensodyne Fresh Mint contains both potassium nitrate and sodium fluoride as active ingredients.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40561,
      question: "Sensodyne Sensitivity & Gum contains 0.454% stannous fluoride as its active ingredient.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40562,
      question: "ProNamel Intensive Enamel Repair is described as providing immediate 60-second relief.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40563,
      question: "Sensodyne Rapid Relief is described as \"engineered for speed.\"",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40564,
      question: "All products in the table help prevent cavities.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40565,
      question: "Sensodyne Repair & Protect contains 5% calcium sodium phosphosilicate (NovaMin®).",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40566,
      question: "ProNamel for Children helps strengthen tooth enamel.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40567,
      question: "Sensodyne Fresh Mint helps relieve dentin hypersensitivity associated with professional whitening.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40568,
      question: "The concentration of sodium fluoride in Sensodyne Repair & Protect is 0.454%.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40569,
      question: "Sensodyne Sensitivity & Gum helps control plaque buildup to improve gum health.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40570,
      question: "ProNamel Intensive Enamel Repair actively repairs acid-weakened enamel.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40571,
      question: "Sensodyne Rapid Relief contains NovaMin® technology.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40572,
      question: "The patient profile for ProNamel Intensive Enamel Repair includes those who frequently consume acidic foods and beverages.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40573,
      question: "Sensodyne Fresh Mint provides dual relief of dentin hypersensitivity and gingivitis.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40574,
      question: "ProNamel for Children is recommended for children ages 6 and older.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40575,
      question: "Sensodyne Sensitivity & Gum is appropriate for patients with red, swollen, bleeding gums in addition to sensitivity.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40576,
      question: "The concentration of stannous fluoride in Sensodyne Rapid Relief is 0.254%.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40577,
      question: "ProNamel Intensive Enamel Repair helps protect enamel against future acid wear.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40578,
      question: "Sensodyne Repair & Protect is suitable for patients with generalized sensitivity and gingival recession.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40579,
      question: "The minimum age for ProNamel Intensive Enamel Repair is 6 years and older.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40580,
      question: "Sensodyne Fresh Mint builds soothing protection around the nerves to provide 24/7 relief.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40581,
      question: "ProNamel for Children helps protect children's teeth against acid wear and cavities.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    }
  ],
  "5. Denture": [
    {
      id: 40582,
      question: "What continues to accumulate throughout the mouth even after losing natural teeth?",
      options: [
      "Only food particles and saliva",
      "Food debris and bacteria forming plaque",
      "Minerals and calcium deposits only",
      "Dead tissue and keratin buildup"
      ],
      correct: 1
    },
    {
      id: 40583,
      question: "What potential problems can plaque on dentures cause?",
      options: [
      "Whitening, smoothness, and freshness",
      "Strengthening, protection, and comfort",
      "Cavities, odours, sores, and irritation",
      "Mineralization, hardening, and staining"
      ],
      correct: 2
    },
    {
      id: 40584,
      question: "How often should dentures be taken out for appropriate cleaning?",
      options: [
      "Weekly or as needed",
      "Monthly for deep cleaning",
      "Daily for proper maintenance",
      "Only when visibly soiled"
      ],
      correct: 2
    },
    {
      id: 40585,
      question: "What should be placed at the bottom of the sink during denture cleaning?",
      options: [
      "A hard plastic mat",
      "A metal grate",
      "A towel or face cloth",
      "A rubber stopper"
      ],
      correct: 2
    },
    {
      id: 40586,
      question: "Why should a towel be placed in a sink half-full of water during cleaning?",
      options: [
      "To absorb excess cleaning solution",
      "To reduce impact if dentures are dropped",
      "To keep the dentures from floating",
      "To prevent water from splashing out"
      ],
      correct: 1
    },
    {
      id: 40587,
      question: "What type of brush should be used for cleaning dentures?",
      options: [
      "A hard-bristled scrub brush",
      "A medium-bristled regular brush",
      "A soft-bristled denture brush",
      "A wire-bristled cleaning brush"
      ],
      correct: 2
    },
    {
      id: 40588,
      question: "What type of cleanser should be used when brushing dentures?",
      options: [
      "Abrasive powder or strong detergent",
      "Non-abrasive denture cleanser or mild liquid soap",
      "Heavy-duty degreaser or bleach solution",
      "Concentrated antibacterial or acidic cleaner"
      ],
      correct: 1
    },
    {
      id: 40589,
      question: "When should dentures be rinsed and brushed?",
      options: [
      "Only in the morning",
      "Only before sleeping",
      "After each meal and before bed",
      "Once weekly on weekends"
      ],
      correct: 2
    },
    {
      id: 40590,
      question: "What should you check for when examining dentures?",
      options: [
      "Color changes and surface texture",
      "Weight and buoyancy",
      "Broken, cracked, or weakened areas",
      "Flexibility and elasticity"
      ],
      correct: 2
    },
    {
      id: 40591,
      question: "How long should dentures be left out to allow gums to rest?",
      options: [
      "Overnight or for a few hours",
      "Only during meal times",
      "For fifteen minutes daily",
      "One full day per week"
      ],
      correct: 0
    },
    {
      id: 40592,
      question: "Why is it important to leave dentures out for periods of time?",
      options: [
      "To air out the dentures completely",
      "To allow gums to rest and maintain healthy tissues",
      "To prevent denture warping and damage",
      "To reduce cleaning product accumulation"
      ],
      correct: 1
    },
    {
      id: 40593,
      question: "Who should you consult about the most effective way to store dentures?",
      options: [
      "Family members or friends",
      "Online forums or websites",
      "Your oral health professional",
      "Denture product manufacturers"
      ],
      correct: 2
    },
    {
      id: 40594,
      question: "What type of toothbrush should be used to clean natural teeth and oral tissues?",
      options: [
      "A hard-bristled electric brush",
      "A medium-bristled manual brush",
      "A soft-bristled toothbrush",
      "A specialized gum massager"
      ],
      correct: 2
    },
    {
      id: 40595,
      question: "What areas should be brushed besides natural teeth?",
      options: [
      "Only the tongue surface",
      "Gums, tongue, and roof of mouth",
      "Just the cheeks and lips",
      "Only areas with remaining teeth"
      ],
      correct: 1
    },
    {
      id: 40596,
      question: "What devices should be used to remove plaque between natural teeth?",
      options: [
      "Toothpicks and wooden sticks",
      "Cotton swabs and gauze",
      "Floss or interdental brushes",
      "Rubber bands and string"
      ],
      correct: 2
    },
    {
      id: 40597,
      question: "How often should you see your oral health professional for denture care?",
      options: [
      "Only when problems occur",
      "Every five years minimum",
      "Regularly to maintain health and denture integrity",
      "Once after initial denture fitting"
      ],
      correct: 2
    },
    {
      id: 40598,
      question: "What professional equipment can dental hygienists use to clean dentures?",
      options: [
      "High-pressure water jets",
      "Chemical immersion tanks",
      "Steam cleaning devices",
      "Ultrasonic cleaners"
      ],
      correct: 3
    },
    {
      id: 40599,
      question: "What additional service can dental hygienists provide for denture wearers?",
      options: [
      "Denture whitening and polishing",
      "Denture resizing and adjustment",
      "Label dentures to avoid misplacement",
      "Denture warranty and insurance"
      ],
      correct: 2
    },
    {
      id: 40600,
      question: "What special consideration is mentioned for implant-supported dentures?",
      options: [
      "They never require cleaning",
      "They need diamond paste polishing",
      "Discuss specific care needs with oral health professional",
      "They should be cleaned monthly only"
      ],
      correct: 2
    },
    {
      id: 40601,
      question: "According to the caregiver section, what do many people not realize?",
      options: [
      "The cost of denture maintenance",
      "How to properly fit dentures",
      "The importance of maintaining mouth health after tooth loss",
      "The lifespan of modern dentures"
      ],
      correct: 2
    },
    {
      id: 40602,
      question: "What protective equipment should caregivers wear when providing denture care?",
      options: [
      "Face shields and gowns",
      "Protective gloves",
      "Safety goggles and masks",
      "Sterile surgical attire"
      ],
      correct: 1
    },
    {
      id: 40603,
      question: "What should caregivers apply to the individual's lips before denture care?",
      options: [
      "Antiseptic solution",
      "Petroleum jelly",
      "Lip lubrication",
      "Medicated ointment"
      ],
      correct: 2
    },
    {
      id: 40604,
      question: "What type of container should be used for storing dentures?",
      options: [
      "Any clean cup or glass",
      "A sealed plastic bag",
      "A labelled denture container",
      "An open dish or tray"
      ],
      correct: 2
    },
    {
      id: 40605,
      question: "What type of toothpaste is recommended in the caregiver materials list?",
      options: [
      "Whitening gel toothpaste",
      "Abrasive tartar control paste",
      "Non-foaming toothpaste",
      "High-fluoride prescription paste"
      ],
      correct: 2
    },
    {
      id: 40606,
      question: "What tool may be helpful to ensure adequate access when brushing?",
      options: [
      "A tongue depressor",
      "A dental mirror",
      "A mouth prop",
      "A cheek retractor"
      ],
      correct: 2
    },
    {
      id: 40607,
      question: "Where should individuals spit if they have difficulty swallowing?",
      options: [
      "Into a paper towel",
      "Into a kidney basin",
      "Into the sink drain",
      "Into a plastic cup"
      ],
      correct: 1
    },
    {
      id: 40608,
      question: "How should dentures be removed if the individual cannot do it themselves?",
      options: [
      "Pull firmly on the front teeth",
      "Use suction to release the seal",
      "Gently place finger on back and apply gentle pressure",
      "Rock the denture side to side vigorously"
      ],
      correct: 2
    },
    {
      id: 40609,
      question: "What should caregivers look for after cleaning dentures and mouth?",
      options: [
      "Only color changes in tissues",
      "Any changes and ask how mouth and dentures feel",
      "Just denture fit and stability",
      "Only signs of bleeding"
      ],
      correct: 1
    },
    {
      id: 40610,
      question: "When should caregivers encourage seeking care from an oral health professional?",
      options: [
      "Only during annual checkups",
      "When the individual requests it",
      "If an area of concern is identified",
      "After completing a cleaning cycle"
      ],
      correct: 2
    },
    {
      id: 40611,
      question: "According to the document, dentures should be removed for cleaning for what minimum time?",
      options: [
      "30 minutes daily",
      "A minimum of 4 hours or ideally overnight",
      "2 hours after each meal",
      "6 hours every other day"
      ],
      correct: 1
    },
    {
      id: 40612,
      question: "What can dental hygienists do to help prevent denture misplacement?",
      options: [
      "Provide storage containers only",
      "Keep dentures at the office",
      "Label dentures for identification",
      "Register dentures in a database"
      ],
      correct: 2
    },
    {
      id: 40613,
      question: "What organization published this denture care information?",
      options: [
      "American Dental Association",
      "World Health Organization",
      "Canadian Dental Hygienists Association",
      "International Dental Federation"
      ],
      correct: 2
    },
    {
      id: 40614,
      question: "Where can the Helpful Hints for Daily Denture and Mouth Care be found online?",
      options: [
      "www.dentalcare.com",
      "www.dentalhygienecanada.ca/denturehints",
      "www.cdha.ca/dentures",
      "www.oralhealth.ca/hints"
      ],
      correct: 1
    },
    {
      id: 40615,
      question: "What website is provided for general denture care information?",
      options: [
      "www.dentalhygienecanada.ca",
      "www.cdha.org",
      "www.dentalcanada.com",
      "www.oralhealthcare.ca"
      ],
      correct: 0
    },
    {
      id: 40616,
      question: "What is the copyright year for this denture care document?",
      options: [
      "2010",
      "2012",
      "2015",
      "2018"
      ],
      correct: 2
    },
    {
      id: 40617,
      question: "What abbreviation is used for the Canadian Dental Hygienists Association?",
      options: [
      "CDHA or ACHD",
      "CDHC or ACHC",
      "ADHA or ACHD",
      "CDHA or ACDH"
      ],
      correct: 0
    },
    {
      id: 40618,
      question: "What can food debris and bacteria accumulate on besides dentures?",
      options: [
      "Only the palate",
      "Tongue and remaining teeth",
      "Only the cheeks",
      "Just the lips"
      ],
      correct: 1
    },
    {
      id: 40619,
      question: "What should caregivers determine before beginning denture care?",
      options: [
      "The individual's insurance coverage",
      "The age of the dentures",
      "The level of assistance required",
      "The denture warranty status"
      ],
      correct: 2
    },
    {
      id: 40620,
      question: "What is recommended if the individual is able to perform self-care?",
      options: [
      "Complete all care for them anyway",
      "Supervise every single step closely",
      "Encourage them to follow the Helpful Hints",
      "Let them proceed without any guidance"
      ],
      correct: 2
    },
    {
      id: 40621,
      question: "Many people understand the importance of maintaining oral health after losing their natural teeth.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40622,
      question: "Food debris and bacteria continue to accumulate in the mouth even after losing natural teeth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40623,
      question: "Plaque formation on dentures and oral tissues can cause cavities, odours, sores, and irritation.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40624,
      question: "It is important to take dentures out daily for appropriate cleaning.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40625,
      question: "A towel or face cloth should be placed at the bottom of a sink half-full of water when cleaning dentures.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40626,
      question: "Dentures should be cleaned with hard-bristled brushes and abrasive cleansers.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40627,
      question: "Dentures should be rinsed and brushed after each meal and before going to bed.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40628,
      question: "Implant-supported dentures have the same care requirements as regular dentures.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40629,
      question: "You should check dentures for any broken, cracked, or weakened areas during cleaning.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40630,
      question: "Dentures should be worn 24 hours a day without removal.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40631,
      question: "Leaving dentures out overnight or for a few hours allows gums to rest and maintains healthy tissues.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40632,
      question: "Natural teeth, gums, tongue, and roof of mouth should be brushed with a soft-bristled toothbrush.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40633,
      question: "Interdental devices such as floss or interdental brushes should be used between natural teeth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40634,
      question: "Regular visits to oral health professionals are necessary to maintain oral health and denture integrity.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40635,
      question: "Dental hygienists can professionally remove debris from dentures using an ultrasonic cleaner.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40636,
      question: "Dental hygienists can label dentures to avoid misplacement in multi-denture households.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40637,
      question: "Dentures require just as much care as natural teeth.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40638,
      question: "Caregivers should wear protective gloves when providing denture care assistance.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40639,
      question: "Lip lubrication should be applied before beginning denture care assistance.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40640,
      question: "A labelled denture container is one of the materials needed for caregiver assistance.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40641,
      question: "Non-foaming toothpaste is recommended in the materials list for caregivers.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40642,
      question: "A mouth prop may be helpful when brushing an individual's teeth to ensure adequate access.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40643,
      question: "If dentures need to be removed by a caregiver, gentle pressure should be applied with a finger on the back of the denture.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40644,
      question: "Individuals with difficulty swallowing should spit into a kidney basin during oral care.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40645,
      question: "After cleaning, caregivers should look for changes and ask how the mouth and dentures feel.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40646,
      question: "Caregivers should make appropriate referrals if they identify an area of concern.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40647,
      question: "The document was published by the Canadian Dental Hygienists Association in 2015.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40648,
      question: "The helpful hints for daily denture care can be found at www.dentalhygienecanada.ca/denturehints.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    }
  ],
  "6. A String around Your Finger": [
    {
      id: 40649,
      question: "What is the average time that US adults spend brushing their teeth daily according to the document?",
      options: [
      "30 seconds",
      "45-70 seconds",
      "90-120 seconds",
      "240 seconds"
      ],
      correct: 1
    },
    {
      id: 40650,
      question: "Approximately what percentage of US adults floss daily and consistently?",
      options: [
      "2%",
      "15%",
      "35%",
      "50%"
      ],
      correct: 0
    },
    {
      id: 40651,
      question: "What is the recommended return on investment for each dollar spent on community water fluoridation?",
      options: [
      "Up to $3",
      "Up to $12",
      "Up to $32",
      "Up to $50"
      ],
      correct: 2
    },
    {
      id: 40652,
      question: "What percentage of US adults ages 20-44 years have untreated dental caries?",
      options: [
      "15%",
      "22%",
      "32%",
      "45%"
      ],
      correct: 2
    },
    {
      id: 40653,
      question: "What percentage of dentate adults have decay in a permanent tooth?",
      options: [
      "63%",
      "78%",
      "85%",
      "92%"
      ],
      correct: 3
    },
    {
      id: 40654,
      question: "On average, patients with periodontitis demonstrate how much attachment loss per year?",
      options: [
      "0.01 mm",
      "0.1 mm",
      "0.5 mm",
      "1.0 mm"
      ],
      correct: 1
    },
    {
      id: 40655,
      question: "What is the estimated prevalence of periodontitis among US adults over 30 years of age?",
      options: [
      "26%",
      "34%",
      "42%",
      "63%"
      ],
      correct: 2
    },
    {
      id: 40656,
      question: "Among older individuals who never floss, the increased risk of death is approximately what percentage?",
      options: [
      "10%",
      "30%",
      "50%",
      "75%"
      ],
      correct: 1
    },
    {
      id: 40657,
      question: "According to the 2014 Delta Dental Oral Health and Well-Being Survey, what percentage of Americans never floss?",
      options: [
      "20%",
      "30%",
      "45%",
      "58%"
      ],
      correct: 0
    },
    {
      id: 40658,
      question: "How many species of microorganisms have been identified in dental biofilm?",
      options: [
      "Over 200",
      "Over 400",
      "Over 700",
      "Over 1,000"
      ],
      correct: 2
    },
    {
      id: 40659,
      question: "What percentage of children ages 2-19 had untreated caries in 2015-2016?",
      options: [
      "8%",
      "13%",
      "23%",
      "32%"
      ],
      correct: 1
    },
    {
      id: 40660,
      question: "What is the total incidence of caries (treated and untreated) among children ages 2-19?",
      options: [
      "32.5%",
      "41.0%",
      "48.5%",
      "56.2%"
      ],
      correct: 2
    },
    {
      id: 40661,
      question: "How many restricted activity days result from dental caries annually?",
      options: [
      "2 million days",
      "5 million days",
      "8 million days",
      "10 million days"
      ],
      correct: 1
    },
    {
      id: 40662,
      question: "How many work hours do employed adults lose each year to dental disease?",
      options: [
      "52.4 million",
      "72.8 million",
      "92.4 million",
      "112.6 million"
      ],
      correct: 2
    },
    {
      id: 40663,
      question: "What percentage of severe periodontitis was found among adults 65 years or older?",
      options: [
      "5.2%",
      "7.8%",
      "10.4%",
      "13.6%"
      ],
      correct: 1
    },
    {
      id: 40664,
      question: "According to the ADA, how long should individuals brush their teeth?",
      options: [
      "At least 1 minute once daily",
      "At least 1 minute twice daily",
      "At least 2 minutes once daily",
      "At least 2 minutes twice daily"
      ],
      correct: 3
    },
    {
      id: 40665,
      question: "How often must biofilm be completely removed to prevent inflammation in experimental settings?",
      options: [
      "Every 24 hours",
      "Every 36 hours",
      "Every 48 hours",
      "Every 72 hours"
      ],
      correct: 2
    },
    {
      id: 40666,
      question: "What percentage of teenagers reportedly floss daily?",
      options: [
      "2%",
      "8%",
      "15%",
      "23%"
      ],
      correct: 1
    },
    {
      id: 40667,
      question: "What percentage of Americans reported they would rather perform an unpleasant task than floss?",
      options: [
      "Over 20%",
      "Over 30%",
      "Over 35%",
      "Over 45%"
      ],
      correct: 2
    },
    {
      id: 40668,
      question: "What year was the Cochrane systematic review on flossing published that influenced the Dietary Guidelines?",
      options: [
      "2008",
      "2009",
      "2011",
      "2013"
      ],
      correct: 2
    },
    {
      id: 40669,
      question: "Which government agency omitted flossing recommendations from the 2015-2020 Dietary Guidelines for Americans?",
      options: [
      "Centers for Disease Control",
      "Food and Drug Administration",
      "National Institutes of Health",
      "Dietary Guideline Advisory Committee"
      ],
      correct: 3
    },
    {
      id: 40670,
      question: "What was the nickname given to the controversy about the flossing recommendation omission?",
      options: [
      "Flossgate",
      "Dental Debate",
      "Hygiene Controversy",
      "String Theory Scandal"
      ],
      correct: 0
    },
    {
      id: 40671,
      question: "In what year did the European Federation of Periodontology hold its 11th European Workshop on flossing?",
      options: [
      "2011",
      "2012",
      "2014",
      "2016"
      ],
      correct: 2
    },
    {
      id: 40672,
      question: "According to the document, what percentage of US children ages 3-15 report brushing their teeth twice daily?",
      options: [
      "45.2%",
      "51.0%",
      "60.5%",
      "68.3%"
      ],
      correct: 2
    },
    {
      id: 40673,
      question: "What percentage of adult Americans reported brushing twice daily?",
      options: [
      "41%",
      "51%",
      "61%",
      "71%"
      ],
      correct: 1
    },
    {
      id: 40674,
      question: "What percentage of Americans have gone two or more days without brushing in the past year?",
      options: [
      "13%",
      "18%",
      "23%",
      "28%"
      ],
      correct: 2
    },
    {
      id: 40675,
      question: "According to research, toothbrushing duration is associated with greater biofilm removal up to approximately how many minutes?",
      options: [
      "One minute",
      "Two minutes",
      "Three minutes",
      "Four minutes"
      ],
      correct: 1
    },
    {
      id: 40676,
      question: "What type of toothbrush bristles result in superior plaque removal both subgingivally and interproximally?",
      options: [
      "Hard bristles",
      "Medium-hard bristles",
      "Medium-soft bristles",
      "Soft bristles"
      ],
      correct: 3
    },
    {
      id: 40677,
      question: "After how many weeks of normal use can toothbrush efficacy decrease?",
      options: [
      "3 weeks",
      "6 weeks",
      "9 weeks",
      "12 weeks"
      ],
      correct: 2
    },
    {
      id: 40678,
      question: "Which type of power toothbrush has been shown to remove significantly more plaque than manual toothbrushes?",
      options: [
      "Sonic action brushes",
      "Oscillating rotating action brushes",
      "Ultrasonic brushes",
      "Pulsating action brushes"
      ],
      correct: 1
    },
    {
      id: 40679,
      question: "In patients with adequate interdental space, which method was superior for biofilm removal compared to toothbrushing and flossing?",
      options: [
      "Water flossing",
      "Wooden toothpicks",
      "Interdental brushes",
      "Powered flossers"
      ],
      correct: 2
    },
    {
      id: 40680,
      question: "What did the 2011 Cochrane review conclude about flossing's effect on gingivitis?",
      options: [
      "No evidence of benefit",
      "Strong evidence of benefit",
      "Some evidence of benefit",
      "Contradictory evidence"
      ],
      correct: 2
    },
    {
      id: 40681,
      question: "According to the EFP statement, for which patient group is floss optimal for primary prevention?",
      options: [
      "Patients with periodontitis",
      "Patients with gingivitis",
      "Healthy patients",
      "Patients with implants"
      ],
      correct: 2
    },
    {
      id: 40682,
      question: "For patients with established periodontitis, what does the EFP recommend over floss where space allows?",
      options: [
      "Water flossers",
      "Interdental brushes",
      "Toothpicks",
      "Air flossers"
      ],
      correct: 1
    },
    {
      id: 40683,
      question: "In a matched twin cohort study, what was the effect of supervised flossing and toothbrushing?",
      options: [
      "Increased visible plaque",
      "No change in gingival bleeding",
      "Decreased subgingival harmful bacteria",
      "Increased dental caries"
      ],
      correct: 2
    },
    {
      id: 40684,
      question: "Flossing even how many days per week was associated with lower prevalence of periodontitis?",
      options: [
      "1-2 days",
      "2-4 days",
      "4-6 days",
      "5-7 days"
      ],
      correct: 1
    },
    {
      id: 40685,
      question: "When should flossing or interdental cleaning be performed for maximal biofilm removal?",
      options: [
      "After toothbrushing",
      "Before toothbrushing",
      "At the same time as toothbrushing",
      "It doesn't matter when"
      ],
      correct: 1
    },
    {
      id: 40686,
      question: "What percentage more plaque do interdental brushes remove compared to floss?",
      options: [
      "They remove less plaque",
      "They remove the same amount",
      "They remove more plaque",
      "The research is inconclusive"
      ],
      correct: 2
    },
    {
      id: 40687,
      question: "According to research, triangular wooden tips demonstrate what level of reduction in plaque when compared to toothbrushing alone?",
      options: [
      "Significant reduction",
      "Moderate reduction",
      "Slight reduction",
      "No overall reduction"
      ],
      correct: 3
    },
    {
      id: 40688,
      question: "What do powered flossers decrease when used adjunctively with toothbrushing?",
      options: [
      "Enamel thickness",
      "Interdental biofilm and gingival bleeding",
      "Tooth sensitivity",
      "Saliva production"
      ],
      correct: 1
    },
    {
      id: 40689,
      question: "Which psychological interventions have been shown to improve oral hygiene practices?",
      options: [
      "Authoritarian models",
      "Punishment-based systems",
      "Motivational interviewing",
      "Passive education only"
      ],
      correct: 2
    },
    {
      id: 40690,
      question: "What is the primary etiology of both dental caries and periodontal disease?",
      options: [
      "Genetic factors",
      "Dietary sugar alone",
      "Bacterial biofilm (plaque)",
      "Mechanical trauma"
      ],
      correct: 2
    },
    {
      id: 40691,
      question: "According to the document, what happens to the oral microbiome when dysbiosis occurs?",
      options: [
      "Symbiotic bacteria increase",
      "Pathogenic microbes take over",
      "All bacteria are eliminated",
      "Beneficial bacteria dominate"
      ],
      correct: 1
    },
    {
      id: 40692,
      question: "What is the critical pH threshold below which demineralization of teeth occurs?",
      options: [
      "pH 7.0",
      "pH 6.5",
      "Below the demineralization threshold (varies)",
      "pH 5.0"
      ],
      correct: 2
    },
    {
      id: 40693,
      question: "What mineral does fluoride help incorporate into remineralized tooth tissues?",
      options: [
      "Calcium phosphate",
      "Hydroxyapatite",
      "Fluorapatite",
      "Calcium carbonate"
      ],
      correct: 2
    },
    {
      id: 40694,
      question: "The average US adult has how many decayed, missing, or filled teeth?",
      options: [
      "1.28",
      "2.15",
      "3.28",
      "4.42"
      ],
      correct: 2
    },
    {
      id: 40695,
      question: "Which groups have higher prevalence of tooth decay according to the document?",
      options: [
      "Adults and younger children",
      "High socioeconomic status individuals",
      "Non-Hispanic whites",
      "Children, older adults, and lower socioeconomic status individuals"
      ],
      correct: 3
    },
    {
      id: 40696,
      question: "Gingivitis is described as what type of condition?",
      options: [
      "Irreversible gingival inflammation",
      "Reversible gingival inflammation",
      "Permanent tissue destruction",
      "Genetic disorder"
      ],
      correct: 1
    },
    {
      id: 40697,
      question: "What is periodontitis classified as in the updated AAP/EFP system?",
      options: [
      "By color (red, yellow, green)",
      "By Stage (I-IV) and Grade (A-C)",
      "By severity only (mild, moderate, severe)",
      "By age of onset only"
      ],
      correct: 1
    },
    {
      id: 40698,
      question: "How does periodontitis prevalence compare to diabetes mellitus in US adults?",
      options: [
      "Periodontitis is less prevalent",
      "They are equally prevalent",
      "Periodontitis is nearly 4-fold greater",
      "Periodontitis is 2-fold greater"
      ],
      correct: 2
    },
    {
      id: 40699,
      question: "How many hours after cessation of oral hygiene do well-organized biofilms grow?",
      options: [
      "Within 2 hours",
      "Within 6 hours",
      "Within hours",
      "Within 24 hours"
      ],
      correct: 2
    },
    {
      id: 40700,
      question: "What is one limitation of using floss at interproximal sites?",
      options: [
      "It's too expensive",
      "It's too time-consuming",
      "At deep probing depths it may not provide adequate plaque removal",
      "It damages tooth enamel"
      ],
      correct: 2
    },
    {
      id: 40701,
      question: "According to research on powered toothbrushes, which patient groups show additional benefit?",
      options: [
      "Only healthy adults",
      "Children with disabilities and patients with orthodontics",
      "Only elderly patients",
      "Only professional athletes"
      ],
      correct: 1
    },
    {
      id: 40702,
      question: "What does the document recommend regarding toothbrush replacement?",
      options: [
      "Replace every 3 months regardless",
      "Replace when bristles are frayed",
      "Regular replacement improves outcomes (efficacy decreases after 9 weeks)",
      "Never replace, just clean thoroughly"
      ],
      correct: 2
    },
    {
      id: 40703,
      question: "In patients with dental implants, which cleaning method may provide additional benefit?",
      options: [
      "Manual flossing only",
      "Toothbrushing only",
      "Powered flossers",
      "No interdental cleaning needed"
      ],
      correct: 2
    },
    {
      id: 40704,
      question: "What percentage of the population lost work/school hours seeking unplanned dental care?",
      options: [
      "45.5%",
      "57.3%",
      "67.5%",
      "78.2%"
      ],
      correct: 2
    },
    {
      id: 40705,
      question: "Which organizations continue to support the importance of flossing despite the Dietary Guidelines omission?",
      options: [
      "Only the ADA",
      "Only the Surgeon General",
      "The Surgeon General, CDC, ADA, and other federal/state agencies",
      "No organizations support flossing anymore"
      ],
      correct: 2
    },
    {
      id: 40706,
      question: "What is the relationship between flossing frequency and periodontitis according to observational studies?",
      options: [
      "More frequent flossing is associated with higher periodontitis",
      "No relationship exists",
      "More frequent flossing is associated with lower periodontitis",
      "Only professional cleaning matters"
      ],
      correct: 2
    },
    {
      id: 40707,
      question: "According to the document, what percentage of adults ages 18-24 have gone days without brushing?",
      options: [
      "23%",
      "30%",
      "37%",
      "45%"
      ],
      correct: 2
    },
    {
      id: 40708,
      question: "What is the recommended toothbrushing technique most endorsed by dental professionals?",
      options: [
      "Circular motion technique",
      "Modified Bass technique",
      "Scrub brush technique",
      "Vertical stroke technique"
      ],
      correct: 1
    },
    {
      id: 40709,
      question: "Dental caries result from acid erosion of hard tooth surfaces due to bacterial metabolism of simple sugars.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40710,
      question: "Children with poor oral health demonstrate similar scholastic performance to children with higher levels of oral wellness.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40711,
      question: "Periodontal disease is bacterially initiated, and disease progression is propagated by inflammatory host factors.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40712,
      question: "Manual toothbrushing alone is adequate in the treatment of gingivitis.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40713,
      question: "Improvement in effectiveness of oral hygiene measures requires multiple rounds of oral hygiene instruction and reinforcement over time.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40714,
      question: "Hard toothbrush bristles are more effective at plaque removal than soft bristles.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40715,
      question: "The 2011 Cochrane review found strong evidence that flossing prevents dental caries.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    }
  ],
  "7. Toothbrushing": [
    {
      id: 40716,
      question: "What is tooth brushing considered to be in terms of plaque removal?",
      options: [
      "A secondary chemical means of removing plaque",
      "A primary mechanical means of removing plaque",
      "An optional supplementary oral hygiene behavior",
      "A temporary substitute for professional cleaning"
      ],
      correct: 1
    },
    {
      id: 40717,
      question: "How many papers were identified and retrieved in full text for this position paper?",
      options: [
      "138 papers total",
      "338 papers total",
      "238 papers total",
      "438 papers total"
      ],
      correct: 2
    },
    {
      id: 40718,
      question: "What percentage of all plaque does average daily toothbrush cleaning of two minutes remove?",
      options: [
      "Approximately 30% of all plaque",
      "Approximately 50% of all plaque",
      "Approximately 70% of all plaque",
      "Approximately 90% of all plaque"
      ],
      correct: 1
    },
    {
      id: 40719,
      question: "Where was the toothbrush reportedly invented around 1000 AD?",
      options: [
      "In China using ivory handles",
      "In Japan using bamboo handles",
      "In India using wooden handles",
      "In Egypt using bone handles"
      ],
      correct: 0
    },
    {
      id: 40720,
      question: "When were nylon bristles reported to have largely replaced natural bristles?",
      options: [
      "In the early 1920s",
      "In the late 1930s",
      "In the mid 1940s",
      "In the early 1950s"
      ],
      correct: 1
    },
    {
      id: 40721,
      question: "What event gave impetus for widespread use of tooth brushing in North America?",
      options: [
      "Mandatory brushing for American soldiers in WWI",
      "Mandatory brushing for American soldiers in WWII",
      "Introduction of fluoride toothpaste in 1950s",
      "Formation of American Dental Association in 1960s"
      ],
      correct: 1
    },
    {
      id: 40722,
      question: "When were powered toothbrushes first developed after WWII?",
      options: [
      "They were developed in Switzerland",
      "They were developed in United States",
      "They were developed in United Kingdom",
      "They were developed in Germany"
      ],
      correct: 0
    },
    {
      id: 40723,
      question: "When did the second generation of powered toothbrushes emerge?",
      options: [
      "In the 1970s",
      "In the 1980s",
      "In the 1990s",
      "In the 2000s"
      ],
      correct: 2
    },
    {
      id: 40724,
      question: "Which databases were used in the literature search for this position paper?",
      options: [
      "MedLine, PubMed, and Google Scholar",
      "MedLine, CINAHL, and Cochrane Controlled Trials Register",
      "CINAHL, PubMed, and Web of Science",
      "Cochrane Register, PubMed, and EMBASE"
      ],
      correct: 1
    },
    {
      id: 40725,
      question: "What time period did the Brothwell et al. review cover?",
      options: [
      "From 1974 to 1985",
      "From 1984 to 1995",
      "From 1994 to 2005",
      "From 2004 to 2015"
      ],
      correct: 1
    },
    {
      id: 40726,
      question: "What was the conclusion of the Frandsen review regarding toothbrush superiority?",
      options: [
      "Power brushes were clearly superior",
      "Manual brushes were clearly superior",
      "No evidence showed superiority of any type",
      "Ionic brushes showed the most promise"
      ],
      correct: 2
    },
    {
      id: 40727,
      question: "According to the Brothwell review, which type of power brush was more effective?",
      options: [
      "Side-to-side action power brushes",
      "Oscillating/rotating action power brushes",
      "Ultrasonic frequency power brushes",
      "Counter oscillation power brushes"
      ],
      correct: 1
    },
    {
      id: 40728,
      question: "How many modes of action were powered toothbrushes clustered into in the 2003 Cochrane review?",
      options: [
      "Four modes of action",
      "Five modes of action",
      "Six modes of action",
      "Seven modes of action"
      ],
      correct: 2
    },
    {
      id: 40729,
      question: "Which cluster removed more plaque in both short and long term in the Cochrane review?",
      options: [
      "The side-to-side cluster",
      "The circular motion cluster",
      "The rotational oscillation cluster",
      "The ultrasonic cluster"
      ],
      correct: 2
    },
    {
      id: 40730,
      question: "What percentage more plaque did rotation oscillation brushes remove in the Cochrane update?",
      options: [
      "7% more plaque removal",
      "11% more plaque removal",
      "17% more plaque removal",
      "23% more plaque removal"
      ],
      correct: 1
    },
    {
      id: 40731,
      question: "What was added as a seventh group in the 2005 Cochrane update?",
      options: [
      "The pulsating group",
      "The sonic group",
      "The ionic group",
      "The hybrid group"
      ],
      correct: 2
    },
    {
      id: 40732,
      question: "What was the primary reason for excluding studies from the Cochrane meta-analysis?",
      options: [
      "Studies lacked proper control groups",
      "Studies were too short in duration",
      "Studies had inadequate sample sizes",
      "Studies used improper outcome measures"
      ],
      correct: 1
    },
    {
      id: 40733,
      question: "What is the minimum duration requirement for studies included in the Cochrane review?",
      options: [
      "At least 14 days",
      "At least 21 days",
      "At least 28 days",
      "At least 35 days"
      ],
      correct: 2
    },
    {
      id: 40734,
      question: "What manual toothbrush design has undergone considerable study with angled filaments?",
      options: [
      "Colgate Total Advanced",
      "Oral-B CrossAction",
      "Crest Pro-Health",
      "Sensodyne Precision"
      ],
      correct: 1
    },
    {
      id: 40735,
      question: "What unique feature does the Oral-B CrossAction Vitalizer have?",
      options: [
      "One row of silicon cleaning cups",
      "Two lateral rows of non-latex rubber nubs",
      "Three vertical rows of polishing bristles",
      "Four diagonal rows of flexible filaments"
      ],
      correct: 1
    },
    {
      id: 40736,
      question: "What diameter were the bristles that Frandsen recommended?",
      options: [
      "Approximately 0.1 mm in diameter",
      "Approximately 0.2 mm in diameter",
      "Approximately 0.3 mm in diameter",
      "Approximately 0.4 mm in diameter"
      ],
      correct: 1
    },
    {
      id: 40737,
      question: "What length were the bristles that Frandsen recommended?",
      options: [
      "8 mm in length",
      "10 mm in length",
      "12 mm in length",
      "14 mm in length"
      ],
      correct: 1
    },
    {
      id: 40738,
      question: "Which type of brush has been shown to be less effective according to Brothwell?",
      options: [
      "Brushes with serrated tufts",
      "Brushes with raised toe bristles",
      "Foam brushes",
      "Brushes with angled heads"
      ],
      correct: 2
    },
    {
      id: 40739,
      question: "What happens to bristle tips when less than 10% of toothbrush life has elapsed?",
      options: [
      "Tips become sharper and pointed",
      "Tips display a flattened shape",
      "Tips become rounded and smoother",
      "Tips remain unchanged"
      ],
      correct: 1
    },
    {
      id: 40740,
      question: "How long do individuals typically brush their teeth according to studies?",
      options: [
      "About 30 seconds or less",
      "About one minute or less",
      "About two minutes or less",
      "About three minutes or less"
      ],
      correct: 1
    },
    {
      id: 40741,
      question: "How much do people typically overestimate their tooth-brushing duration?",
      options: [
      "By 30 to 50 seconds",
      "By 50 to 70 seconds",
      "By 70 to 90 seconds",
      "By 90 to 110 seconds"
      ],
      correct: 1
    },
    {
      id: 40742,
      question: "What brushing frequency did Frandsen identify from previous workshops?",
      options: [
      "Up to one time a day",
      "Up to two times a day",
      "Up to three times a day",
      "Up to four times a day"
      ],
      correct: 1
    },
    {
      id: 40743,
      question: "What has been found to be the optimal force for tooth brushing?",
      options: [
      "Between 100 to 200 grams",
      "Between 200 to 300 grams",
      "Between 300 to 400 grams",
      "Between 400 to 500 grams"
      ],
      correct: 2
    },
    {
      id: 40744,
      question: "What is the optimal range of feedback force determined in recent studies?",
      options: [
      "From 150 to 180 grams",
      "From 200 to 230 grams",
      "From 250 to 280 grams",
      "From 300 to 330 grams"
      ],
      correct: 2
    },
    {
      id: 40745,
      question: "At what force do some Braun oscillating/rotational powered toothbrushes stop?",
      options: [
      "Over 1.5 Newtons",
      "Over 2.5 Newtons",
      "Over 3.5 Newtons",
      "Over 4.5 Newtons"
      ],
      correct: 1
    },
    {
      id: 40746,
      question: "What percentage of people employ their \"personal tooth-brushing method\"?",
      options: [
      "Over 70% of people",
      "Over 80% of people",
      "Over 90% of people",
      "Over 95% of people"
      ],
      correct: 2
    },
    {
      id: 40747,
      question: "Which tooth-brushing method was found especially effective on lingual sites?",
      options: [
      "The Stillman's method",
      "The Charter's method",
      "The modified Bass method",
      "The Roll method"
      ],
      correct: 2
    },
    {
      id: 40748,
      question: "How often has it typically been recommended that toothbrushes be replaced?",
      options: [
      "Every one month",
      "Every two months",
      "Every three months",
      "Every six months"
      ],
      correct: 2
    },
    {
      id: 40749,
      question: "What range of time does toothbrush wear vary according to studies?",
      options: [
      "From one week to three months",
      "From two weeks to six months",
      "From three weeks to nine months",
      "From four weeks to twelve months"
      ],
      correct: 1
    },
    {
      id: 40750,
      question: "What percentage of middle-aged U.S. population shows some level of recession?",
      options: [
      "58% to 80% show recession",
      "68% to 90% show recession",
      "78% to 100% show recession",
      "88% to 110% show recession"
      ],
      correct: 2
    },
    {
      id: 40751,
      question: "What percentage of 30-to-90 year olds in the U.S. had recession of 3mm or greater?",
      options: [
      "Almost one tenth had recession",
      "Almost one fifth had recession",
      "Almost one quarter had recession",
      "Almost one third had recession"
      ],
      correct: 2
    },
    {
      id: 40752,
      question: "What difference in force has been reported between power and manual brushing?",
      options: [
      "A 0.5 Newton difference",
      "A 1.0 Newton difference",
      "A 1.5 Newton difference",
      "A 2.0 Newton difference"
      ],
      correct: 1
    },
    {
      id: 40753,
      question: "What technique was found to be associated with the greatest recession?",
      options: [
      "A vertical scrubbing technique",
      "A horizontal scrubbing technique",
      "A circular scrubbing technique",
      "A rolling scrubbing technique"
      ],
      correct: 1
    },
    {
      id: 40754,
      question: "What term has been more recently accepted for cervical hard tissue loss?",
      options: [
      "Cervical abrasion lesion",
      "Cervical abfraction lesion",
      "Non-carious cervical lesion",
      "Cervical erosion lesion"
      ],
      correct: 2
    },
    {
      id: 40755,
      question: "What is well recognized about toothpaste in relation to hard-tissue lesions?",
      options: [
      "Toothpaste is the sole cause",
      "Toothpaste is important for delivering fluoride",
      "Toothpaste has no effect",
      "Toothpaste prevents all lesions"
      ],
      correct: 1
    },
    {
      id: 40756,
      question: "What does current understanding consider about the toothbrush alone?",
      options: [
      "It causes severe enamel damage",
      "It causes moderate dentin damage",
      "It has negligible effects on dentin and enamel",
      "It causes significant gingival trauma"
      ],
      correct: 2
    },
    {
      id: 40757,
      question: "Which bristle type has the most influence on abrasion?",
      options: [
      "Hard-bristled brushes",
      "Medium-bristled brushes",
      "Soft-bristled brushes",
      "Extra-hard-bristled brushes"
      ],
      correct: 2
    },
    {
      id: 40758,
      question: "Why do soft bristles cause more abrasion according to research?",
      options: [
      "They move faster across tooth surfaces",
      "They apply more direct pressure",
      "They hold toothpaste better and have greater flexion",
      "They create more friction with enamel"
      ],
      correct: 2
    },
    {
      id: 40759,
      question: "What do toothbrushes support according to contamination studies?",
      options: [
      "Only aerobic bacteria",
      "Only anaerobic bacteria",
      "A wide variety of micro-organisms",
      "Only fungal organisms"
      ],
      correct: 2
    },
    {
      id: 40760,
      question: "Which design made retention of micro-organisms significantly more difficult?",
      options: [
      "Staple set tufting design",
      "In-mold tufting design",
      "Individual in-mold placement design",
      "Clustered tuft placement design"
      ],
      correct: 2
    },
    {
      id: 40761,
      question: "What has been shown to be associated with the least toothbrush contamination?",
      options: [
      "Post-brushing antimicrobial spray",
      "Pre-brushing mouth rinse",
      "Brushing with fluoride toothpaste",
      "Brushing with baking soda"
      ],
      correct: 1
    },
    {
      id: 40762,
      question: "What material more effectively inhibited retention of micro-organisms?",
      options: [
      "Opaque brush head materials",
      "Colored brush head materials",
      "Transparent brush head materials",
      "Metallic brush head materials"
      ],
      correct: 2
    },
    {
      id: 40763,
      question: "How many recommendations were developed in this position paper?",
      options: [
      "Five recommendations total",
      "Six recommendations total",
      "Seven recommendations total",
      "Eight recommendations total"
      ],
      correct: 2
    },
    {
      id: 40764,
      question: "What does Recommendation 1 state about manual toothbrushes?",
      options: [
      "They are obsolete for plaque control",
      "They are inferior to all power brushes",
      "They are a viable option for plaque control",
      "They should only be used by children"
      ],
      correct: 2
    },
    {
      id: 40765,
      question: "What action must power toothbrushes incorporate to be superior according to Recommendation 2?",
      options: [
      "Side-to-side and circular motion",
      "Oscillating, rotating (with or without pulsating)",
      "Ultrasonic vibration and pulsating",
      "Counter oscillation and circular motion"
      ],
      correct: 1
    },
    {
      id: 40766,
      question: "What design must superior power toothbrushes have according to Recommendation 2?",
      options: [
      "A battery-operated disposable design",
      "A solar-powered rechargeable design",
      "A re-chargeable design",
      "A hybrid manual-power design"
      ],
      correct: 2
    },
    {
      id: 40767,
      question: "What does Recommendation 3 state about power toothbrush tissue damage?",
      options: [
      "Power brushes cause more damage than manual",
      "Power brushes cause equal damage to manual",
      "Power brushes are no more damaging and may be less damaging",
      "Power brushes cause no damage whatsoever"
      ],
      correct: 2
    },
    {
      id: 40768,
      question: "What does Recommendation 4 conclude about tooth-brushing technique efficacy?",
      options: [
      "Bass method is clearly superior",
      "Roll method is clearly superior",
      "No method has been shown clearly superior",
      "Modified Stillman's method is superior"
      ],
      correct: 2
    },
    {
      id: 40769,
      question: "What does Recommendation 5 state about worn toothbrush bristles?",
      options: [
      "Worn bristles are definitely less effective",
      "Evidence is inconclusive about worn bristles",
      "Worn bristles are more effective",
      "Worn bristles should be replaced weekly"
      ],
      correct: 1
    },
    {
      id: 40770,
      question: "What should recommendations include for clients with recession according to Recommendation 6?",
      options: [
      "Information on bacterial etiology only",
      "Information on genetic factors only",
      "Information on multi-factorial etiology",
      "Information on dietary causes only"
      ],
      correct: 2
    },
    {
      id: 40771,
      question: "What has not been shown according to Recommendation 7?",
      options: [
      "Toothbrushes support micro-organisms",
      "Contaminated brushes cause oral/systemic manifestations",
      "Toothbrushes require regular replacement",
      "Toothbrushes accumulate bacteria over time"
      ],
      correct: 1
    },
    {
      id: 40772,
      question: "What organization commissioned this position paper?",
      options: [
      "American Dental Hygienists Association",
      "Canadian Dental Hygienists Association",
      "International Dental Hygienists Federation",
      "World Health Organization"
      ],
      correct: 1
    },
    {
      id: 40773,
      question: "Who is the author of this CDHA position paper?",
      options: [
      "Joanna Asadoorian, AAS(DH), MSc",
      "Jennifer Brothwell, PhD, RDH",
      "Anna Frandsen, DDS, MSc",
      "Patricia Robinson, PhD, RDH"
      ],
      correct: 0
    },
    {
      id: 40774,
      question: "In what journal was this position paper published?",
      options: [
      "Journal of Dental Hygiene",
      "International Journal of Dental Hygiene",
      "Canadian Journal of Dental Hygiene",
      "American Journal of Dental Hygiene"
      ],
      correct: 2
    },
    {
      id: 40775,
      question: "What volume and number was this paper published in?",
      options: [
      "Volume 38, Number 3",
      "Volume 39, Number 4",
      "Volume 40, Number 5",
      "Volume 41, Number 6"
      ],
      correct: 2
    },
    {
      id: 40776,
      question: "When was this position paper published?",
      options: [
      "July-August 2006",
      "September-October 2006",
      "November-December 2006",
      "January-February 2007"
      ],
      correct: 1
    },
    {
      id: 40777,
      question: "What is inadequate plaque control considered to be the primary cause of?",
      options: [
      "Dental caries only",
      "Halitosis only",
      "Gingivitis",
      "Tooth sensitivity only"
      ],
      correct: 2
    },
    {
      id: 40778,
      question: "What is tooth brushing also used as a means of delivering?",
      options: [
      "Nutritional supplements via toothpaste",
      "Chemotherapeutic agents via toothpaste",
      "Antibiotics via toothpaste",
      "Vitamins via toothpaste"
      ],
      correct: 1
    },
    {
      id: 40779,
      question: "Where is plaque control particularly critical in preventing inflammation?",
      options: [
      "In the occlusal area",
      "In the interproximal area",
      "In the gingival area",
      "In the incisal area"
      ],
      correct: 2
    },
    {
      id: 40780,
      question: "What type of studies are considered the gold standard for assessing healthcare intervention effectiveness?",
      options: [
      "Case-control studies",
      "Cross-sectional surveys",
      "Systematic reviews of RCTs",
      "Retrospective cohort studies"
      ],
      correct: 2
    },
    {
      id: 40781,
      question: "What were the primary outcome measures used in the Cochrane meta-analysis?",
      options: [
      "Tooth sensitivity and halitosis levels",
      "Quantified levels of plaque and/or gingivitis",
      "Enamel wear and gingival trauma",
      "Patient satisfaction and compliance rates"
      ],
      correct: 1
    },
    {
      id: 40782,
      question: "Why were plaque values taken before brushing at assessment visits?",
      options: [
      "To reduce patient anxiety levels",
      "To standardize clinical procedures",
      "To be more reflective of actual home use",
      "To minimize examiner bias"
      ],
      correct: 2
    },
    {
      id: 40783,
      question: "What could not be assessed due to the length of clinical trials in the Cochrane review?",
      options: [
      "Patient compliance with brushing",
      "Cost-effectiveness of interventions",
      "Impact on reduction of periodontal destruction",
      "Toothbrush durability over time"
      ],
      correct: 2
    },
    {
      id: 40784,
      question: "What effect has been described for sonic brushes?",
      options: [
      "Direct bristle contact effect",
      "Chemical dissolution effect",
      "\"Micro-streaming\" beyond bristle effect",
      "Thermal activation effect"
      ],
      correct: 2
    },
    {
      id: 40785,
      question: "What does \"micro-streaming\" of sonic brushes generate?",
      options: [
      "Electrical charges on tooth surfaces",
      "Chemical reactions in saliva",
      "Localized hydrodynamic shear forces",
      "Thermal energy in oral tissues"
      ],
      correct: 2
    },
    {
      id: 40786,
      question: "What is believed to impact tooth-brushing efficacy in difficult-to-clean areas?",
      options: [
      "Toothpaste formulation",
      "Brushing duration",
      "Toothbrush design",
      "Water temperature"
      ],
      correct: 2
    },
    {
      id: 40787,
      question: "What traditionally difficult areas does toothbrush design aim to improve?",
      options: [
      "Occlusal, buccal, and anterior surfaces",
      "Lingual, interproximal, and posterior surfaces",
      "Facial, incisal, and cervical surfaces",
      "Palatal, distal, and mesial surfaces"
      ],
      correct: 1
    },
    {
      id: 40788,
      question: "What contributes to plaque removal efficacy according to bristle design studies?",
      options: [
      "Bristle color and texture",
      "Bristle material and weight",
      "Bristle design and taper",
      "Bristle packaging and storage"
      ],
      correct: 2
    },
    {
      id: 40789,
      question: "What have more tapered bristles been shown to improve in vitro?",
      options: [
      "Access to the occlusal region",
      "Access to the sub-gingival region",
      "Access to the interproximal region",
      "Access to the lingual region"
      ],
      correct: 1
    },
    {
      id: 40790,
      question: "What is believed to contribute to the traumatic potential of a toothbrush?",
      options: [
      "Handle length and grip",
      "Brush head size and shape",
      "Filament stiffness",
      "Toothbrush weight and balance"
      ],
      correct: 2
    },
    {
      id: 40791,
      question: "What are the majority of commercially available toothbrushes marketed as today?",
      options: [
      "\"Hard\" bristle toothbrushes",
      "\"Medium\" bristle toothbrushes",
      "\"Soft\" bristle toothbrushes",
      "\"Extra-soft\" bristle toothbrushes"
      ],
      correct: 2
    },
    {
      id: 40792,
      question: "What do contemporary understanding favor for bristle tips?",
      options: [
      "Pointed sharp-edged tips",
      "Flat cut-edge tips",
      "End-rounded filament tips",
      "Irregular jagged tips"
      ],
      correct: 2
    },
    {
      id: 40793,
      question: "What occurs to bristle tips when the brush is being used by the client?",
      options: [
      "Sharp edges become sharper",
      "Rounding of sharp-edged filaments occurs",
      "Bristles become more pointed",
      "Tips remain completely unchanged"
      ],
      correct: 1
    },
    {
      id: 40794,
      question: "What is an important variable in plaque removal efficacy according to recent reports?",
      options: [
      "Toothbrush color and brand",
      "Toothbrush cost and warranty",
      "Tooth-brushing duration",
      "Toothbrush storage location"
      ],
      correct: 2
    },
    {
      id: 40795,
      question: "What has been recommended as ideal for manual brushing duration?",
      options: [
      "One minute for manual brushing",
      "Two minutes for manual brushing",
      "Three minutes for manual brushing",
      "Four minutes for manual brushing"
      ],
      correct: 2
    },
    {
      id: 40796,
      question: "What have recent studies shown exists between recession and tooth-brushing duration?",
      options: [
      "No relationship exists",
      "An inverse relationship exists",
      "A significant relationship exists",
      "A weak correlation exists"
      ],
      correct: 2
    },
    {
      id: 40797,
      question: "What have powered toothbrush designs incorporated to enable accurate time assessment?",
      options: [
      "Digital displays showing elapsed time",
      "Timers typically set for two minutes",
      "Audible alerts every 30 seconds",
      "Vibration patterns indicating time intervals"
      ],
      correct: 1
    },
    {
      id: 40798,
      question: "What did Frandsen conclude about brushing quality versus frequency?",
      options: [
      "Frequency is more important than quality",
      "Both are equally unimportant",
      "Quality is likely more important than frequency",
      "Neither quality nor frequency matters"
      ],
      correct: 2
    },
    {
      id: 40799,
      question: "What did recent research on dogs show about brushing frequency?",
      options: [
      "Brushing twice daily is necessary",
      "Brushing once daily is necessary",
      "Brushing three times daily is necessary",
      "Brushing weekly is sufficient"
      ],
      correct: 1
    },
    {
      id: 40800,
      question: "What has been associated with increased pressure up to a point?",
      options: [
      "Decreased plaque removal efficacy",
      "No change in efficacy",
      "Increased plaque removal efficacy",
      "Increased gingival inflammation"
      ],
      correct: 2
    },
    {
      id: 40801,
      question: "What has manual tooth brushing been associated with compared to power brushing?",
      options: [
      "Lower levels of force",
      "Equal levels of force",
      "Greater levels of force",
      "Variable unpredictable force"
      ],
      correct: 2
    },
    {
      id: 40802,
      question: "What do some powered toothbrushes incorporate to provide feedback on excessive force?",
      options: [
      "Visual color change indicators",
      "Audible feedback mechanisms",
      "Vibration pattern changes",
      "Automatic shut-off features"
      ],
      correct: 1
    },
    {
      id: 40803,
      question: "What were the most commonly recommended manual tooth-brushing methods historically?",
      options: [
      "Stillman's and Charter's methods",
      "Bass and roll methods",
      "Fones and vertical methods",
      "Horizontal and circular methods"
      ],
      correct: 1
    },
    {
      id: 40804,
      question: "What method do over 90% of people generally employ?",
      options: [
      "A modified Bass technique",
      "A professional roll technique",
      "A \"scrub\" method",
      "A Charter's technique"
      ],
      correct: 2
    },
    {
      id: 40805,
      question: "Why has the scrub method been considered detrimental?",
      options: [
      "It removes too little plaque",
      "It encourages recession and abrasion",
      "It damages tooth enamel severely",
      "It causes excessive salivation"
      ],
      correct: 1
    },
    {
      id: 40806,
      question: "What are indicators of a worn-out toothbrush?",
      options: [
      "Bristles that are new and straight",
      "Bristles that are splaying, bending, or curling",
      "Bristles that are clean and white",
      "Bristles that are tightly packed together"
      ],
      correct: 1
    },
    {
      id: 40807,
      question: "How variable is the occurrence of toothbrush wear?",
      options: [
      "It is completely uniform among users",
      "It varies only slightly among users",
      "It is highly variable among users",
      "It follows a predictable pattern"
      ],
      correct: 2
    },
    {
      id: 40808,
      question: "What factors affect toothbrush wear according to research?",
      options: [
      "Toothbrush brand, cost, and color",
      "Storage location, humidity, and temperature",
      "Method, frequency, and force of brushing",
      "User's age, gender, and occupation"
      ],
      correct: 2
    },
    {
      id: 40809,
      question: "What have some studies indicated about newer versus worn toothbrushes?",
      options: [
      "No difference in plaque or gingivitis scores",
      "Worn brushes improve both plaque and gingivitis scores",
      "Newer brushes result in lower plaque and improved gingivitis scores",
      "Worn brushes improve plaque scores only"
      ],
      correct: 2
    },
    {
      id: 40810,
      question: "What has tooth brushing been described as to the gingiva?",
      options: [
      "A beneficial therapeutic procedure",
      "A harmless cosmetic procedure",
      "A traumatic procedure",
      "A preventive non-invasive procedure"
      ],
      correct: 2
    },
    {
      id: 40811,
      question: "What percentage range of gingival abrasion sizes are small according to studies?",
      options: [
      "Small abrasions are uncommon",
      "Medium abrasions are most common",
      "Most gingival abrasions are small",
      "Large abrasions are typical"
      ],
      correct: 2
    },
    {
      id: 40812,
      question: "What was the initial concern about power toothbrushes regarding gingival tissue?",
      options: [
      "They may cause tooth sensitivity",
      "They may promote gingival recession",
      "They may increase bacterial growth",
      "They may damage tooth enamel"
      ],
      correct: 1
    },
    {
      id: 40813,
      question: "What is current understanding about powered tooth brushing safety?",
      options: [
      "Power brushing is less safe than manual",
      "Power brushing is equally unsafe as manual",
      "Power brushing is at least as safe as manual",
      "Power brushing safety is unknown"
      ],
      correct: 2
    },
    {
      id: 40814,
      question: "What have studies recognized about technique, frequency, and duration regarding recession?",
      options: [
      "No relationship to recession exists",
      "Only technique affects recession",
      "Significant relationships with recession exist",
      "Only frequency affects recession"
      ],
      correct: 2
    },
    {
      id: 40815,
      question: "Where were gingival abrasions mostly located according to studies?",
      options: [
      "In the apical gingival aspect",
      "In the mid-gingival aspect",
      "In the marginal gingival aspect",
      "In the interdental gingival aspect"
      ],
      correct: 1
    },
    {
      id: 40816,
      question: "What have studies shown about end-rounding of toothbrush bristles?",
      options: [
      "It has no effect on abrasions",
      "It increases gingival abrasions",
      "It affects the incidence of gingival abrasions",
      "It only affects hard tissue abrasions"
      ],
      correct: 2
    },
    {
      id: 40817,
      question: "Tooth brushing is the most commonly recommended oral hygiene behavior in North America.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40818,
      question: "The toothbrush was reportedly invented in China in approximately 1000 AD.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40819,
      question: "Nylon bristles largely replaced natural bristles in the late 1930s.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40820,
      question: "Powered toothbrushes were first developed in the United States after World War II.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40821,
      question: "The second generation of powered toothbrushes emerged in the 1990s.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40822,
      question: "A total of 238 papers were identified and retrieved in full text for this position paper.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40823,
      question: "The Frandsen review concluded that power toothbrushes were superior to manual toothbrushes.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40824,
      question: "The Brothwell review found oscillating/rotating action power brushes more effective in reducing gingivitis.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40825,
      question: "The 2003 Cochrane review clustered powered toothbrushes into seven modes of action.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40826,
      question: "Rotation oscillation brushes removed more plaque in both short and long term studies.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40827,
      question: "The ionic group was added in the 2005 Cochrane update.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40828,
      question: "Studies of fewer than 28 days were included in the Cochrane review.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40829,
      question: "The Oral-B CrossAction has angled filaments in opposing directions along the horizontal axis.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40830,
      question: "The Oral-B CrossAction Vitalizer has two lateral rows of non-latex rubber nubs.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40831,
      question: "Frandsen recommended bristles with a diameter of approximately 0.2 mm.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40832,
      question: "Foam brushes have been shown to be as effective as conventional manual brushes.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40833,
      question: "Individuals typically brush for about one minute or less.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40834,
      question: "Most people accurately estimate their tooth-brushing duration.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40835,
      question: "Frandsen identified a brushing frequency up to two times a day from previous workshops.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40836,
      question: "The optimal force for tooth brushing has been found to be between 300 to 400 grams.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40837,
      question: "Over 90% of people employ their \"personal tooth-brushing method.\"",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40838,
      question: "The modified Bass method was found especially effective on lingual sites.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40839,
      question: "It has typically been recommended that toothbrushes be replaced every three months.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40840,
      question: "Toothbrush wear occurs uniformly for all individuals.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40841,
      question: "Worn toothbrushes have definitively been shown to be less effective than unworn brushes.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40842,
      question: "Bristle tips display a flattened shape when less than 10% of toothbrush life has elapsed.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40843,
      question: "Gingival recession has a multi-factorial etiology.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40844,
      question: "78% to 100% of middle-aged U.S. population shows some level of recession.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40845,
      question: "A horizontal scrubbing technique was associated with the greatest recession.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40846,
      question: "The term \"non-carious cervical lesion\" has been more recently accepted for hard tissue loss.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40847,
      question: "The toothbrush alone has negligible effects on dentin and enamel.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40848,
      question: "Hard-bristled brushes have the most influence on abrasion.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40849,
      question: "Soft bristles hold toothpaste better than hard filaments.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40850,
      question: "Toothbrushes support a wide variety of micro-organisms.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40851,
      question: "Individual in-mold placement made retention of micro-organisms more difficult.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40852,
      question: "Pre-brushing mouth rinse has been shown to be associated with the least toothbrush contamination.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40853,
      question: "Transparent brush head materials more effectively inhibited retention of micro-organisms.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40854,
      question: "Seven recommendations were developed in this position paper.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40855,
      question: "Manual toothbrushes are a viable option for plaque control according to the recommendations.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40856,
      question: "All power toothbrush designs have been shown to be superior to manual toothbrushes.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40857,
      question: "Power toothbrushes with oscillating, rotating action in a re-chargeable design are superior.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40858,
      question: "Use of a power toothbrush is more damaging than a manual toothbrush to oral tissues.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40859,
      question: "No tooth-brushing method has been shown to be clearly superior.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40860,
      question: "There is conclusive evidence that worn bristles are less effective than unworn bristles.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40861,
      question: "The paper was commissioned by the Canadian Dental Hygienists Association.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40862,
      question: "The position paper was published in September-October 2006.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    }
  ],
  "8. Rinsing Recommendations": [
    {
      id: 40863,
      question: "What organization published this position statement on oral rinsing recommendations?",
      options: [
      "American Dental Hygienists Association",
      "Canadian Dental Hygienists Association",
      "International Dental Hygienists Federation",
      "World Health Organization"
      ],
      correct: 1
    },
    {
      id: 40864,
      question: "When was this oral rinsing recommendations document copyrighted?",
      options: [
      "March 2015",
      "March 2016",
      "March 2017",
      "March 2018"
      ],
      correct: 2
    },
    {
      id: 40865,
      question: "What role does oral biofilm play in disease according to the document?",
      options: [
      "A minor role in oral diseases only",
      "No significant role in any diseases",
      "A significant role in oral and systemic diseases",
      "A role only in systemic diseases"
      ],
      correct: 2
    },
    {
      id: 40866,
      question: "What do clients often find challenging according to the introduction?",
      options: [
      "Selecting appropriate toothpaste brands",
      "Maintaining good oral hygiene through toothbrushing and interdental cleansing",
      "Visiting dental professionals regularly",
      "Understanding nutritional guidelines"
      ],
      correct: 1
    },
    {
      id: 40867,
      question: "What may integrating oral rinsing into daily home care practices help to reduce?",
      options: [
      "Tooth sensitivity and enamel wear",
      "Dental caries and tooth decay",
      "Oral biofilm",
      "Halitosis and dry mouth"
      ],
      correct: 2
    },
    {
      id: 40868,
      question: "How are most oral rinses categorized in Canada?",
      options: [
      "As \"consumer health products\"",
      "As \"medical devices\"",
      "As \"prescription medications\"",
      "As \"dental equipment\""
      ],
      correct: 0
    },
    {
      id: 40869,
      question: "How can consumer health products be identified in Canada?",
      options: [
      "By their manufacturing date on the packaging",
      "By their price point at retail stores",
      "By their product number on the label",
      "By their brand name recognition"
      ],
      correct: 2
    },
    {
      id: 40870,
      question: "What does the product number on the label indicate?",
      options: [
      "The date of manufacture and expiration",
      "Whether approved by Food and Drug Regulations or Natural Health Products Regulations",
      "The country of origin and distribution",
      "The chemical composition and ingredients"
      ],
      correct: 1
    },
    {
      id: 40871,
      question: "Under which regulations are prescription oral rinse products regulated?",
      options: [
      "Natural Health Products Regulations",
      "Consumer Products Regulations",
      "Food and Drug Regulations",
      "Medical Devices Regulations"
      ],
      correct: 2
    },
    {
      id: 40872,
      question: "Which natural compound is mentioned as being of growing interest for home oral care?",
      options: [
      "Aloe vera",
      "Chamomile",
      "Green tea",
      "Lavender"
      ],
      correct: 2
    },
    {
      id: 40873,
      question: "Which of these natural compounds is mentioned as being of growing interest?",
      options: [
      "Peppermint oil",
      "Witch hazel",
      "Tea tree oil",
      "Eucalyptus oil"
      ],
      correct: 1
    },
    {
      id: 40874,
      question: "What other natural extract is mentioned as being of growing interest?",
      options: [
      "Cranberry extract",
      "Blueberry extract",
      "Pomegranate extract",
      "Raspberry extract"
      ],
      correct: 2
    },
    {
      id: 40875,
      question: "What has long been considered the gold standard for therapeutic home oral rinsing?",
      options: [
      "Essential oil compounds",
      "Cetylpyridinium chloride",
      "Chlorhexidine gluconate (CHG)",
      "Hydrogen peroxide solutions"
      ],
      correct: 2
    },
    {
      id: 40876,
      question: "What is an example of prescription chlorhexidine gluconate mentioned in the document?",
      options: [
      "LISTERINE® 0.12%",
      "PERIDEX™ 0.12%",
      "Crest® PRO-HEALTH™",
      "Scope® Advanced"
      ],
      correct: 1
    },
    {
      id: 40877,
      question: "What percentage concentration is the PERIDEX™ chlorhexidine gluconate?",
      options: [
      "0.06%",
      "0.12%",
      "0.24%",
      "0.50%"
      ],
      correct: 1
    },
    {
      id: 40878,
      question: "What is the thymol concentration in the essential oil compound?",
      options: [
      "0.042%",
      "0.063%",
      "0.091%",
      "0.120%"
      ],
      correct: 1
    },
    {
      id: 40879,
      question: "What is the eucalyptol concentration in the essential oil compound?",
      options: [
      "0.042%",
      "0.063%",
      "0.091%",
      "0.120%"
      ],
      correct: 2
    },
    {
      id: 40880,
      question: "What is the menthol concentration in the essential oil compound?",
      options: [
      "0.042%",
      "0.063%",
      "0.091%",
      "0.120%"
      ],
      correct: 0
    },
    {
      id: 40881,
      question: "What brand name is associated with the essential oil compound mentioned?",
      options: [
      "Scope®",
      "LISTERINE®",
      "Crest®",
      "Colgate®"
      ],
      correct: 1
    },
    {
      id: 40882,
      question: "How many essential oils are combined in the effective essential oil compound?",
      options: [
      "Two essential oils",
      "Three essential oils",
      "Four essential oils",
      "Five essential oils"
      ],
      correct: 1
    },
    {
      id: 40883,
      question: "What negative side effect of CHG involves visual appearance?",
      options: [
      "Causing tooth discoloration",
      "Staining the oral tissues",
      "Whitening tooth enamel",
      "Darkening gingival tissues"
      ],
      correct: 1
    },
    {
      id: 40884,
      question: "What negative side effect of CHG involves sensory perception?",
      options: [
      "Increasing tooth sensitivity",
      "Causing burning sensation",
      "Altering taste",
      "Creating numbness"
      ],
      correct: 2
    },
    {
      id: 40885,
      question: "What negative side effect involves hard deposit formation?",
      options: [
      "Reducing enamel mineralization",
      "Increasing calculus accumulation",
      "Decreasing saliva production",
      "Promoting plaque adhesion"
      ],
      correct: 1
    },
    {
      id: 40886,
      question: "For what duration is CHG indicated for use?",
      options: [
      "Long-term use only",
      "Permanent use indefinitely",
      "Short-term use only",
      "Seasonal use periodically"
      ],
      correct: 2
    },
    {
      id: 40887,
      question: "What is an example of cetylpyridinium chloride mentioned in the document?",
      options: [
      "LISTERINE® Total Care",
      "Crest® PRO-HEALTH™",
      "Scope® Outlast",
      "PERIDEX™ Rinse"
      ],
      correct: 1
    },
    {
      id: 40888,
      question: "How does cetylpyridinium chloride compare to placebo?",
      options: [
      "Inferior efficacy to placebo",
      "Equivalent efficacy to placebo",
      "Superior efficacy to placebo",
      "Variable efficacy compared to placebo"
      ],
      correct: 2
    },
    {
      id: 40889,
      question: "How effective is cetylpyridinium chloride compared to CHG or essential oils?",
      options: [
      "More effective than both",
      "Equally effective as both",
      "Not as effective as either",
      "More effective than CHG only"
      ],
      correct: 2
    },
    {
      id: 40890,
      question: "What is lacking for non-commercially available oral rinse formulations?",
      options: [
      "Consumer interest and market demand",
      "Regulatory approval and distribution channels",
      "Consistent, high-quality, long-term studies",
      "Professional endorsement and recommendations"
      ],
      correct: 2
    },
    {
      id: 40891,
      question: "What minimum duration defines \"long-term\" studies according to the document?",
      options: [
      "At least 3 months",
      "At least 6 months",
      "At least 9 months",
      "At least 12 months"
      ],
      correct: 1
    },
    {
      id: 40892,
      question: "What should dental hygienists recommend to their adult clients?",
      options: [
      "Oral rinsing as a replacement for brushing",
      "Mechanical cleansing without any rinsing",
      "A daily combination of oral rinsing and mechanical plaque control",
      "Professional cleanings as the primary method"
      ],
      correct: 2
    },
    {
      id: 40893,
      question: "What should dental hygienists only recommend regarding oral rinsing products?",
      options: [
      "The most expensive products available",
      "Products that have been proven safe and effective",
      "Products from major brand manufacturers only",
      "Products recommended by advertising campaigns"
      ],
      correct: 1
    },
    {
      id: 40894,
      question: "What should be taken into consideration when recommending products?",
      options: [
      "Clients' income and insurance coverage",
      "Product popularity and market share",
      "Clients' needs, beliefs, preferences, and product availability",
      "Dental office inventory and profit margins"
      ],
      correct: 2
    },
    {
      id: 40895,
      question: "Among non-prescription oral rinses, which has been shown to be most effective?",
      options: [
      "Hydrogen peroxide solutions",
      "Cetylpyridinium chloride rinses",
      "Sodium fluoride rinses",
      "Essential oil rinse compound"
      ],
      correct: 3
    },
    {
      id: 40896,
      question: "What should the essential oil rinse be recommended as a complement to?",
      options: [
      "Professional cleanings only",
      "Tooth brushing and interdental mechanical cleansing",
      "Dietary modifications and supplements",
      "Prescription medications and treatments"
      ],
      correct: 1
    },
    {
      id: 40897,
      question: "For which population should dental hygienists recommend therapeutic oral rinses?",
      options: [
      "Only children under 12",
      "Only elderly patients",
      "Adult clients",
      "All age groups equally"
      ],
      correct: 2
    },
    {
      id: 40898,
      question: "What is the primary purpose of recommending therapeutic oral rinses?",
      options: [
      "To whiten teeth and improve aesthetics",
      "To reduce plaque and gingival inflammation",
      "To prevent tooth decay exclusively",
      "To freshen breath and improve taste"
      ],
      correct: 1
    },
    {
      id: 40899,
      question: "According to the position statement, what type of evidence is lacking for non-commercial formulations?",
      options: [
      "Any research studies whatsoever",
      "Short-term preliminary studies",
      "Evidence from rigorous, long-term studies",
      "Anecdotal reports from practitioners"
      ],
      correct: 2
    },
    {
      id: 40900,
      question: "What should dental hygienists continue to recommend?",
      options: [
      "Experimental and unproven products",
      "Only natural and organic formulations",
      "Commercially available products proven effective and safe",
      "The least expensive products available"
      ],
      correct: 2
    },
    {
      id: 40901,
      question: "Who authored the reference about therapeutic oral rinsing with non-commercially available products?",
      options: [
      "Consumer Health Products Canada",
      "Van Leeuwen MP",
      "Asadoorian J",
      "Lorenz K"
      ],
      correct: 2
    },
    {
      id: 40902,
      question: "In what year was the reference about non-commercially available products published?",
      options: [
      "2009",
      "2011",
      "2016",
      "2017"
      ],
      correct: 3
    },
    {
      id: 40903,
      question: "What journal published the 2017 reference by Asadoorian about non-commercial products?",
      options: [
      "J Periodontol",
      "Can J Dent Hyg",
      "J Clin Periodontol",
      "Int Dent J"
      ],
      correct: 1
    },
    {
      id: 40904,
      question: "What volume and issue was the 2017 Asadoorian reference published in?",
      options: [
      "50(3)",
      "51(1)",
      "60(3)",
      "82(2)"
      ],
      correct: 1
    },
    {
      id: 40905,
      question: "Who authored the reference about selecting study designs for mouthrinses?",
      options: [
      "Asadoorian J",
      "Van Leeuwen MP",
      "Lorenz K",
      "Sharma NC"
      ],
      correct: 2
    },
    {
      id: 40906,
      question: "In what year was the Lorenz reference about study designs published?",
      options: [
      "2009",
      "2010",
      "2011",
      "2012"
      ],
      correct: 0
    },
    {
      id: 40907,
      question: "What journal published the Lorenz reference?",
      options: [
      "J Clin Dent",
      "J Physio Pharm",
      "Int Dent J",
      "Can J Dent Hyg"
      ],
      correct: 1
    },
    {
      id: 40908,
      question: "Who authored the systematic review comparing essential oils to chlorhexidine?",
      options: [
      "Van Strydonck DA",
      "Sharma NC",
      "Van Leeuwen MP",
      "Ayad F"
      ],
      correct: 2
    },
    {
      id: 40909,
      question: "In what year was the Van Leeuwen systematic review published?",
      options: [
      "2009",
      "2010",
      "2011",
      "2012"
      ],
      correct: 2
    },
    {
      id: 40910,
      question: "What journal published the Van Leeuwen systematic review?",
      options: [
      "J Periodontol",
      "J Clin Periodontol",
      "Int Dent J",
      "Can J Dent Hyg"
      ],
      correct: 0
    },
    {
      id: 40911,
      question: "Who authored the systematic review about chlorhexidine effects on staining?",
      options: [
      "Van Leeuwen MP",
      "Van Strydonck DA",
      "Lorenz K",
      "Ayad F"
      ],
      correct: 1
    },
    {
      id: 40912,
      question: "In what year was the Van Strydonck systematic review published?",
      options: [
      "2009",
      "2010",
      "2011",
      "2012"
      ],
      correct: 3
    },
    {
      id: 40913,
      question: "What journal published the Van Strydonck systematic review?",
      options: [
      "J Periodontol",
      "J Clin Periodontol",
      "J Clin Dent",
      "Int Dent J"
      ],
      correct: 1
    },
    {
      id: 40914,
      question: "Who was the first author on the comparative investigation of CPC-containing mouthwash?",
      options: [
      "Sharma NC",
      "Van Leeuwen MP",
      "Ayad F",
      "Lorenz K"
      ],
      correct: 2
    },
    {
      id: 40915,
      question: "In what year was the Ayad comparative investigation published?",
      options: [
      "2009",
      "2010",
      "2011",
      "2012"
      ],
      correct: 2
    },
    {
      id: 40916,
      question: "What journal published the Ayad comparative investigation?",
      options: [
      "J Periodontol",
      "J Clin Periodontol",
      "J Clin Dent",
      "Int Dent J"
      ],
      correct: 2
    },
    {
      id: 40917,
      question: "Where was the Ayad clinical study conducted?",
      options: [
      "Toronto, Canada",
      "Miami, United States",
      "San Jose, Costa Rica",
      "Mexico City, Mexico"
      ],
      correct: 2
    },
    {
      id: 40918,
      question: "Who was the first author on the superiority study of essential oil mouthrinse?",
      options: [
      "Ayad F",
      "Van Leeuwen MP",
      "Sharma NC",
      "Asadoorian J"
      ],
      correct: 2
    },
    {
      id: 40919,
      question: "In what year was the Sharma superiority study published?",
      options: [
      "2009",
      "2010",
      "2011",
      "2012"
      ],
      correct: 1
    },
    {
      id: 40920,
      question: "What journal published the Sharma superiority study?",
      options: [
      "J Periodontol",
      "J Clin Periodontol",
      "Int Dent J",
      "Can J Dent Hyg"
      ],
      correct: 2
    },
    {
      id: 40921,
      question: "What concentration of cetylpyridinium chloride was compared in the Sharma study?",
      options: [
      "0.05%",
      "0.12%",
      "0.25%",
      "0.50%"
      ],
      correct: 0
    },
    {
      id: 40922,
      question: "Who authored the 2016 reference about commercially available products?",
      options: [
      "Van Leeuwen MP",
      "Sharma NC",
      "Asadoorian J",
      "Lorenz K"
      ],
      correct: 2
    },
    {
      id: 40923,
      question: "In what year was the Asadoorian reference about commercially available products published?",
      options: [
      "2010",
      "2012",
      "2015",
      "2016"
      ],
      correct: 3
    },
    {
      id: 40924,
      question: "What volume and issue was the 2016 Asadoorian reference published in?",
      options: [
      "50(3)",
      "51(1)",
      "60(3)",
      "82(2)"
      ],
      correct: 0
    },
    {
      id: 40925,
      question: "What website is provided for Consumer Health Products Canada?",
      options: [
      "www.healthcanada.ca",
      "www.chpcanada.ca",
      "www.cdha.ca",
      "www.consumerproducts.ca"
      ],
      correct: 1
    },
    {
      id: 40926,
      question: "In what year was Consumer Health Products Canada information dated?",
      options: [
      "2009",
      "2012",
      "2015",
      "2017"
      ],
      correct: 1
    },
    {
      id: 40927,
      question: "Dental hygienists are encouraged to recommend therapeutic oral rinses to complement home care routines.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40928,
      question: "There is strong evidence that non-commercially available oral rinses are as effective as commercial rinses.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40929,
      question: "Long-term studies are defined as those lasting 6 months or longer.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40930,
      question: "Oral biofilm plays a significant role in many oral and systemic diseases.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40931,
      question: "Most oral rinses in Canada are categorized as \"consumer health products.\"",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40932,
      question: "Products requiring a prescription are regulated under the Natural Health Products Regulations.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40933,
      question: "Green tea is mentioned as a natural compound of growing interest for oral care.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40934,
      question: "Chlorhexidine gluconate (CHG) has long been considered the gold standard for therapeutic oral rinsing.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40935,
      question: "PERIDEX™ contains 0.24% chlorhexidine gluconate.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40936,
      question: "The essential oil compound contains three essential oils.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40937,
      question: "The essential oil compound is marketed under the brand name LISTERINE®.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40938,
      question: "CHG has negative side effects including staining oral tissues.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40939,
      question: "CHG is indicated for long-term use.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40940,
      question: "Cetylpyridinium chloride demonstrates superior efficacy to placebo.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40941,
      question: "Cetylpyridinium chloride is as effective as CHG at reducing biofilm.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40942,
      question: "Consistent, high-quality, long-term studies are lacking for non-commercial formulations.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40943,
      question: "Dental hygienists should recommend oral rinsing products proven safe and effective.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40944,
      question: "Client needs, beliefs, and preferences should be considered when recommending products.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40945,
      question: "The essential oil rinse compound has been shown to be the most effective non-prescription rinse.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    },
    {
      id: 40946,
      question: "The essential oil rinse should replace tooth brushing and interdental cleansing.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40947,
      question: "The position statement applies to all age groups equally.",
      options: [
      "True",
      "False"
      ],
      correct: 1
    },
    {
      id: 40948,
      question: "The document was copyrighted in March 2017.",
      options: [
      "True",
      "False"
      ],
      correct: 0
    }
  ]
};
